import { NgForOf, NgIf, AsyncPipe, CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, signal, OnInit, AfterViewInit, ElementRef, ViewChild, HostListener, inject, TemplateRef, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { RouterLink, Router, ActivatedRoute } from '@angular/router';
import { tuiAsPortal, TuiPortals } from '@taiga-ui/cdk';
import { CountryRegionService, CountryData } from '../../../shared/services/country-region.service';
import { CountryCoordinatesService, CountryCoordinates } from '../../../shared/services/country-coordinates.service';
import { TimezoneConverterService } from '../../../shared/services/timezone-converter.service';
import { TuiResponsiveDialogService } from '@taiga-ui/addon-mobile';
import { TuiAppearance, TuiButton, TuiDataList, TuiDropdown, TuiDropdownService, TuiIcon, TuiTextfield, TuiTitle, TuiError, TuiNotification, TuiLink, TuiLoader } from '@taiga-ui/core';
import { TuiHeader, TuiNavigation, TuiCardLarge, TuiForm, TuiCell, TuiCard } from '@taiga-ui/layout';
import { TuiInputModule, TuiSelectModule } from '@taiga-ui/legacy';
import { TuiAvatar, TuiChevron, TuiStepper, tuiValidationErrorsProvider, TuiTextarea, TuiFiles, TuiSelect, TuiDataListWrapper, TuiInputTime, TuiCarousel, TuiPagination, TuiFade, TuiProgress, TuiSwitch, TuiFieldErrorPipe, TuiPush } from '@taiga-ui/kit';
import { TuiTime } from '@taiga-ui/cdk';
import { TUI_CONFIRM, type TuiConfirmData } from '@taiga-ui/kit';
import { switchMap, map, startWith, of, defer, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiService } from '../../../shared/services/api.service';
import { ParkingDataService } from '../../../shared/services/parking-data.service';
import { NavigationService } from '../../../shared/services/navigation.service';
import { NotificationService } from '../../../shared/services/notification.service';
import { GlobalNotificationComponent } from '../../../shared/components/global-notification/global-notification';
import { tuiClamp, TuiSwipe, type TuiSwipeEvent } from '@taiga-ui/cdk';
import { TuiPreview, TuiPreviewDialogService } from '@taiga-ui/kit';
import { type PolymorpheusContent, PolymorpheusOutlet, PolymorpheusTemplate } from '@taiga-ui/polymorpheus';
import { TuiDialogContext } from '@taiga-ui/core';
import { CustomListComponent } from '../../parking-add-capacity/custom-list.component';
import { DrawerInviteTeamMember } from '../../../shared/components/drawers/drawer-invite-team-member/drawer-invite-team-member';
import { InputHeading } from '../../../shared/components/input-heading/input-heading';
import { AmenityIconService } from '../../../shared/services/amenity-icon.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { RoleService } from '../../../shared/services/role.service';

declare var google: any;

const ICON =
    "data:image/svg+xml,%0A%3Csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='32' height='32' rx='8' fill='url(%23paint0_linear_2036_35276)'/%3E%3Cmask id='mask0_2036_35276' style='mask-type:alpha' maskUnits='userSpaceOnUse' x='6' y='5' width='20' height='21'%3E%3Cpath d='M18.2399 9.36607C21.1347 10.1198 24.1992 9.8808 26 7.4922C26 7.4922 21.5645 5 16.4267 5C11.2888 5 5.36726 8.69838 6.05472 16.6053C6.38707 20.4279 6.65839 23.7948 6.65839 23.7948C8.53323 22.1406 9.03427 19.4433 8.97983 16.9435C8.93228 14.7598 9.55448 12.1668 12.1847 10.4112C14.376 8.94865 16.4651 8.90397 18.2399 9.36607Z' fill='url(%23paint1_linear_2036_35276)'/%3E%3Cpath d='M11.3171 20.2647C9.8683 17.1579 10.7756 11.0789 16.4267 11.0789C20.4829 11.0789 23.1891 12.8651 22.9447 18.9072C22.9177 19.575 22.9904 20.2455 23.2203 20.873C23.7584 22.3414 24.7159 24.8946 24.7159 24.8946C23.6673 24.5452 22.8325 23.7408 22.4445 22.7058L21.4002 19.921L21.2662 19.3848C21.0202 18.4008 20.136 17.7104 19.1217 17.7104H17.5319L17.6659 18.2466C17.9119 19.2306 18.7961 19.921 19.8104 19.921L22.0258 26H10.4754C10.7774 24.7006 12.0788 23.2368 11.3171 20.2647Z' fill='url(%23paint2_linear_2036_35276)'/%3E%3C/mask%3E%3Cg mask='url(%23mask0_2036_35276)'%3E%3Crect x='4' y='4' width='24' height='24' fill='white'/%3E%3C/g%3E%3Cdefs%3E%3ClinearGradient id='paint0_linear_2036_35276' x1='0' y1='0' x2='32' y2='32' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23A681D4'/%3E%3Cstop offset='1' stop-color='%237D31D4'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint1_linear_2036_35276' x1='6.0545' y1='24.3421' x2='28.8119' y2='3.82775' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0.0001' stop-opacity='0.996458'/%3E%3Cstop offset='0.317708'/%3E%3Cstop offset='1' stop-opacity='0.32'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint2_linear_2036_35276' x1='6.0545' y1='24.3421' x2='28.8119' y2='3.82775' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0.0001' stop-opacity='0.996458'/%3E%3Cstop offset='0.317708'/%3E%3Cstop offset='1' stop-opacity='0.32'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E%0A";

@Component({
    standalone: true,
    exportAs: "Parkings",
    imports: [
        CommonModule,
        AsyncPipe,
        FormsModule,
        ReactiveFormsModule,
        NgForOf,
        RouterLink,

        TuiAppearance,
        TuiAvatar,
        TuiButton,
        TuiCardLarge,
        TuiDataList,
        TuiDropdown,
        TuiFade,
        TuiForm,
        TuiHeader,
        TuiIcon,
        TuiNavigation,
        TuiProgress,
        TuiPush,
        TuiCarousel,
        TuiPagination,
        TuiTextfield,
        TuiTitle,
        InputHeading,
        TuiError,
        TuiFieldErrorPipe,
        TuiInputTime,
        TuiStepper,
        TuiTextarea,
        TuiFiles,
        TuiInputModule,
        TuiSelectModule,
        TuiSelect,
        TuiChevron,
        TuiDataListWrapper,
        TuiNotification,
        TuiCell,
        TuiCard,
        CustomListComponent,
        DrawerInviteTeamMember,
        TuiSwitch,
        TuiLink,
        TuiLoader,
        PolymorpheusOutlet, PolymorpheusTemplate, TuiButton, TuiPreview, TuiSwipe,
        GlobalNotificationComponent
    ],
    styleUrl: './parkings.scss',
    templateUrl: './parkings.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [TuiDropdownService, tuiAsPortal(TuiDropdownService),
        tuiValidationErrorsProvider({
            required: 'This field is required',
            minlength: 'Minimum 6 characters required',
        }),
    ],
})
export default class Parkings extends TuiPortals implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('mapContainer', { static: false }) mapContainer!: ElementRef;
    @ViewChild('searchInput', { static: false }) searchInput!: ElementRef;
    @ViewChild('teamDrawerComponent') teamDrawerComponent?: DrawerInviteTeamMember;

    protected open = false;
    protected switch = false;
    protected readonly routes: any = {};
    protected selectedCardIndex = signal<number>(-1);
    protected parkingTypeSelected = signal<boolean>(false);

    protected isDescriptionExpanded = false;
    protected showReadMore = false;
    @ViewChild('descText', { static: false }) private descText?: ElementRef<HTMLSpanElement>;

    protected currentStep = signal(1);
    protected totalSteps = 8;
    protected formData: any = {};

    protected map: any = null;
    protected marker: any = null;
    protected autocomplete: any = null;
    protected isMapLoaded = signal(false);
    protected isReverseGeocoding = signal(false);
    protected selectedLocation = signal<{ lat: number, lng: number } | null>(null);
    protected pendingLocationData = signal<{
        addressValue?: string; cityValue?: string; stateValue?: string;
        postalCodeValue?: string; countryValue?: string;
        latitudeValue?: string; longitudeValue?: string;
    } | null>(null);
    protected searchQuery = signal('');
    protected isInitialMapLoad = true;
    protected isSearching = signal(false);
    protected _savingImagesInProgress = false;
    protected searchResults = signal<any[]>([]);
    protected showSearchResults = signal(false);
    protected recentSearches = signal<any[]>([]);
    protected popularLocations = signal<any[]>([]);
    protected nearbyParkings = signal<any[]>([]);
    protected showNearbyParkings = signal(false);
    protected isMarkerVisible = signal(false);
    protected isSubmitting = signal(false);
    protected isActivating = signal(false);
    protected hasManualLocationSelection = false;
    private keepSelectedSearchLabel = false;
    private selectedPlaceDescription = '';
    private stepFromUrl: number | null = null;

    protected selectedCountry = signal('IN');
    protected selectedCountryData = signal<CountryData | null>(null);
    protected isRegionLoading = signal(true);
    protected regionError = signal<string | null>(null);
    protected organizationCountry = signal<string>('IN');
    protected organizationRegionId = signal<string | null>(null);
    protected organizationTimezone = signal<string | null>(null);
    protected organizationCurrency = signal<string | null>(null);
    protected isOrganizationLoading = signal(true);
    protected regionMap: { [key: string]: { countryName: string, regionName: string, subregion: string } } = {};
    protected timezonesForSelectedCountry: string[] = [];
    protected hasMultipleTimezones = false;

    // ============ MANAGER ASSIGNMENT TRACKING FLAGS - FIXED ============
    private isManagerAssignmentInProgress = false;
    private managerAlreadyAssigned = false;
    private managerAssignmentChecked = false;
    private assignedManagerId: string | null = null;
    private managerAssignmentPromise: Promise<void> | null = null;
    private managerAssignmentCompleted = false;
    private managerAssignmentInFlight = false;
    private managerAssignmentResolve: (() => void) | null = null;
    private managerAssignmentReject: ((error: any) => void) | null = null;
    private parkingActivationChecked = false;
    private parkingIsActive = false;
    private lastManagerAssignmentCallTime = 0;
    private isUpdatingManager = false;

    private getExistingParkingId(): string | null {
        if (this.parkingId) {
            return this.parkingId;
        }

        const apiParkingId = this.apiService.getCurrentParkingId();
        if (apiParkingId) {
            return apiParkingId;
        }

        const storedId = sessionStorage.getItem('parking_id') ||
            localStorage.getItem('parking_id') ||
            sessionStorage.getItem('parkingId') ||
            localStorage.getItem('parkingId') ||
            this.parkingIdForSaveExit();

        if (storedId) {
            return storedId;
        }

        return null;
    }

    private selectedAmenityIconsCache: string[] = [];
    private selectedAmenityIconsCacheTimestamp = 0;

    protected selectedAmenityIcons = signal<string[]>([]);
    protected amenitySvgs = signal<SafeHtml[]>([]);

    protected isEditMode = false;
    protected parkingId: string | null = null;
    protected savedMapData: any = null;

    protected defaultLat = 20.5937;
    protected defaultLng = 78.9629;

    protected getCountryCoordinates(countryCode: string): CountryCoordinates {
        return this.countryCoordinatesService.getCoordinates(countryCode);
    }

    protected readonly steps = ['Parking Type', 'Location & Address', 'Complete Details', 'Amenities', 'Working hours', 'Parking Images', 'Assign Manager/Vendor', 'Review and Submit'];

    protected parkingFeatures: any[] = [
        { title: 'WiFi', icon: 'assets/images/icons/Wifi.svg' },
        { title: 'Air Conditioner', icon: 'assets/images/icons/Air Condition.svg' },
        { title: 'Nearby Tourist Place', icon: 'assets/images/icons/Nearby Tourist Place.svg' },
        { title: 'EV Charging', icon: 'assets/images/icons/EV Charging.svg' },
        { title: 'Smoke Alarm', icon: 'assets/images/icons/Smoke Alarm.svg' },
        { title: 'Fire Safety Measures', icon: 'assets/images/icons/Fire Safety Measures.svg' },
        { title: 'First Aid Kit', icon: 'assets/images/icons/First Aid Kit.svg' },
        { title: 'Restroom Access', icon: 'assets/images/icons/Restroom Access.svg' },
        { title: 'Wheelchair Access', icon: 'assets/images/icons/Wheelchair Accessible.svg' },
        { title: 'CCTV Surveillance', icon: 'assets/images/icons/CCTV Surveillance.svg' },
        { title: '24/7 Access', icon: 'assets/images/icons/24 hrs.svg' },
        { title: 'Lighting & Safety', icon: 'assets/images/icons/Lighting & Safety.svg' },
        { title: 'Security Personnel', icon: 'assets/images/icons/Security Personnel.svg' },
        { title: 'Valet Service', icon: 'assets/images/icons/Valet Parking.svg' },
        { title: 'Phone Charging Station', icon: 'assets/images/icons/Device Charging.svg' }
    ];
    protected selectedFeatures = signal<number[]>([]);

    private get selectedParkingTypes(): Set<number> {
        return new Set(this.selectedFeatures());
    }

    protected teamMembers: any[] = [];
    protected selectedTeamMember: any = null;
    protected selectedTeamValue: any = null;
    protected selectedTeamDisplayValue: string = '';
    protected teamItems: any[] = [];
    protected teamSelectOpen: boolean = false;
    @ViewChild('teamList') teamList?: CustomListComponent<any>;

    protected debugLog(message: string, extra?: any): void {
        try {
            console.log(`[AssignManager] ${message}`, extra ?? '');
        } catch { }
    }

    protected readonly fileControl = new FormControl<File[]>([], [this.maxFilesLength(5)]);
    protected readonly accepted$ = defer(() =>
        this.fileControl.valueChanges.pipe(
            startWith(this.fileControl.value),
            map(files => files?.filter(file => file instanceof File) || [])
        )
    );
    protected rejected: readonly File[] = [];
    private currentUploadFiles: File[] = [];
    protected existingImages: string[] = [];
    protected uploadErrorMessage = '';
    private fileUrlCache = new Map<File, string>();

    private static readonly WIZARD_STEP_STORAGE_KEY = 'parking_wizard_steps';
    private readonly stepperIndexToStep: number[] = [1, 2, 3, 4, 5, 6, 7, 8];

    private readonly stepToSlug: Record<number, string> = {
        1: 'parking-type',
        2: 'location-address',
        3: 'complete-details',
        4: 'amenities',
        5: 'working-hours',
        6: 'parking-images',
        7: 'assign-manager',
        8: 'review',
    };
    private readonly slugToStep: Record<string, number> = {
        'parking-type': 1,
        'location-address': 2,
        'complete-details': 3,
        'amenities': 4,
        'working-hours': 5,
        'parking-images': 6,
        'assign-manager': 7,
        'review': 8,
    };

    private getStepToStepperIndexMap(): Record<number, number> {
        const map: Record<number, number> = {};
        this.stepperIndexToStep.forEach((step, index) => { map[step] = index; });
        return map;
    }

    getActiveStepperIndex(): number {
        const map = this.getStepToStepperIndexMap();
        return map[this.currentStep()] ?? 0;
    }

    private updateMarkerColor(): void {
        try {
            const step = this.currentStep();
            const total = this.totalSteps || 9;
            const ratioRaw = (step - 1) / Math.max(1, total - 1);
            const ratio = Math.min(1, Math.max(0, ratioRaw));
            const red = Math.round(200 + 55 * ratio);
            const green = Math.round(200 * (1 - ratio));
            const blue = Math.round(200 * (1 - ratio));
            const color = `rgb(${red}, ${green}, ${blue})`;
            document.documentElement.style.setProperty('--marker-color', color);
        } catch { }
    }

    onStepperClick(index: number): void {
        const targetStep = this.stepperIndexToStep[index] ?? 1;

        const canNavigateForward = this.getStepProgress(targetStep) === 100;
        const canNavigateBackward = targetStep <= this.currentStep();

        if (!canNavigateForward && !canNavigateBackward) {
            return;
        }

        if (targetStep >= 2 && !this.parkingTypeSelected() && !localStorage.getItem('parking_type_selection')) {
            return;
        }
        this.saveCurrentStepData().catch(() => { });
        const previous = this.currentStep();
        this.currentStep.set(targetStep);
        this.persistWizardStep(targetStep);
        this.updateUrlWithCurrentStep();
        this.updateMarkerColor();
        this.loadStepData(targetStep);

        if (targetStep === 2 && previous !== 2) {
            setTimeout(() => this.loadMap(), 300);
        }
        if (targetStep === 3 && previous !== 3) {
            setTimeout(() => this.ensureFormIsPopulated(), 100);
        }
        if (targetStep === 5) {
            setTimeout(() => this.debugStep7Form(), 50);
        }
        if (targetStep === 8 && previous !== 8) {
            setTimeout(() => this.hydrateReviewData(), 100);
        }
    }

    protected isStepperItemCompleted(index: number): boolean {
        const stepNumber = this.stepperIndexToStep[index] ?? 1;
        const progress = this.getStepProgress(stepNumber);
        const isCompleted = progress >= 100;
        return isCompleted;
    }

    private updateUrlWithCurrentStep(replaceUrl: boolean = false): void {
        const step = this.currentStep();
        const slug = this.stepToSlug[step] ?? `step${step}`;
        const currentParams = this.route.snapshot.queryParams;
        const queryParams: Record<string, string | null> = {
            fresh: null
        };

        if (currentParams['parkingId'] && currentParams['mode'] === 'edit') {
            queryParams['parkingId'] = currentParams['parkingId'];
            queryParams['mode'] = 'edit';
        }

        this.router.navigate(['/parkings/create', slug], {
            replaceUrl,
            queryParams
        });
    }

    private persistWizardStep(step?: number, parkingId?: string | null): void {
        const id = parkingId || this.getExistingParkingId();
        const stepToSave = step ?? this.currentStep();
        if (!id || stepToSave < 1 || stepToSave > this.totalSteps) {
            return;
        }

        try {
            const raw = localStorage.getItem(Parkings.WIZARD_STEP_STORAGE_KEY);
            const map = raw ? JSON.parse(raw) : {};
            map[id] = stepToSave;
            localStorage.setItem(Parkings.WIZARD_STEP_STORAGE_KEY, JSON.stringify(map));
            sessionStorage.setItem('lastActiveStep', String(stepToSave));
            sessionStorage.setItem(`parking_wizard_step_${id}`, String(stepToSave));
        } catch { }
    }

    private getPersistedWizardStep(parkingId?: string | null): number | null {
        const id = parkingId || this.getExistingParkingId();
        if (!id) {
            return null;
        }

        try {
            const raw = localStorage.getItem(Parkings.WIZARD_STEP_STORAGE_KEY);
            const map = raw ? JSON.parse(raw) : {};
            const stored = Number(map[id] || sessionStorage.getItem(`parking_wizard_step_${id}`));
            if (stored >= 1 && stored <= this.totalSteps) {
                return stored;
            }
        } catch { }

        return null;
    }

    private clearPersistedWizardStep(parkingId?: string | null): void {
        const id = parkingId || this.getExistingParkingId();
        if (!id) {
            return;
        }

        try {
            const raw = localStorage.getItem(Parkings.WIZARD_STEP_STORAGE_KEY);
            const map = raw ? JSON.parse(raw) : {};
            delete map[id];
            localStorage.setItem(Parkings.WIZARD_STEP_STORAGE_KEY, JSON.stringify(map));
            sessionStorage.removeItem(`parking_wizard_step_${id}`);
            sessionStorage.removeItem('lastActiveStep');
        } catch { }
    }

    protected canSaveAndExit(): boolean {
        if (this.getExistingParkingId() || this.parkingId || this.parkingIdForSaveExit()) {
            return true;
        }

        const parkingName = (this.locationForm.get('parkingName')?.value || '').toString().trim();
        return !!parkingName || this.parkingTypeSelected() || this.selectedCardIndex() >= 0;
    }

    protected operations: Record<string, Array<{
        name?: string;
        parkingType?: string;
        location?: string;
        amenities?: string;
        operations?: string;
        vehicleTypes?: string;
        facilities?: string;
        manager?: string;
        icon?: string;
    }>> = {
            'Tell us about your parking': [
                {
                    icon: 'assets/images/icons/Parking Lots.svg',
                    name: 'Godowalia MultiLevel Parking',
                    parkingType: 'Standalone Parking lot',
                    location: 'Bangali Tola, Varanasi, Uttar Pradesh 221001',
                },
            ],
            'Add details people look for': [
                {
                    icon: 'assets/images/icons/operating hours.svg',
                    name: 'Godowalia MultiLevel Parking',
                    amenities: 'Wifi, Nearby Tourist Spot',
                    operations: 'All Day, 24 Hours',
                }],
            'Set up rules and go live': [
                {
                    icon: 'assets/images/icons/h.svg',
                    vehicleTypes: 'Car (200) Bike (15)',
                    facilities: 'Helmet Locker',
                    manager: 'Loading manager...',
                }],
        };

    protected collapsedStates: Record<string, any> = {
        'Tell us about your parking': signal(false),
        'Add details people look for': signal(false),
        'Set up rules and go live': signal(false)
    };

    protected isSectionCollapsed(key: string): boolean {
        return this.collapsedStates[key] ? this.collapsedStates[key]() : false;
    }

    protected toggleSection(key: string): void {
        if (this.collapsedStates[key]) {
            this.collapsedStates[key].set(!this.collapsedStates[key]());
        }
    }

    protected orderBy(): number {
        return 0;
    }

    protected index = 0;
    private readonly blankMockImage =
        'data:image/svg+xml,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="800" height="450" viewBox="0 0 800 450"><rect width="800" height="450" fill="#EEF0F3"/></svg>');
    protected carouselItems = [
        {
            src: this.blankMockImage,
            title: 'Welcome to Your Parking',
            description: 'All day • 24 Hours'
        },
        {
            src: this.blankMockImage,
            title: 'Car Parking Available',
            description: 'Secure car parking'
        }
    ];

    protected onCarouselIndexChange(nextIndex: number): void {
        const length = this.carouselItems.length;
        if (!length) {
            this.index = 0;
            return;
        }
        const normalized = ((nextIndex % length) + length) % length;
        this.index = normalized;
    }

    protected navigateCarousel(delta: number, event: Event): void {
        event.stopPropagation();
        event.preventDefault();
        const length = this.carouselItems.length;
        if (!length) return;
        this.onCarouselIndexChange(this.index + delta);
    }

    protected parkingData: any = {};
    private readonly cdr = inject(ChangeDetectorRef);
    private sanitizer = inject(DomSanitizer);
    private amenityIconService = inject(AmenityIconService);
    private amenitySvgCache = new Map<string, SafeHtml>();

    private async updateSelectedAmenityIcons(): Promise<void> {
        const titlesFromSelection = (this.selectedFeatures() || [])
            .map(i => this.parkingFeatures[i]?.title)
            .filter(Boolean) as string[];

        let titles = titlesFromSelection;
        if (!titles.length) {
            try {
                const saved = localStorage.getItem('parking_amenities_data');
                if (saved) {
                    const parsed = JSON.parse(saved);
                    const savedSelected: number[] = parsed?.selectedFeatures || [];
                    titles = savedSelected.map((i: number) => this.parkingFeatures[i]?.title).filter(Boolean);
                }
            } catch { }
        }

        if (!titles.length && this.parkingData?.amenities) {
            titles = Array.isArray(this.parkingData.amenities)
                ? this.parkingData.amenities
                : String(this.parkingData.amenities).split(',').map((s: string) => s.trim()).filter(Boolean);
        }

        const result = Array.from(new Set(titles)).slice(0, 8);

        this.selectedAmenityIcons.set(result);

        try {
            const svgs = await Promise.all(result.map(icon => this.asyncSvg(icon)));
            this.amenitySvgs.set(svgs);
        } catch (error) {
            this.amenitySvgs.set([]);
        }
    }

    public getSelectedAmenityIcons(): string[] {
        return this.selectedAmenityIcons();
    }

    protected asyncSvg(iconTitleOrUrl: string): Promise<SafeHtml> {
        if (this.amenityIconService) {
            const inline = this.amenityIconService.getSvgByTitle(iconTitleOrUrl);
            if (inline) return Promise.resolve(inline);
        }
        if (this.amenitySvgCache.has(iconTitleOrUrl)) {
            return Promise.resolve(this.amenitySvgCache.get(iconTitleOrUrl)!);
        }
        return fetch(iconTitleOrUrl)
            .then(r => r.text())
            .then(text => {
                const cleaned = text
                    .replace(/<rect[^>]*fill=("|')(#fff|#ffffff|white)("|')[^>]*>/gi, '')
                    .replace(/<path[^>]*fill=("|')(#fff|#ffffff|white)("|')[^>]*>/gi, (m) => m.replace(/fill=("|')(#fff|#ffffff|white)("|')/i, 'fill="none"'))
                    .replace(/fill:(#fff|#ffffff|white)/gi, 'fill:none');
                const safe = this.sanitizer ? this.sanitizer.bypassSecurityTrustHtml(cleaned) : (cleaned as any);
                this.amenitySvgCache.set(iconTitleOrUrl, safe);
                return safe;
            })
            .catch(() => Promise.resolve(this.sanitizer ? this.sanitizer.bypassSecurityTrustHtml('') : ('' as any)));
    }

    protected goBack(): void {
        if (this.currentStep() > 1) {
            this.previousStep();
        } else {
            this.router.navigate(['/parking-lots']);
        }
    }

    protected isFeatureActive(index: number): boolean {
        return this.selectedFeatures().includes(index);
    }

    protected selectFeature(index: number): void {
        const featureIndex = this.selectedFeatures().indexOf(index);
        if (featureIndex > -1) {
            this.selectedFeatures.set(this.selectedFeatures().filter((_, i) => i !== featureIndex));
        } else {
            this.selectedFeatures.set([...this.selectedFeatures(), index]);
        }
        this.saveAmenitiesData();
    }

    protected toggleDay(day: string): void {
        const currentValue = this.locationForm.get(day)?.value;
        this.locationForm.get(day)?.setValue(!currentValue);
        this.saveOperatingHoursData();
    }

    protected onReject(files: readonly File[]): void {
        this.rejected = files;
        this.uploadErrorMessage = '';
    }

    protected onRemove(file: File): void {
        const currentFiles = this.fileControl.value || [];
        const index = currentFiles.indexOf(file);
        if (index > -1) {
            currentFiles.splice(index, 1);
            this.fileControl.setValue([...currentFiles]);
            this.fileControl.updateValueAndValidity();
            this.cleanupFileUrl(file);
        }
        this.uploadErrorMessage = '';
    }

    protected onRemoveExistingImage(index: number): void {
        const imagePath = this.existingImages[index];
        const parkingId = this.parkingId || this.apiService.getCurrentParkingId() || sessionStorage.getItem('parking_id');

        if (!parkingId) {
            this.notificationService.showError('Unable to remove image: Parking ID not found', 3000);
            return;
        }

        this.apiService.removeParkingImage(parkingId, imagePath).subscribe({
            next: () => {
                this.existingImages.splice(index, 1);
                this.fileControl.updateValueAndValidity();
                this.uploadErrorMessage = '';
                this.updateCarouselItems();
                this.notificationService.showSuccess('Image removed successfully', 3000);
            },
            error: (error) => {
                this.notificationService.showError('Failed to remove image. Please try again.', 3000);
            }
        });
    }

    protected getTotalFilesCount(): number {
        const newFilesCount = this.fileControl.value ? this.fileControl.value.length : 0;
        const existingFilesCount = this.existingImages ? this.existingImages.length : 0;
        return newFilesCount + existingFilesCount;
    }

    protected getImageFileName(imageUrl: string): string {
        return imageUrl.split('/').pop() || 'image';
    }

    protected getImageFileSize(imageUrl: string): string {
        return 'Unknown size';
    }

    private maxFilesLength(maxLength: number): ValidatorFn {
        return (control: AbstractControl) => {
            const files = control.value as File[];
            const newFilesCount = files ? files.length : 0;
            const existingFilesCount = this.existingImages ? this.existingImages.length : 0;
            const totalFiles = newFilesCount + existingFilesCount;

            return totalFiles > maxLength
                ? { maxLength: { actualLength: totalFiles, requiredLength: maxLength } }
                : null;
        };
    }

    protected async loadTeamMembers(): Promise<void> {
        try {
            this.teamItems = [];
            this.teamMembers = [];
            setTimeout(() => {
                try { this.teamList?.refresh(); } catch { }
            }, 0);
        } catch (error) {
        }
    }

    protected onAddTeamFromDropdown(): void {
        this.debugLog('onAddTeamFromDropdown invoked');
        (this as any).teamSelectOpen = false;
        try {
            const active = document.activeElement as HTMLElement | null;
            if (active) {
                active.blur();
            }
            window.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape' }));
        } catch { }

        setTimeout(() => {
            if (this.teamDrawerComponent) {
                this.teamDrawerComponent.openDrawer();
            }
            setTimeout(() => {
                const overlay = document.querySelector('.cdk-overlay-container .cdk-overlay-pane');
            }, 0);
        }, 0);
    }

    private getUserDisplayName(user: any): string {
        if (!user) return '';

        if (user.fullName) {
            return user.fullName.trim();
        }
        if (user.name) {
            return user.name.trim();
        }

        const firstName = user.firstName || '';
        const lastName = user.lastName || '';
        if (firstName || lastName) {
            const fullName = `${firstName} ${lastName}`.trim();
            if (fullName) {
                return fullName;
            }
        }

        return user.email || '';
    }

    private getUserRoleName(user: any): string {
        if (!user) {
            return '';
        }

        const roleName = user.role?.name
            || user.role?.role_name
            || (typeof user.role === 'string' ? user.role : '')
            || user.role_name
            || user.roleName
            || '';

        if (roleName) {
            return this.formatRoleDisplayName(roleName);
        }

        if (user.roleType) {
            return this.formatRoleDisplayName(user.roleType);
        }

        const roleId = user.role_id || user.role?.id;
        if (roleId) {
            const resolvedRole = this.roleService.getRoleNameById(roleId);
            if (resolvedRole) {
                return this.formatRoleDisplayName(resolvedRole);
            }
        }

        if (user.type) {
            return this.formatRoleDisplayName(user.type);
        }

        const currentUser = this.apiService.getCurrentUser();
        if (currentUser && this.getUserId(user) === this.getUserId(currentUser)) {
            const currentRole = this.roleService.getCurrentRole() || currentUser.role?.name || 'Admin';
            return this.formatRoleDisplayName(currentRole);
        }

        return '';
    }

    private formatRoleDisplayName(role: string): string {
        const normalized = String(role || '').trim();
        if (!normalized) {
            return '';
        }

        return normalized
            .split(/[\s_-]+/)
            .filter(Boolean)
            .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
            .join(' ');
    }

    private getPendingInviteRoleType(): string {
        try {
            const raw = localStorage.getItem('parking_pending_team_invite');
            if (!raw) {
                return '';
            }

            const pending = JSON.parse(raw);
            const roleType = pending?.display?.roleType || pending?.payload?.userData?.type;
            return roleType ? this.formatRoleDisplayName(roleType) : '';
        } catch {
            return '';
        }
    }

    private getManagerRoleForReview(managerUser: any): string {
        const managerRole = this.getUserRoleName(managerUser)
            || this.getPendingInviteRoleType();

        if (managerRole) {
            return managerRole;
        }

        if (managerUser) {
            return 'Manager';
        }

        return this.getUserRoleName(this.apiService.getCurrentUser()) || '-';
    }

    private getUserId(user: any): string {
        if (!user) return '';

        const candidateIds = [
            user.id,
            user.user_id,
            user.userId,
            user.memberId,
            user.managerId,
            user?.user?.id,
            user?.user?.user_id,
        ];

        const validId = candidateIds.find((value) => typeof value === 'string' && value.trim() !== '');
        return validId || '';
    }

    protected onUserSelected(user: any): void {
        const userId = this.getUserId(user);
        if (userId) {
            const cleanUser = {
                ...user,
                id: userId,
                user_id: userId,
                userId: userId
            };
            this.selectedTeamMember = cleanUser;
            this.selectedTeamValue = cleanUser;
            localStorage.setItem('parking_invited_manager_id', userId);
        } else {
            this.selectedTeamMember = user;
            this.selectedTeamValue = user;
            localStorage.removeItem('parking_invited_manager_id');
        }
        this.selectedTeamDisplayValue = this.getUserDisplayName(user);

        // Latest selection wins: selecting an existing user cancels any deferred invite
        // so Go Live doesn't create multiple team members for this parking.
        if (!user?.pendingInvite) {
            localStorage.removeItem('parking_pending_team_invite');
        }

        this.saveTeamMemberData();
        this.updateReviewManagerName();

        // If a different manager is selected, reset all assignment flags
        if (this.assignedManagerId && this.assignedManagerId !== userId) {
            this.resetManagerAssignmentFlags();
        }

        this.cdr.markForCheck();
    }

    protected clearSelectedTeamMember(): void {
        this.selectedTeamMember = null;
        this.selectedTeamValue = null;
        this.selectedTeamDisplayValue = '';
        this.saveTeamMemberData();
        localStorage.removeItem('parking_invited_manager_id');
        localStorage.removeItem('parking_pending_team_invite');

        // Reset all assignment flags when clearing selection
        this.resetManagerAssignmentFlags();

        this.cdr.markForCheck();
    }

    // Helper method to reset all manager assignment flags
    private resetManagerAssignmentFlags(): void {
        this.managerAlreadyAssigned = false;
        this.managerAssignmentChecked = false;
        this.assignedManagerId = null;
        this.managerAssignmentPromise = null;
        this.managerAssignmentCompleted = false;
        this.isManagerAssignmentInProgress = false;
        this.managerAssignmentInFlight = false;
        this.managerAssignmentResolve = null;
        this.managerAssignmentReject = null;
        this.lastManagerAssignmentCallTime = 0;
        // NOTE: Do NOT reset parkingActivationChecked / parkingIsActive here.
        // Parking activation status does not change when user navigates backward;
        // resetting these would cause duplicate activateParking API calls.
        this.isUpdatingManager = false;
    }

    protected onTeamMembersCreated(createdMember?: any): void {
        this.debugLog('onTeamMembersCreated invoked with:', createdMember);
        this.loadTeamMembers();
        try { this.teamList?.refresh(); } catch { }

        if (createdMember?.pendingInvite) {
            const memberWithRole = {
                ...createdMember,
                role: createdMember.role || (createdMember.roleType ? { name: createdMember.roleType } : undefined),
            };
            this.onUserSelected(memberWithRole);
            this.saveTeamMemberData();
            this.cdr.markForCheck();

            const currentStep = this.currentStep();
            if (currentStep === 6 || currentStep === 7) {
                setTimeout(() => {
                    this.nextStep();
                }, 300);
            }
            return;
        }

        if (createdMember) {
            const userId = createdMember.id ||
                createdMember.user_id ||
                createdMember.userId ||
                createdMember.memberId ||
                createdMember.data ||
                createdMember;

            if (userId) {
                localStorage.setItem('parking_invited_manager_id', userId);
                this.debugLog('Stored invited manager ID:', userId);

                this.apiService.getUserById(userId).subscribe({
                    next: (userData: any) => {
                        this.debugLog('Fetched user details:', userData);

                        let user = userData?.data || userData;

                        if (user && !user.id) {
                            user.id = userId;
                            user.user_id = userId;
                            user.userId = userId;
                        }

                        if (user) {
                            this.onUserSelected(user);
                            this.saveTeamMemberData();

                            const currentStep = this.currentStep();
                            if (currentStep === 6 || currentStep === 7) {
                                setTimeout(() => {
                                    this.nextStep();
                                }, 300);
                            }
                        } else {
                            this.handleTeamMemberFallback(userId);
                        }
                    },
                    error: (err) => {
                        this.debugLog('Failed to fetch user details, using ID directly');
                        this.handleTeamMemberFallback(userId);
                    }
                });
            }
        }
    }

    private handleTeamMemberFallback(userId: string): void {
        const memberWithId = {
            id: userId,
            user_id: userId,
            userId: userId,
            name: 'New Team Member',
            email: 'loading...'
        };
        this.onUserSelected(memberWithId);
        this.saveTeamMemberData();

        const currentStep = this.currentStep();
        if (currentStep === 6 || currentStep === 7) {
            setTimeout(() => {
                this.nextStep();
            }, 300);
        }
    }

    protected readonly drawer = {
        Components: [
            { name: 'Button', icon: ICON },
            { name: 'Input', icon: ICON },
            { name: 'Tooltip', icon: ICON }],
        Essentials: [
            { name: 'Getting started', icon: ICON },
            { name: 'Showcase', icon: ICON },
            { name: 'Typography', icon: ICON }],
    };

    constructor(
        private countryRegionService: CountryRegionService,
        private countryCoordinatesService: CountryCoordinatesService,
        private apiService: ApiService,
        private router: Router,
        private route: ActivatedRoute,
        private readonly dialogs: TuiResponsiveDialogService,
        private parkingDataService: ParkingDataService,
        private timezoneConverterService: TimezoneConverterService,
        private navigationService: NavigationService,
        private notificationService: NotificationService,
        private roleService: RoleService,
    ) {
        super();
        this.fileControl.valueChanges.subscribe((vals) => {
            const files: File[] = [];
            (vals || []).forEach((v: any) => {
                if (v instanceof File) {
                    files.push(v as File);
                } else if (v && v.file instanceof File) {
                    files.push(v.file as File);
                }
            });
            this.currentUploadFiles = files;
            this.updateCarouselItems();
        });
    }

    protected getProgressValue(): number {
        return this.getCurrentStepProgress();
    }

    protected getOverallProgress(): number {
        let totalProgress = 0;

        if (this.currentStep() > 1) {
            totalProgress += 25;
        }

        if (this.currentStep() > 2) {
            if (this.selectedCardIndex() >= 0) {
                totalProgress += 25;
            }
        } else if (this.currentStep() === 2) {
            if (this.selectedCardIndex() >= 0) {
                totalProgress += 25;
            }
        }

        if (this.currentStep() > 3) {
            if (this.selectedLocation()) {
                totalProgress += 25;
            }
        } else if (this.currentStep() === 3) {
            if (this.selectedLocation()) {
                totalProgress += 25;
            }
        }

        if (this.currentStep() > 4) {
            totalProgress += 25;
        } else if (this.currentStep() === 4) {
            const formControls = Object.keys(this.locationForm.controls);
            const validControls = formControls.filter(control =>
                this.locationForm.get(control)?.valid
            ).length;
            const formProgress = Math.round((validControls / formControls.length) * 25);
            totalProgress += formProgress;
        }

        return totalProgress;
    }

    protected getAddPeopleProgress(): number {
        return 0;
    }

    protected getAddCapacityProgress(): number {
        return 0;
    }

    protected getCurrentStepProgress(): number {
        switch (this.currentStep()) {
            case 1:
                return 100;
            case 2:
                return this.selectedCardIndex() >= 0 ? 100 : 0;
            case 3:
                return this.selectedLocation() ? 100 : 0;
            case 4:
                const formControls = Object.keys(this.locationForm.controls);
                const validControls = formControls.filter(control =>
                    this.locationForm.get(control)?.valid
                ).length;
                return Math.round((validControls / formControls.length) * 100);
            default:
                return 0;
        }
    }

    protected getStepProgress(stepNumber: number): number {
        let progress = 0;

        if (stepNumber === 1) {
            return (this.currentStep() > 1 || this.parkingTypeSelected() || localStorage.getItem('parking_type_selection')) ? 100 : 0;
        }

        if (stepNumber === 2) {
            return (this.currentStep() > 2 || this.selectedLocation() || sessionStorage.getItem('parkingsStep3Data')) ? 100 : 0;
        }

        if (stepNumber === 3) {
            return (this.currentStep() > 3 || sessionStorage.getItem('parkingsStep4Data')) ? 100 : 0;
        }

        if (stepNumber === 4) {
            return (this.currentStep() > 4 || this.selectedFeatures().length > 0 || localStorage.getItem('parking_amenities_data')) ? 100 : 0;
        }

        if (stepNumber === 5) {
            return (this.currentStep() > 5 || localStorage.getItem('parking_operating_hours_data')) ? 100 : 0;
        }

        if (stepNumber === 6) {
            return (this.currentStep() > 6 || this.existingImages.length > 0 || this.currentUploadFiles.length > 0 || sessionStorage.getItem('parkingsStep6Data')) ? 100 : 0;
        }

        if (stepNumber === 7) {
            return (this.currentStep() > 7 || this.selectedTeamMember || localStorage.getItem('parking_team_member_data') ||
                localStorage.getItem('parking_pending_team_invite') ||
                (this.parkingData.manager && this.parkingData.manager !== 'Not Assigned')) ? 100 : 0;
        }

        return 0;
    }

    protected nextStep(): void {
        if (this.currentStep() < this.totalSteps) {
            const currentStepNumber = this.currentStep();
            const nextStepNumber = this.currentStep() + 1;

            if (currentStepNumber === 1) {
                const parkingName = this.locationForm.get('parkingName');
                const description = this.locationForm.get('descriptionValue');

                parkingName?.markAsTouched();
                description?.markAsTouched();

                if (!parkingName?.valid || !description?.valid) {
                    this.notificationService.showError('Please fill in all required fields', 3000);
                    return;
                }

                if (!this.parkingTypeSelected) {
                    this.notificationService.showError('Please select a parking type to continue', 3000);
                    return;
                }
            }

            if (currentStepNumber === 3) {
                const requiredFields = ['addressValue', 'stateValue', 'cityValue', 'postalCodeValue', 'latitudeValue', 'longitudeValue'];
                let hasError = false;

                requiredFields.forEach(field => {
                    const control = this.locationForm.get(field);
                    control?.markAsTouched();
                    if (!control?.valid) {
                        hasError = true;
                    }
                });

                if (hasError) {
                    this.notificationService.showError('Please fill in all required fields', 3000);
                    return;
                }
            }

            if (currentStepNumber === 7) {
                const managerId = this.getUserId(this.selectedTeamMember);
                const hasPendingInvite = !!localStorage.getItem('parking_pending_team_invite');
                if (!managerId && !hasPendingInvite && !this.selectedTeamMember) {
                    this.notificationService.showError('Please select a team member to manage this parking', 3000);
                    return;
                }
            }

            if (currentStepNumber === 2) {
                this.proceedFromStep2ToNext(nextStepNumber);
                return;
            }

            this.saveCurrentStepData().then(() => {
                const previousStepNumber = this.currentStep();
                this.currentStep.update(step => step + 1);
                this.persistWizardStep();
                this.updateUrlWithCurrentStep();
                this.updateMarkerColor();

                if (nextStepNumber === 2) {
                    setTimeout(() => {
                        this.loadMap();
                    }, 300);
                }

                if (nextStepNumber === 3) {
                    if (previousStepNumber !== 2) {
                        this.loadStepData(nextStepNumber);
                    }
                    setTimeout(() => {
                        this.ensureFormIsPopulated();
                    }, 100);
                }

                if (nextStepNumber === 4 || nextStepNumber === 5) {
                    setTimeout(() => {
                        this.ensureTimezoneIsSetFromOrganization();
                    }, 300);
                }

                if (nextStepNumber === 5) {
                    setTimeout(() => this.debugStep7Form(), 50);
                }

                if (nextStepNumber === 7) {
                    setTimeout(() => this.loadTeamMembers(), 100);
                }

                if (nextStepNumber === 8) {
                    setTimeout(() => this.hydrateReviewData(), 100);
                }
            }).catch((error) => {
                this.notificationService.showError('Error saving data. Please try again.', 3000);
            });
        } else {
            this.saveCurrentStepData().then(() => {
                this.router.navigate(['/parking-add-capacity']);
            }).catch((error) => {
                this.notificationService.showError('Error on final step. Please try again.', 3000);
            });
        }
    }

    private async proceedFromStep2ToNext(nextStepNumber: number): Promise<void> {
        this.isInitialMapLoad = false;
        let capturedLocation = this.selectedLocation();
        const searchText = (this.searchQuery() || '').toString().trim();

        if (!capturedLocation && searchText) {
            await this.geocodeSearchQuery(searchText);
            capturedLocation = this.selectedLocation();
        }

        if (capturedLocation && (!this.locationForm.get('addressValue')?.value || !this.locationForm.get('cityValue')?.value || !this.locationForm.get('stateValue')?.value)) {
            await this.reverseGeocode(capturedLocation.lat, capturedLocation.lng, true);
        }

        if ((!this.locationForm.get('addressValue')?.value) && searchText) {
            this.locationForm.patchValue({ addressValue: searchText });
        }

        const capturedFormData = {
            addressValue: this.locationForm.get('addressValue')?.value || searchText || '',
            cityValue: this.locationForm.get('cityValue')?.value || '',
            countryValue: this.locationForm.get('countryValue')?.value || '',
            postalCodeValue: this.locationForm.get('postalCodeValue')?.value || '',
            stateValue: this.locationForm.get('stateValue')?.value || '',
            latitudeValue: this.locationForm.get('latitudeValue')?.value || (capturedLocation ? capturedLocation.lat.toString() : ''),
            longitudeValue: this.locationForm.get('longitudeValue')?.value || (capturedLocation ? capturedLocation.lng.toString() : '')
        };

        this.pendingLocationData.set(capturedFormData);

        this.hasManualLocationSelection = true;
        this.saveMapSelectionToLocalStorage(capturedFormData);
        this.saveLocationData();

        this.currentStep.update(step => step + 1);
        this.persistWizardStep();
        this.updateUrlWithCurrentStep();
        this.updateMarkerColor();

        if (nextStepNumber === 3) {
            setTimeout(() => {
                this.ensureFormIsPopulated();
            }, 100);
        }
    }

    protected previousStep(): void {
        if (this.currentStep() > 1) {
            const currentStepNumber = this.currentStep();

            if (currentStepNumber !== 2) {
                switch (currentStepNumber) {
                    case 3: this.saveFormData(); break;
                    case 4: this.saveAmenitiesData(); break;
                    case 5: this.saveOperatingHoursData(); break;
                    case 6: this.saveParkingImagesToLocalStorage(); break;
                    case 7:
                        // Reset all manager assignment flags when going back
                        this.resetManagerAssignmentFlags();
                        this.saveTeamMemberData();
                        break;
                }
                this.saveCurrentStepData().catch(() => { });
            }

            const previousStepNumber = this.currentStep() - 1;
            this.currentStep.update(step => step - 1);
            this.persistWizardStep();
            this.updateUrlWithCurrentStep();
            this.updateMarkerColor();

            this.loadStepData(this.currentStep());
            this.cdr.markForCheck();

            if (this.currentStep() === 2) {
                setTimeout(() => {
                    this.loadMap();
                }, 300);
            }
        }
    }

    private async saveCurrentStepData(): Promise<void> {
        const currentStep = this.currentStep();
        this.persistWizardStep(currentStep);

        if (currentStep !== 2) {
            this.autoSaveData().catch(() => { });
        }

        switch (currentStep) {
            case 1:
                await this.patchParkingTypeData();
                this.saveParkingTypeToLocalStorage();
                break;
            case 2:
                this.saveLocationData();
                await this.patchParkingWithLocationData();
                break;
            case 3:
                this.saveFormData();
                await this.patchParkingWithFormData();
                break;
            case 4:
                this.saveAmenitiesData();
                await this.patchParkingWithAmenitiesData();
                break;
            case 5:
                this.saveOperatingHoursData();
                await this.patchParkingWithOperatingHours();
                break;
            case 6:
                await this.saveParkingImagesToLocalStorage();
                await this.patchParkingWithImages();
                break;
            case 7:
                this.saveTeamMemberData();
                await this.patchParkingWithTeamMember();
                break;
            case 8:
                break;
        }
    }

    // ============ MANAGER ASSIGNMENT - COMPLETE FIXED METHODS ============

    private async checkParkingActivationStatus(parkingId: string): Promise<boolean> {
        // If already checked, return cached value
        if (this.parkingActivationChecked) {
            return this.parkingIsActive;
        }

        try {
            const response = await this.apiService.getParkingDetail(parkingId).toPromise();
            const parkingData = response?.data || response;
            if (parkingData) {
                this.parkingIsActive = parkingData.status === 'active' || parkingData.status === 'Active';
                this.parkingActivationChecked = true;
                return this.parkingIsActive;
            }
            return false;
        } catch (error) {
            return false;
        }
    }

    private async checkIfManagerAlreadyAssigned(parkingId: string): Promise<boolean> {
        // If already checked and assigned, and we haven't changed selection
        if (this.managerAssignmentChecked && this.managerAlreadyAssigned && this.assignedManagerId) {
            // Check if user selected a different manager
            const currentManagerId = this.getUserId(this.selectedTeamMember);
            if (currentManagerId && currentManagerId !== this.assignedManagerId) {
                // User selected different manager, reset
                this.managerAlreadyAssigned = false;
                this.managerAssignmentChecked = false;
                this.assignedManagerId = null;
                this.managerAssignmentCompleted = false;
                return false;
            }
            return true;
        }

        try {
            const response = await this.apiService.getParkingDetail(parkingId).toPromise();
            const parkingData = response?.data || response;

            // Cache activation status
            if (parkingData) {
                this.parkingIsActive = parkingData.status === 'active' || parkingData.status === 'Active';
                this.parkingActivationChecked = true;
            }

            if (parkingData?.managedBy || parkingData?.manager) {
                const manager = parkingData.managedBy || parkingData.manager;
                const existingManagerId = this.getUserId(manager);

                if (existingManagerId) {
                    // Check if user selected a different manager
                    const currentManagerId = this.getUserId(this.selectedTeamMember);
                    if (currentManagerId && currentManagerId !== existingManagerId) {
                        // User selected different manager, don't use existing
                        this.assignedManagerId = null;
                        this.managerAlreadyAssigned = false;
                        this.managerAssignmentChecked = false;
                        this.managerAssignmentCompleted = false;
                        return false;
                    }

                    this.assignedManagerId = existingManagerId;
                    this.managerAlreadyAssigned = true;
                    this.managerAssignmentChecked = true;
                    this.managerAssignmentCompleted = true;

                    // Update the selected team member to match the API
                    this.selectedTeamMember = manager;
                    this.selectedTeamValue = manager;
                    this.selectedTeamDisplayValue = this.getUserDisplayName(manager);
                    this.saveTeamMemberData();
                    return true;
                }
            }
        } catch (error) {
            // If we can't fetch, proceed with assignment
        }

        return false;
    }

    // During parking creation, only persist the selected manager locally.
    // Team invite + manager assignment + parking activation happen exclusively on Go Live.
    private async patchParkingWithTeamMember(): Promise<void> {
        this.saveTeamMemberData();

        const managerId =
            this.getUserId(this.selectedTeamMember) ||
            localStorage.getItem('parking_invited_manager_id') ||
            '';

        if (managerId) {
            localStorage.setItem('parking_invited_manager_id', managerId);
        }

        // Reset in-memory assignment flags so revisiting this step + changing selection
        // never re-triggers premature API assignment on next navigation.
        this.resetManagerAssignmentFlags();

        return Promise.resolve();
    }

    // Method to manually update manager (for edit mode)
    protected async updateManager(managerId: string): Promise<void> {
        if (this.isUpdatingManager) {
            return;
        }

        this.isUpdatingManager = true;
        try {
            const parkingId = this.getExistingParkingId();
            if (!parkingId) {
                throw new Error('No parking ID');
            }

            const payload = {
                parkingId: parkingId,
                managerId: managerId
            };

            const result = await this.apiService.updateParkingManager(payload).pipe(
                catchError(() => of(null))
            ).toPromise();
            if (result) {
                this.managerAlreadyAssigned = true;
                this.managerAssignmentChecked = true;
                this.assignedManagerId = managerId;
                this.managerAssignmentCompleted = true;
                this.notificationService.showSuccess('Manager updated successfully!', 2000);
            }
        } catch (error) {
            this.notificationService.showError('Failed to update manager. Please try again.', 3000);
            throw error;
        } finally {
            this.isUpdatingManager = false;
        }
    }

    // ============ END MANAGER ASSIGNMENT METHODS ============

    private saveAmenitiesData(): void {
        try {
            const amenitiesData = {
                selectedFeatures: [...this.selectedFeatures()],
                timestamp: new Date().toISOString()
            };
            localStorage.setItem('parking_amenities_data', JSON.stringify(amenitiesData));
        } catch (error) {
        }
    }

    private loadAmenitiesData(): void {
        try {
            const savedData = localStorage.getItem('parking_amenities_data');
            if (savedData) {
                const amenitiesData = JSON.parse(savedData);
                this.selectedFeatures.set([...(amenitiesData.selectedFeatures || [])]);
                this.updateSelectedAmenityIcons();
            }
        } catch (error) {
        }
    }

    private loadStepData(step: number): void {
        switch (step) {
            case 1:
                this.loadParkingTypeFromLocalStorage();
                break;
            case 4:
                this.loadAmenitiesData();
                break;
            case 5:
                this.loadOperatingHoursData();
                break;
            case 6:
                this.loadParkingImagesFromLocalStorage();
                break;
            case 7:
                this.loadTeamMemberData();
                this.loadTeamMembers();
                break;
        }

        if (step === 8) {
            this.hydrateReviewData();
            return;
        }

        if (this.isEditMode && this.parkingId) {
            this.loadStepDataFromAPI(step);
        } else {
            this.loadStepDataFromLocalStorage(step);
        }
    }

    private loadStepDataFromAPI(step: number): void {
        if (!this.parkingId) {
            return;
        }

        this.apiService.getParkingDetail(this.parkingId).subscribe({
            next: (response) => {
                const parkingData = response?.data || response;
                if (parkingData) {
                    this.populateStepDataFromAPI(step, parkingData);
                }
            },
            error: () => {
                this.loadStepDataFromLocalStorage(step);
            }
        });
    }

    private loadStepDataFromLocalStorage(step: number): void {
        switch (step) {
            case 1:
                this.loadParkingTypeFromLocalStorage();
                break;
            case 2:
                this.loadLocationFromLocalStorage();
                break;
            case 3:
                this.loadFormFromLocalStorage();
                break;
            case 4:
                this.loadAmenitiesData();
                break;
            case 5:
                this.loadOperatingHoursData();
                break;
            case 6:
                this.loadParkingImagesFromLocalStorage();
                break;
            case 7:
                this.loadTeamMemberData();
                break;
            case 8:
                this.loadReviewDataFromAPI();
                break;
        }
    }

    private populateStepDataFromAPI(step: number, parkingData: any): void {
        switch (step) {
            case 1:
                this.populateParkingTypeFromAPI(parkingData);
                break;
            case 2:
                this.populateLocationFromAPI(parkingData);
                break;
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
                this.autoFillAllFields(parkingData);
                break;
            case 8:
                this.autoFillAllFields(parkingData);
                this.hydrateReviewData();
                break;
        }
    }

    private saveParkingTypeData(): void {
        this.createParkingAtStep1();
    }

    private saveLocationData(): void {
        try {
            const data = {
                selectedLocation: this.selectedLocation(),
                searchQuery: this.searchQuery(),
                locationFormData: this.locationForm.getRawValue(),
                timestamp: new Date().toISOString()
            };
            const serialized = JSON.stringify(data);
            sessionStorage.setItem('parkingsStep3Data', serialized);
            localStorage.setItem('parkingsStep3Data', serialized);
        } catch (error) {
        }
    }

    private saveFormData(): void {
        try {
            const data = {
                locationFormData: this.locationForm.getRawValue(),
                timestamp: new Date().toISOString()
            };
            const serialized = JSON.stringify(data);
            sessionStorage.setItem('parkingsStep4Data', serialized);
            localStorage.setItem('parkingsStep4Data', serialized);
        } catch (error) {
        }
    }

    private loadParkingTypeFromLocalStorage(): void {
        try {
            const savedData = localStorage.getItem('parking_type_selection');
            if (savedData) {
                const data = JSON.parse(savedData);
                if (data.selectedCardIndex !== undefined && data.selectedCardIndex >= 0) {
                    this.selectedCardIndex.set(data.selectedCardIndex);
                    this.parkingTypeSelected.set(true);
                }
                if (data.parkingName) {
                    this.locationForm.get('parkingName')?.setValue(data.parkingName);
                }
                if (data.descriptionValue) {
                    this.locationForm.get('descriptionValue')?.setValue(data.descriptionValue);
                }
                this.cdr.markForCheck();
            }
        } catch (error) {
        }
    }

    private saveParkingTypeToLocalStorage(): void {
        try {
            const data = {
                selectedCardIndex: this.selectedCardIndex(),
                parkingTypeSelected: this.parkingTypeSelected(),
                parkingName: this.locationForm.get('parkingName')?.value,
                descriptionValue: this.locationForm.get('descriptionValue')?.value,
                timestamp: new Date().toISOString()
            };
            localStorage.setItem('parking_type_selection', JSON.stringify(data));
        } catch (error) {
        }
    }

    private loadLocationFromLocalStorage(): void {
        try {
            const savedData = sessionStorage.getItem('parkingsStep3Data') || localStorage.getItem('parkingsStep3Data');
            if (savedData) {
                const data = JSON.parse(savedData);
                if (data.selectedLocation) {
                    this.selectedLocation.set(data.selectedLocation);
                }
                if (data.searchQuery) {
                    this.searchQuery.set(data.searchQuery);
                }
            }
        } catch (error) {
        }
    }

    private loadFormFromLocalStorage(): void {
        const pending = this.pendingLocationData();
        if (pending && (pending.latitudeValue || pending.longitudeValue || pending.addressValue)) {
            this.locationForm.patchValue({
                addressValue: pending.addressValue || '',
                cityValue: pending.cityValue || '',
                stateValue: pending.stateValue || '',
                postalCodeValue: pending.postalCodeValue || '',
                countryValue: pending.countryValue || '',
                latitudeValue: pending.latitudeValue || '',
                longitudeValue: pending.longitudeValue || ''
            });
            this.locationForm.get('countryValue')?.disable();
            this.pendingLocationData.set(null);
            this.cdr.markForCheck();

            if ((!pending.addressValue || !pending.cityValue) && pending.latitudeValue && pending.longitudeValue) {
                this.isInitialMapLoad = false;
                this.reverseGeocode(parseFloat(pending.latitudeValue), parseFloat(pending.longitudeValue));
            }
            return;
        }

        const currentAddress = this.locationForm.get('addressValue')?.value;
        const currentCity = this.locationForm.get('cityValue')?.value;
        const currentLat = this.locationForm.get('latitudeValue')?.value;
        const currentLng = this.locationForm.get('longitudeValue')?.value;

        const hasManualLocationData = currentAddress && currentCity && currentLat && currentLng &&
            currentLat !== '21.170200' && currentLat !== '21.1702';

        if (hasManualLocationData && this.currentStep() === 3) {
            return;
        }

        let loaded = false;

        try {
            const savedData = sessionStorage.getItem('parkingsStep4Data') || localStorage.getItem('parkingsStep4Data');
            if (savedData) {
                const data = JSON.parse(savedData);
                if (data.locationFormData) {
                    this.locationForm.patchValue(data.locationFormData);
                    this.locationForm.get('countryValue')?.disable();
                    loaded = true;
                }
            }
        } catch (error) { }

        if (!loaded) {
            try {
                const savedData = sessionStorage.getItem('parkingsStep3Data') || localStorage.getItem('parkingsStep3Data');
                if (savedData) {
                    const data = JSON.parse(savedData);
                    if (data.locationFormData) {
                        this.locationForm.patchValue(data.locationFormData);
                        this.locationForm.get('countryValue')?.disable();
                        loaded = true;
                    }
                }
            } catch (error) { }
        }

        if (loaded) {
            this.cdr.markForCheck();
        }
    }

    private async saveParkingImagesToLocalStorage(): Promise<void> {
        if (this._savingImagesInProgress) {
            return;
        }
        this._savingImagesInProgress = true;
        try {
            if (this.fileControl.value && this.fileControl.value.length > 0) {
                this.currentUploadFiles = [...this.fileControl.value];
            }

            const fileDataPromises = this.currentUploadFiles.map(async (file) => {
                return new Promise((resolve) => {
                    const reader = new FileReader();
                    reader.onload = () => {
                        resolve({
                            name: file.name,
                            type: file.type,
                            size: file.size,
                            data: reader.result as string
                        });
                    };
                    reader.readAsDataURL(file);
                });
            });

            const fileData = await Promise.all(fileDataPromises);

            const data = {
                parkingName: this.locationForm.get('parkingName')?.value,
                descriptionValue: this.locationForm.get('descriptionValue')?.value,
                fileData: fileData,
                existingImages: this.existingImages,
                timestamp: new Date().toISOString()
            };
            sessionStorage.setItem('parkingsStep6Data', JSON.stringify(data));
        } finally {
            this._savingImagesInProgress = false;
        }
    }

    private loadParkingImagesFromLocalStorage(): void {
        try {
            const savedData = sessionStorage.getItem('parkingsStep6Data');
            if (savedData) {
                const data = JSON.parse(savedData);
                if (data.parkingName) {
                    this.locationForm.get('parkingName')?.setValue(data.parkingName);
                }
                if (data.descriptionValue) {
                    this.locationForm.get('descriptionValue')?.setValue(data.descriptionValue);
                }

                if (data.existingImages && Array.isArray(data.existingImages)) {
                    this.existingImages = [...data.existingImages];
                }

                if (data.fileData && Array.isArray(data.fileData) && data.fileData.length > 0) {
                    const restoredFiles: File[] = [];
                    for (const fileInfo of data.fileData) {
                        try {
                            const file = this.dataUrlToFile(fileInfo.data, fileInfo.name);
                            restoredFiles.push(file);
                        } catch (error) {
                        }
                    }
                    this.currentUploadFiles = restoredFiles;
                    this.fileControl.setValue([...restoredFiles]);
                }
                this.updateCarouselItems();
                this.cdr.markForCheck();
            }
        } catch (error) {
        }
    }

    private saveOperatingHoursData(): void {
        try {
            const opHours = this.buildOperatingHours();
            const data = {
                operating_hours: opHours,
                allDay: this.locationForm.get('allDay')?.value,
                open24Hours: this.locationForm.get('open24Hours')?.value,
                timestamp: new Date().toISOString()
            };
            localStorage.setItem('parking_operating_hours_data', JSON.stringify(data));
        } catch (error) {
        }
    }

    private loadOperatingHoursData(): void {
        try {
            const savedData = localStorage.getItem('parking_operating_hours_data');
            if (savedData) {
                const data = JSON.parse(savedData);
                const opHours = data.operating_hours;
                if (opHours) {
                    const openTime = typeof opHours.open_time === 'string'
                        ? this.parseTimeToTuiTime(opHours.open_time)
                        : opHours.open_time;
                    const closeTime = typeof opHours.close_time === 'string'
                        ? this.parseTimeToTuiTime(opHours.close_time)
                        : opHours.close_time;

                    this.locationForm.patchValue({
                        allDay: data.allDay,
                        open24Hours: data.open24Hours,
                        openTimeValue: openTime,
                        closeTimeValue: closeTime,
                        monday: opHours.open_days?.includes('mon'),
                        tuesday: opHours.open_days?.includes('tue'),
                        wednesday: opHours.open_days?.includes('wed'),
                        thursday: opHours.open_days?.includes('thu'),
                        friday: opHours.open_days?.includes('fri'),
                        saturday: opHours.open_days?.includes('sat'),
                        sunday: opHours.open_days?.includes('sun')
                    });
                    this.cdr.markForCheck();
                }
            }
        } catch (error) {
        }
    }

    private saveTeamMemberData(): void {
        try {
            if (this.selectedTeamMember) {
                const data = {
                    selectedTeamMember: this.selectedTeamMember,
                    selectedTeamDisplayValue: this.selectedTeamDisplayValue,
                    timestamp: new Date().toISOString()
                };
                localStorage.setItem('parking_team_member_data', JSON.stringify(data));
            } else {
                localStorage.removeItem('parking_team_member_data');
            }
        } catch (error) {
        }
    }

    private loadTeamMemberData(): void {
        try {
            const savedData = localStorage.getItem('parking_team_member_data');
            if (savedData) {
                const data = JSON.parse(savedData);
                if (data.selectedTeamMember) {
                    const member = data.selectedTeamMember;
                    const memberId = this.getUserId(member);
                    if (memberId && !member.id) {
                        member.id = memberId;
                        member.user_id = memberId;
                        member.userId = memberId;
                    }
                    this.selectedTeamMember = member;
                    this.selectedTeamValue = member;
                    this.selectedTeamDisplayValue = data.selectedTeamDisplayValue || this.getUserDisplayName(member);
                    this.cdr.markForCheck();
                }
            }

            // During creation (inactive parking), keep the locally selected manager.
            // Do not overwrite with any prematurely assigned API manager from earlier wizard visits.
            // For already-active parkings in edit mode, sync from API if no local selection.
            if (this.parkingId && this.isEditMode && !this.selectedTeamMember) {
                this.checkIfManagerAlreadyAssigned(this.parkingId).then((assigned) => {
                    if (assigned) {
                        this.managerAlreadyAssigned = true;
                        this.managerAssignmentChecked = true;
                        this.managerAssignmentCompleted = true;
                        this.cdr.markForCheck();
                    }
                });
            }
        } catch (error) {
        }
    }

    private parseTimeToTuiTime(timeStr: string): TuiTime | null {
        if (!timeStr) return null;
        try {
            const parts = timeStr.split(':');
            if (parts.length >= 2) {
                return new TuiTime(parseInt(parts[0], 10), parseInt(parts[1], 10));
            }
        } catch (e) {
            return null;
        }
        return null;
    }

    private populateParkingTypeFromAPI(parkingData: any): void {
        if (parkingData.name) {
            this.locationForm.get('parkingName')?.setValue(parkingData.name);
        }
        if (parkingData.description) {
            this.locationForm.get('descriptionValue')?.setValue(parkingData.description);
        }
        const type = parkingData.parking_type || parkingData.parkingType;
        if (type) {
            if (!this.parkingTypeSelected() || this.selectedCardIndex() < 0) {
                const index = this.parkingTypes.findIndex(t => t.title === type);
                if (index !== -1) {
                    this.selectedCardIndex.set(index);
                    this.parkingTypeSelected.set(true);
                }
            }
        }
    }

    private populateLocationFromAPI(parkingData: any): void {
        if (parkingData.point && parkingData.point.coordinates) {
            const [lng, lat] = parkingData.point.coordinates;
            this.selectedLocation.set({ lat, lng });
        }
        if (parkingData.address) {
            this.searchQuery.set(parkingData.address);
        }
    }

    private populateFormFromAPI(parkingData: any): void {
        const currentLat = this.locationForm.get('latitudeValue')?.value;
        const currentLng = this.locationForm.get('longitudeValue')?.value;
        const hasManualLocation = currentLat && currentLng && this.selectedLocation();

        if (parkingData.address) {
            this.locationForm.get('addressValue')?.setValue(parkingData.address);
        }
        if (parkingData.city) {
            this.locationForm.get('cityValue')?.setValue(parkingData.city);
        }
        if (parkingData.state) {
            this.locationForm.get('stateValue')?.setValue(parkingData.state);
        }
        if (parkingData.country) {
            this.locationForm.get('countryValue')?.setValue(parkingData.country);
            this.locationForm.get('countryValue')?.disable();
        }
        if (parkingData.pincode) {
            this.locationForm.get('postalCodeValue')?.setValue(parkingData.pincode);
        }

        if (!hasManualLocation) {
            let lat: string | null = null;
            let lng: string | null = null;

            if (parkingData.address && parkingData.address.latitude && parkingData.address.longitude) {
                lat = parkingData.address.latitude;
                lng = parkingData.address.longitude;
            } else if (parkingData.point && parkingData.point.coordinates) {
                [lng, lat] = parkingData.point.coordinates;
            }

            if (lat && lng) {
                this.locationForm.patchValue({
                    latitudeValue: lat.toString(),
                    longitudeValue: lng.toString()
                });
                this.selectedLocation.set({
                    lat: parseFloat(lat),
                    lng: parseFloat(lng)
                });
            }
        }
    }

    protected goToStep(step: number): void {
        if (step >= 1 && step <= this.totalSteps) {
            const previousStep = this.currentStep();
            this.saveCurrentStepData().catch(() => { });

            this.currentStep.set(step);
            this.persistWizardStep(step);
            this.updateUrlWithCurrentStep();
            this.updateMarkerColor();

            if (!(previousStep === 2 && step === 3)) {
                this.loadStepData(step);
            }

            if (step === 2) {
                setTimeout(() => {
                    this.loadMap();
                }, 300);
            }

            if (step === 3) {
                setTimeout(() => {
                    this.ensureFormIsPopulated();
                }, 100);
            }
            if (step === 8) {
                setTimeout(() => this.hydrateReviewData(), 100);
            }
            if (step === 5) {
                setTimeout(() => this.debugStep7Form(), 50);
            }
        }
    }

    protected isStepActive(step: number): boolean {
        return this.currentStep() === step;
    }

    protected isStepCompleted(step: number): boolean {
        return this.currentStep() > step;
    }

    protected canProceedToNext(): boolean {
        return true;
    }

    protected canSkipStep(): boolean {
        return this.currentStep() === 4 || this.currentStep() === 6;
    }

    protected skipStep(): void {
        if (this.currentStep() < this.totalSteps && this.canSkipStep()) {
            if (this.currentStep() === 4) {
                this.selectedFeatures.set([]);
            }
            if (this.currentStep() === 6) {
                this.fileControl.setValue([]);
                this.existingImages = [];
            }

            this.currentStep.update(step => step + 1);
            this.persistWizardStep();
            this.updateUrlWithCurrentStep();
            if (this.currentStep() === 7) {
                this.debugStep7Form();
            }
        }
    }

    private debugStep7Form(): void {
        try {
            const files = (this.getUploadFiles() || []).map(f => ({ name: f.name, size: f.size, type: f.type }));
            const debugData = {
                step: 6,
                name: this.locationForm.get('parkingName')?.value,
                description: this.locationForm.get('descriptionValue')?.value,
                timeZone: this.locationForm.get('timeZoneValue')?.value,
                parkingType: this.parkingTypes[this.selectedCardIndex()]?.title || '',
                amenities: (this as any).getAmenitiesList ? (this as any).getAmenitiesList() : this.selectedFeatures().map(i => this.parkingFeatures[i]?.title).filter(Boolean),
                operating_hours: {
                    allDay: this.locationForm.get('allDay')?.value,
                    open24Hours: this.locationForm.get('open24Hours')?.value,
                    openTimeValue: this.locationForm.get('openTimeValue')?.value,
                    closeTimeValue: this.locationForm.get('closeTimeValue')?.value,
                },
                location: {
                    address_line_1: this.locationForm.get('addressValue')?.value,
                    address_line_2: this.locationForm.get('addressLine2Value')?.value,
                    city: this.locationForm.get('cityValue')?.value,
                    state: this.locationForm.get('stateValue')?.value,
                    country: this.locationForm.get('countryValue')?.value,
                    lat: this.locationForm.get('latitudeValue')?.value,
                    lng: this.locationForm.get('longitudeValue')?.value,
                    postalCode: this.locationForm.get('postalCodeValue')?.value,
                },
                files,
            };
        } catch { }
    }

    protected finalSubmit(): void {
        this.isSubmitting.set(true);

        try {
            const existingParkingId = sessionStorage.getItem('parking_id');
            const isComingBackFromCapacity = existingParkingId && !this.isEditMode;

            let longitudeValue = this.locationForm.get('longitudeValue')?.value;
            if (!longitudeValue || longitudeValue === null || longitudeValue === '') {
                this.locationForm.get('longitudeValue')?.setValue('72.8311');
                longitudeValue = '72.8311';
            }

            let finalLongitudeValue = this.locationForm.get('longitudeValue')?.value || longitudeValue || '72.8311';

            if (!finalLongitudeValue || finalLongitudeValue === null || finalLongitudeValue === '') {
                try {
                    const combinedData = sessionStorage.getItem('combinedParkingData');
                    if (combinedData) {
                        const parsedData = JSON.parse(combinedData);
                        if (parsedData.parkings?.location?.lng) {
                            finalLongitudeValue = parsedData.parkings.location.lng;
                        }
                    }
                } catch (error) {
                }
            }

            if (!finalLongitudeValue || finalLongitudeValue === null || finalLongitudeValue === '') {
                finalLongitudeValue = '72.8311';
            }

            let amenitiesFromSelection: string[] = [];
            try {
                if (this.selectedFeatures() && this.selectedFeatures().length > 0) {
                    amenitiesFromSelection = this.selectedFeatures()
                        .map(i => this.parkingFeatures[i]?.title)
                        .filter(Boolean);
                } else {
                    const savedAmenities = localStorage.getItem('parking_amenities_data');
                    if (savedAmenities) {
                        const parsed = JSON.parse(savedAmenities);
                        const savedSelected: number[] = parsed?.selectedFeatures || [];
                        amenitiesFromSelection = savedSelected
                            .map((i: number) => this.parkingFeatures[i]?.title)
                            .filter(Boolean);
                    }
                }
            } catch { }

            const parkingPayload = {
                "name": this.locationForm.get('parkingName')?.value || '',
                "description": this.locationForm.get('descriptionValue')?.value || '',
                "org_id": this.apiService.getCurrentOrganizationId() || '',
                "region_id": this.organizationRegionId() || null,
                "timeZone": this.locationForm.get('timeZoneValue')?.value || '',
                "parkingType": this.selectedParkingTypes.size > 0 ? this.parkingFeatures[Array.from(this.selectedParkingTypes)[0]]?.title || '' : '',
                "amenities": amenitiesFromSelection,
                "operating_hours": this.buildOperatingHours(),
                "status": "inactive",
                "location": {
                    "address_line_1": this.locationForm.get('addressValue')?.value || '',
                    "address_line_2": '',
                    "city": this.locationForm.get('cityValue')?.value || '',
                    "state": this.locationForm.get('stateValue')?.value || '',
                    "country": this.locationForm.get('countryValue')?.value || '',
                    "lat": this.locationForm.get('latitudeValue')?.value || 21.1702,
                    "lng": finalLongitudeValue,
                    "landmark": '',
                    "postalCode": this.locationForm.get('postalCodeValue')?.value || '395007'
                }
            };

            const formData = new FormData();
            formData.append('data', JSON.stringify(parkingPayload));

            const uploadedFiles = this.getUploadFiles();
            if (uploadedFiles.length > 0) {
                uploadedFiles.forEach((file: File) => {
                    formData.append('files', file);
                });
            }

            if (this.existingImages && this.existingImages.length > 0) {
                this.existingImages.forEach((image: any, index) => {
                    if (image) {
                        if (image instanceof File) {
                            formData.append('files', image);
                        }
                        else if (typeof image === 'string' && image.startsWith('data:')) {
                            try {
                                const byteString = atob(image.split(',')[1]);
                                const ab = new ArrayBuffer(byteString.length);
                                const ia = new Uint8Array(ab);

                                for (let i = 0; i < byteString.length; i++) {
                                    ia[i] = byteString.charCodeAt(i);
                                }

                                const blob = new Blob([ab], { type: 'image/jpeg' });
                                const file = new File([blob], `image_${index}.jpg`, { type: 'image/jpeg' });
                                formData.append('files', file);
                            } catch (error) {
                            }
                        }
                        else if (typeof image === 'string' && image.startsWith('http')) {
                        }
                    }
                });
            }

            const parkingId = this.getExistingParkingId();

            if (parkingId) {
                this.apiService.updateParkingPatch(parkingId as string, parkingPayload).subscribe({
                    next: async () => {
                        const uploadedFiles = this.getUploadFiles();

                        if (uploadedFiles.length > 0) {
                            try {
                                await this.apiService.uploadParkingImages(parkingId as string, uploadedFiles).toPromise();
                            } catch (uploadError) {
                            }
                        }

                        this.isSubmitting.set(false);

                        this.saveCombinedData();

                        localStorage.removeItem('selectedParkingId');
                        localStorage.removeItem('combinedParkingData');
                        sessionStorage.removeItem('combinedParkingData');

                        const finalParkingId = parkingId || this.parkingId;
                        if (finalParkingId) {
                            sessionStorage.setItem('parking_id', finalParkingId);
                            localStorage.setItem('parking_id', finalParkingId);
                        }

                        this.router.navigate(['/parking-add-capacity']);
                    },
                    error: () => {
                        this.isSubmitting.set(false);
                    }
                });
            } else {
                const formDataWithoutFiles = new FormData();
                formDataWithoutFiles.append('data', JSON.stringify(parkingPayload));

                this.apiService.createParkingWithFormData(formDataWithoutFiles).subscribe({
                    next: (response) => {
                        const responseData = response as any;
                        const createdParkingId = responseData?.data?.id || responseData?.id;

                        this.isSubmitting.set(false);

                        this.router.navigate(['/parking-add-capacity']);
                    },
                    error: () => {
                        this.isSubmitting.set(false);
                    }
                });
            }
        } catch (error) {
            this.isSubmitting.set(false);
        }
    }

    private buildOperatingHours(): any {
        const open24Hours = this.locationForm.get('open24Hours')?.value;
        const timeZone = this.locationForm.get('timeZoneValue')?.value || ((typeof Intl !== 'undefined' && Intl.DateTimeFormat) ? Intl.DateTimeFormat().resolvedOptions().timeZone : 'UTC');

        const timezoneMatch = timeZone.match(/\(([^)]+)\)$/);
        const extractedTimezone = timezoneMatch ? timezoneMatch[1] : (this.locationForm.get('timeZoneValue')?.value || ((typeof Intl !== 'undefined' && Intl.DateTimeFormat) ? Intl.DateTimeFormat().resolvedOptions().timeZone : 'UTC'));

        const openDays: string[] = [];
        if (this.locationForm.get('monday')?.value) openDays.push('mon');
        if (this.locationForm.get('tuesday')?.value) openDays.push('tue');
        if (this.locationForm.get('wednesday')?.value) openDays.push('wed');
        if (this.locationForm.get('thursday')?.value) openDays.push('thu');
        if (this.locationForm.get('friday')?.value) openDays.push('fri');
        if (this.locationForm.get('saturday')?.value) openDays.push('sat');
        if (this.locationForm.get('sunday')?.value) openDays.push('sun');

        if (openDays.length === 0) {
            openDays.push('mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun');
        }

        let openTime = '08:00';
        let closeTime = '22:00';

        const isOpen24Hours = this.locationForm.get('open24Hours')?.value === true;

        if (isOpen24Hours) {
            openTime = '00:00';
            closeTime = '23:59';
        } else {
            const formOpenTime = this.locationForm.get('openTimeValue')?.value;
            const formCloseTime = this.locationForm.get('closeTimeValue')?.value;

            if (formOpenTime) {
                openTime = formOpenTime;
            }
            if (formCloseTime) {
                closeTime = formCloseTime;
            }
        }

        const operatingHours = {
            "timezone": extractedTimezone,
            "open_days": openDays,
            "open_time": openTime?.toString() || '-',
            "close_time": closeTime?.toString() || '-'
        };
        return operatingHours;
    }

    protected parkingTypes = [
        {
            title: 'Standalone Parking Lots',
            icon: 'assets/images/icons/Standalone%20Parking%20Lots.svg?v=' + Date.now()
        },
        {
            title: 'Apartments & Gated Communities',
            icon: 'assets/images/icons/Apartments%20%26%20Gated%20Communities.svg?v=' + Date.now()
        },
        {
            title: 'Malls & Shopping Complexes',
            icon: 'assets/images/icons/Malls%20%26%20Shopping%20Complexes.svg?v=' + Date.now()
        },
        {
            title: 'On-Street & Smart City Zones',
            icon: 'assets/images/icons/On-Street%20%26%20Smart%20City%20Zones.svg?v=' + Date.now()
        },
        {
            title: 'Hotels & Resorts',
            icon: 'assets/images/icons/Hotel%20and%20Resort.svg?v=' + Date.now()
        },
        {
            title: 'Offices & Commercial Towers',
            icon: 'assets/images/icons/Offices%20%26%20Commercial%20Towers.svg?v=' + Date.now()
        },
        {
            title: 'Stadiums, Arenas & Event Venues',
            icon: 'assets/images/icons/Stadiums%2C%20Arenas%20%26%20Event%20Venues.svg?v=' + Date.now()
        },
        {
            title: 'Airports & Transit Hubs',
            icon: 'assets/images/icons/Airports%20%26%20Transit%20Hubs.svg?v=' + Date.now()
        },
        {
            title: 'Industrial & Warehousing',
            icon: 'assets/images/icons/Industrial%20%26%20Warehousing.svg?v=' + Date.now()
        }
    ]

    protected selectCard(index: number): void {
        this.selectedCardIndex.set(index);
        this.parkingTypeSelected.set(true);

        this.autoSaveData().catch(() => { });
    }

    protected isCardActive(index: number): boolean {
        const isActive = this.selectedCardIndex() === index;
        return isActive;
    }

    protected locationForm = new FormGroup({
        countryValue: new FormControl({ value: '', disabled: true }, Validators.required),
        addressValue: new FormControl('', Validators.required),
        addressLine2Value: new FormControl(''),
        timeZoneValue: new FormControl((typeof Intl !== 'undefined' && Intl.DateTimeFormat) ? Intl.DateTimeFormat().resolvedOptions().timeZone : '', Validators.required),
        currencyValue: new FormControl('', Validators.required),
        languageValue: new FormControl('', Validators.required),
        taxNameValue: new FormControl('', Validators.required),
        stateValue: new FormControl('', Validators.required),
        cityValue: new FormControl('', Validators.required),
        postalCodeValue: new FormControl('', Validators.required),
        latitudeValue: new FormControl('', Validators.required),
        longitudeValue: new FormControl('', Validators.required),
        parkingName: new FormControl('', Validators.required),
        descriptionValue: new FormControl('', [Validators.required, Validators.minLength(6)]),
        allDay: new FormControl(false),
        open24Hours: new FormControl(false),
        openTimeValue: new FormControl(''),
        closeTimeValue: new FormControl(''),
        monday: new FormControl(false),
        tuesday: new FormControl(false),
        wednesday: new FormControl(false),
        thursday: new FormControl(false),
        friday: new FormControl(false),
        saturday: new FormControl(false),
        sunday: new FormControl(false),
    });

    protected onSubmit(): void {
        if (this.locationForm.valid) {
        } else {
        }
    }

    protected onKeyPress(event: KeyboardEvent): void {
        if (event.key === 'Enter') {
            this.onSubmit();
        }
    }

    protected testProgress(): void {
        this.currentStep.update(step => step);
    }

    protected testFormPopulation(): void {
        const testData = {
            addressValue: '123 Test Street, Test City, Test State 12345',
            cityValue: 'Test City',
            countryValue: 'India',
            postalCodeValue: '12345',
            stateValue: 'Test State',
            latitudeValue: '20.5937',
            longitudeValue: '78.9629'
        };

        this.locationForm.patchValue(testData);
        this.locationForm.updateValueAndValidity();
        this.locationForm.get('countryValue')?.disable();
    }

    private isLoadingFromApi = false;

    ngOnInit(): void {
        this.roleService.setAppLoading(false);

        const urlParams = new URLSearchParams(window.location.search);

        const isFreshStartInitial = this.route.snapshot.queryParams['fresh'] === 'true' ||
            urlParams.get('fresh') === 'true' ||
            sessionStorage.getItem('force_fresh_start') === 'true';

        if (isFreshStartInitial) {
            this.clearSavedData(false);
            sessionStorage.removeItem('force_fresh_start');
            this.selectedCardIndex.set(-1);
            this.parkingTypeSelected.set(false);
            this.router.navigate([], {
                relativeTo: this.route,
                queryParams: { fresh: null },
                queryParamsHandling: 'merge',
                replaceUrl: true
            });
        } else if (window.location.pathname.includes('/parkings/create/parking-type') && !urlParams.get('parkingId')) {
            const existingParkingId = sessionStorage.getItem('parking_id') || localStorage.getItem('parking_id');
            if (!existingParkingId) {
                this.clearSavedData(false);
            }
        }

        const urlParkingId = urlParams.get('parkingId');
        const isExplicitEditMode = urlParkingId && urlParams.get('mode') === 'edit';

        const savedState = sessionStorage.getItem('combinedParkingData');
        const savedParkingId = sessionStorage.getItem('parking_id') || localStorage.getItem('parking_id');

        if (urlParkingId && savedParkingId && savedParkingId !== urlParkingId) {
            this.clearSavedData(true);
        }

        const effectiveParkingId = urlParkingId || savedParkingId;

        if (urlParkingId && isExplicitEditMode) {
            this.parkingIdForSaveExit.set(urlParkingId);
            this.parkingId = urlParkingId;
            sessionStorage.setItem('parking_id', urlParkingId);
            localStorage.setItem('parking_id', urlParkingId);
            this.isEditMode = true;
            this.isLoadingFromApi = true;
            this.loadParkingDataForAutoFill(urlParkingId);
        } else if (!isExplicitEditMode && savedState && savedParkingId) {
            this.parkingIdForSaveExit.set(savedParkingId);
            this.parkingId = savedParkingId;
            sessionStorage.setItem('parking_id', savedParkingId);
            localStorage.setItem('parking_id', savedParkingId);
        } else if (effectiveParkingId && !savedState) {
            this.parkingIdForSaveExit.set(effectiveParkingId);
            this.parkingId = effectiveParkingId;
            sessionStorage.setItem('parking_id', effectiveParkingId);
            localStorage.setItem('parking_id', effectiveParkingId);
            this.isLoadingFromApi = true;
            this.loadParkingDataForAutoFill(effectiveParkingId);
        }

        if (effectiveParkingId && !isFreshStartInitial) {
            const persistedStep = this.getPersistedWizardStep(effectiveParkingId);
            if (persistedStep) {
                this.currentStep.set(persistedStep);
            }
        }

        this.route.url.subscribe(segments => {
            const last = segments.length ? segments[segments.length - 1].path : '';

            let target: number | null = null;
            const stepMatch = last.match(/^step(\d{1,2})$/);
            if (stepMatch) {
                target = parseInt(stepMatch[1], 10);
            } else if (last) {
                target = this.slugToStep[last] ?? null;
            }

            const urlParams = new URLSearchParams(window.location.search);
            const hasParkingIdInUrl = urlParams.get('parkingId') !== null;
            const isFreshStart = urlParams.get('fresh') === 'true';

            if (last === 'parking-type' && isFreshStart && !hasParkingIdInUrl && !this.isLoadingFromApi && !this.isEditMode) {
                this.parkingTypeSelected.set(false);
            }

            const isDefaultWizardEntry = last === 'parking-type' || last === 'create' || !last;
            const shouldIgnoreDefaultSlug = (this.isEditMode || hasParkingIdInUrl) &&
                isDefaultWizardEntry &&
                this.currentStep() !== 1 &&
                !isFreshStart;

            if (target && target >= 1 && target <= this.totalSteps && !shouldIgnoreDefaultSlug) {
                const previousStep = this.currentStep();
                if (target !== this.currentStep()) {
                    this.stepFromUrl = target;
                    this.currentStep.set(target);
                    this.persistWizardStep(target);
                }

                if (target === 2) setTimeout(() => this.loadMap(), 300);

                if (!(previousStep === 2 && target === 3)) {
                    this.loadStepData(target);
                }

                if (target === 3) {
                    setTimeout(() => this.ensureFormIsPopulated(), 100);
                }
                if (target === 8) {
                    setTimeout(() => this.hydrateReviewData(), 100);
                }
            }
        });

        this.updateUrlWithCurrentStep(true);

        this.route.queryParams.subscribe(params => {
            const urlParkingId = params['parkingId'];
            if (urlParkingId && params['mode'] === 'edit') {
                const currentSavedId = sessionStorage.getItem('parking_id') || localStorage.getItem('parking_id');
                if (currentSavedId && currentSavedId !== urlParkingId) {
                    this.clearSavedData(true);
                }
                this.isEditMode = true;
                this.parkingId = urlParkingId;
                this.parkingIdForSaveExit.set(this.parkingId);
                sessionStorage.setItem('parking_id', urlParkingId);
                localStorage.setItem('parking_id', urlParkingId);
                this.loadParkingDataFromAPI();
            } else {
                const hasSavedState = sessionStorage.getItem('combinedParkingData');
                const currentParkingId = sessionStorage.getItem('parking_id');

                if (hasSavedState) {
                    this.loadSavedData();
                } else if (!currentParkingId) {
                    this.loadSavedData();
                }
            }
        });

        this.loadRegions();
        this.loadOrganizationDetails();
        this.setOrganizationTimezone();

        if (this.currentStep() === 4 || this.currentStep() === 5) {
            setTimeout(() => {
                this.ensureTimezoneIsSetFromOrganization();
            }, 500);
        }

        this.loadTeamMembers();
        this.preloadCommonCountryCoordinates();

        if (this.currentStep() === 8) {
            setTimeout(() => this.hydrateReviewData(), 50);
        }

        setTimeout(() => {
            this.showCurrentUserCountryInfo();
        }, 2000);

        setTimeout(() => {
            if (this.currentStep() === 2 && !this.isOrganizationLoading()) {
                this.loadMap();
            }
        }, 3000);

        this.initializeMapAPI();
        this.loadRecentSearches();

        const savedCountryData = sessionStorage.getItem('parkingsStep4Data');
        if (!savedCountryData) {
            this.loadCountryRegion();
        } else {
            try {
                const data = JSON.parse(savedCountryData);
                if (!data.locationFormData || !data.locationFormData.countryValue) {
                    this.loadCountryRegion();
                }
            } catch (error) {
                this.loadCountryRegion();
            }
        }

        this.searchQuery.set('');

        setTimeout(() => {
            const searchInput = document.querySelector('.search-input') as HTMLInputElement;
            if (searchInput) {
                searchInput.value = '';
            }
        }, 1000);

        if (this.marker) {
            this.hideMarker();
        }

        this.forceUpdateCountry();
    }

    private fetchRegionIdFromApi(organization: any): void {
        let countryCode = 'IN';
        let countryName = 'India';

        if (organization.address && organization.address.country) {
            countryName = organization.address.country;
            countryCode = this.getCountryCodeFromName(countryName);
        } else if (organization.region && organization.region.country_name) {
            countryName = organization.region.country_name;
            countryCode = this.getCountryCodeFromName(countryName);
        }

        this.apiService.getRegions().subscribe({
            next: (response: any) => {
                let regions = response;
                if (response && response.data) {
                    regions = response.data;
                }

                if (Array.isArray(regions)) {
                    const region = regions.find((r: any) => r.country_code === countryCode);

                    if (region && region.id) {
                        this.organizationRegionId.set(region.id);
                    } else {
                        const regionByName = regions.find((r: any) =>
                            r.name?.toLowerCase().includes(countryName.toLowerCase())
                        );

                        if (regionByName && regionByName.id) {
                            this.organizationRegionId.set(regionByName.id);
                        }
                    }
                }
            },
            error: (error: any) => {
            }
        });
    }

    protected loadOrganizationDetails(): void {
        this.isOrganizationLoading.set(true);

        const organizationId = this.apiService.getCurrentOrganizationId();

        if (!organizationId) {
            this.organizationCountry.set('IN');
            this.selectedCountry.set('IN');
            this.isOrganizationLoading.set(false);
            return;
        }

        this.apiService.getOrganization(organizationId).subscribe({
            next: (response: any) => {
                let organization = response;
                if (response && response.data) {
                    organization = response.data;
                }

                if (organization && organization.name) {
                    if (organization.preferred_timezone) {
                        const convertedTimezone = this.timezoneConverterService.extractTimezoneFromString(organization.preferred_timezone);
                        this.organizationTimezone.set(convertedTimezone);
                    }

                    if (organization.preferred_currency_code) {
                        this.organizationCurrency.set(organization.preferred_currency_code);
                    }

                    if (organization.region_id) {
                        this.organizationRegionId.set(organization.region_id);
                    } else {
                        this.fetchRegionIdFromApi(organization);
                    }

                    let countryCode = 'IN';
                    let countryName = 'India';

                    if (organization.address && organization.address.country) {
                        countryName = organization.address.country;
                        countryCode = this.getCountryCodeFromName(countryName);

                        if (countryCode && countryCode !== 'IN') {
                            this.organizationCountry.set(countryCode);
                            this.selectedCountry.set(countryCode);
                            this.setSearchPlaceholderForCountry(countryName);
                            this.locationForm.get('countryValue')?.setValue(countryName);
                            this.updateTimezoneOptionsForCountry(countryCode);
                            this.countryCoordinatesService.getCoordinatesAsync(countryCode).then((coords) => {
                                this.updateMapCoordinatesForCountry(countryCode);
                                setTimeout(() => {
                                    this.reloadMapWithCountry();
                                }, 500);
                            });
                            setTimeout(() => {
                                this.loadPopularPlacesInCountry(countryName);
                            }, 1000);
                        }
                    } else if (organization.region_id) {
                        countryName = this.getCountryFromRegionId(organization.region_id);

                        if (countryName && countryName !== 'N/A') {
                            countryCode = this.getCountryCodeFromName(countryName);
                            this.organizationCountry.set(countryCode);
                            this.selectedCountry.set(countryCode);
                            this.setSearchPlaceholderForCountry(countryName);
                            setTimeout(() => {
                                this.loadPopularPlacesInCountry(countryName);
                            }, 1000);
                            this.updateTimezoneOptionsForCountry(countryCode);
                        }
                    }

                    this.updateMapCoordinatesForCountry(countryCode);

                    setTimeout(() => {
                        this.reloadMapWithCountry();
                    }, 500);

                } else {
                    this.organizationCountry.set('IN');
                    this.selectedCountry.set('IN');
                }

                this.isOrganizationLoading.set(false);
            },
            error: (error: any) => {
                this.organizationCountry.set('IN');
                this.selectedCountry.set('IN');
                this.isOrganizationLoading.set(false);
            }
        });
    }

    protected updateTimezoneOptionsForCountry(countryCode: string, preferredTimezone?: string | null): void {
        if (!countryCode) {
            return;
        }

        const orgTimezone = preferredTimezone || this.organizationTimezone() || this.locationForm.get('timeZoneValue')?.value;

        this.countryRegionService.getTimezonesForCountry(countryCode).subscribe({
            next: (list) => {
                const rawList = Array.isArray(list) ? list : [];
                const timezones = Array.from(new Set(rawList));
                this.timezonesForSelectedCountry = timezones;
                this.hasMultipleTimezones = timezones.length > 1;

                if (timezones.length > 0) {
                    let timezoneToSet = timezones[0];
                    if (orgTimezone) {
                        const foundTimezone = timezones.find(tz =>
                            tz === orgTimezone ||
                            tz.includes(orgTimezone) ||
                            orgTimezone.includes(tz) ||
                            tz.toLowerCase().includes(orgTimezone.toLowerCase())
                        );
                        if (foundTimezone) {
                            timezoneToSet = foundTimezone;
                        }
                    }
                    this.locationForm.get('timeZoneValue')?.setValue(timezoneToSet);
                } else if (orgTimezone) {
                    this.timezonesForSelectedCountry = [orgTimezone];
                    this.hasMultipleTimezones = false;
                    this.locationForm.get('timeZoneValue')?.setValue(orgTimezone);
                }
                this.cdr.markForCheck();
            },
            error: () => {
                if (orgTimezone) {
                    this.timezonesForSelectedCountry = [orgTimezone];
                    this.hasMultipleTimezones = false;
                    this.locationForm.get('timeZoneValue')?.setValue(orgTimezone);
                }
                this.cdr.markForCheck();
            }
        });
    }

    protected ensureTimezoneIsSetFromOrganization(): void {
        const countryValue = this.locationForm.get('countryValue')?.value;
        let countryCode = this.getCountryCodeFromName(countryValue || '');
        if (!countryCode) {
            countryCode = this.organizationCountry();
        }

        const organizationId = this.apiService.getCurrentOrganizationId();

        if (!organizationId) {
            if (countryCode) {
                this.updateTimezoneOptionsForCountry(countryCode);
            }
            return;
        }

        this.apiService.getOrganization(organizationId).subscribe({
            next: (response: any) => {
                let organization: any = null;

                if (response && response.data) {
                    organization = response.data;
                } else if (response && response.success && response.data) {
                    organization = response.data;
                } else {
                    organization = response;
                }

                if (!countryCode && organization?.address?.country) {
                    countryCode = this.getCountryCodeFromName(organization.address.country || '');
                }
                if (countryCode) {
                    this.organizationCountry.set(countryCode);
                }

                const preferredTimezone = organization?.preferred_timezone;
                let convertedTimezone = '';

                if (preferredTimezone) {
                    convertedTimezone = this.timezoneConverterService.extractTimezoneFromString(preferredTimezone);
                    this.organizationTimezone.set(convertedTimezone);
                }

                const tzToUse = convertedTimezone || this.organizationTimezone() || this.locationForm.get('timeZoneValue')?.value || undefined;

                if (countryCode) {
                    this.updateTimezoneOptionsForCountry(countryCode, tzToUse);
                } else if (tzToUse) {
                    this.hasMultipleTimezones = false;
                    this.timezonesForSelectedCountry = [tzToUse];
                    this.locationForm.get('timeZoneValue')?.setValue(tzToUse);
                    this.cdr.markForCheck();
                }
            },
            error: () => {
                const tzToUse = this.organizationTimezone() || this.locationForm.get('timeZoneValue')?.value || undefined;
                if (countryCode) {
                    this.updateTimezoneOptionsForCountry(countryCode, tzToUse);
                } else if (tzToUse) {
                    const formattedTimezone = this.timezoneConverterService.extractTimezoneFromString(tzToUse);
                    this.locationForm.get('timeZoneValue')?.setValue(formattedTimezone);
                    this.cdr.markForCheck();
                }
            }
        });
    }

    protected loadRegions(): void {
        this.apiService.getRegions().subscribe({
            next: (regionResp) => {
                let regions = regionResp;
                if (regionResp && regionResp.data) {
                    regions = regionResp.data;
                }

                if (Array.isArray(regions)) {
                    this.regionMap = {};

                    regions.forEach(region => {
                        if (region.id) {
                            this.regionMap[region.id] = {
                                countryName: region.country_name || 'N/A',
                                regionName: region.region || 'N/A',
                                subregion: region.subregion || 'N/A'
                            };
                        }
                    });
                }
            },
            error: (error) => {
                this.regionMap = {};
            }
        });
    }

    protected getCountryFromRegionId(regionId: string): string {
        if (this.regionMap[regionId]) {
            const countryName = this.regionMap[regionId].countryName;
            return countryName;
        } else {
            return 'N/A';
        }
    }

    protected loadPopularPlacesInCountry(countryName: string): void {
        if (!countryName || countryName === 'N/A') {
            return;
        }

        const countryCode = this.getCountryCodeFromName(countryName);

        if (typeof google === 'undefined') {
            setTimeout(() => {
                this.loadPopularPlacesInCountry(countryName);
            }, 2000);
            return;
        }

        const service = new google.maps.places.AutocompleteService();

        const placeTypes = [
            'administrative_area_level_1', 'administrative_area_level_2',
            'locality', 'sublocality', 'neighborhood'
        ];

        placeTypes.forEach(type => {
            service.getPlacePredictions(
                {
                    input: countryName,
                    types: [type],
                    componentRestrictions: { country: countryCode }
                },
                (predictions: any, status: any) => {
                    if (status === google.maps.places.PlacesServiceStatus.OK && predictions) {
                        const currentPopular = this.popularLocations();
                        const newPlaces = predictions.slice(0, 3).map((prediction: any) => ({
                            name: prediction.description,
                            place_id: prediction.place_id,
                            type: type,
                            country: countryName
                        }));

                        const allPlaces = [...currentPopular, ...newPlaces];
                        const uniquePlaces = allPlaces.filter((place, index, self) =>
                            index === self.findIndex(p => p.place_id === place.place_id)
                        );

                        this.popularLocations.set(uniquePlaces.slice(0, 10));
                    }
                }
            );
        });
    }

    protected getPredictionScore(prediction: any): number {
        let score = 0;

        if (prediction.types && prediction.types.length > 0) {
            const types = prediction.types;
            if (types.includes('locality')) score += 10;
            if (types.includes('establishment')) score += 8;
            if (types.includes('sublocality')) score += 6;
            if (types.includes('neighborhood')) score += 5;
            if (types.includes('administrative_area_level_1')) score += 4;
            if (types.includes('administrative_area_level_2')) score += 3;
            if (types.includes('geocode')) score += 2;
        }

        return score;
    }

    protected getCountryNameFromCode(countryCode: string): string {
        return this.countryCoordinatesService.getCountryName(countryCode);
    }

    private getResumeStep(parkingData: any, parkingId?: string | null): number {
        const targetId = parkingId || parkingData?.id || this.getExistingParkingId();
        const persisted = this.getPersistedWizardStep(targetId);
        if (persisted) {
            return persisted;
        }

        const apiStep = Number(
            parkingData?.wizard_step ??
            parkingData?.current_step ??
            parkingData?.setup_step
        );
        if (apiStep >= 1 && apiStep <= this.totalSteps) {
            this.persistWizardStep(apiStep, targetId);
            return apiStep;
        }

        if (!parkingData) return 1;

        const manager = parkingData.managedBy || parkingData.manager;
        if (manager && (manager.id || manager.name || manager.email)) {
            return 8;
        }

        const hasImages = parkingData.images && Array.isArray(parkingData.images) && parkingData.images.length > 0;
        if (hasImages) {
            return 7;
        }

        const opHours = parkingData.operating_hours || parkingData.operatingHours;
        const hasHours = !!(opHours && (opHours.open_time || opHours.open_days || opHours.openTime));
        if (hasHours) {
            return 6;
        }

        const hasAmenities = parkingData.amenities && Array.isArray(parkingData.amenities) && parkingData.amenities.length > 0;
        if (hasAmenities) {
            return 5;
        }

        const address = parkingData.address || parkingData.location;
        const hasAddressDetails = !!(address && (address.address_line_1 || address.city || address.postal_code || address.postalCode));
        if (hasAddressDetails) {
            return 4;
        }

        const hasLocation = !!(address && (address.latitude || address.lat || address.longitude || address.lng));
        if (hasLocation) {
            return 3;
        }

        if (parkingData.parking_type || parkingData.parkingType || parkingData.name) {
            return 2;
        }

        return 1;
    }

    private loadParkingDataFromAPI(): void {
        if (!this.parkingId) {
            return;
        }

        this.apiService.getParkingDetail(this.parkingId).subscribe({
            next: (response) => {
                if (response && response.data) {
                    const parkingData = response.data;
                    this.populateFormWithAPIData(parkingData);
                    this.autoFillAllFields(parkingData);
                    sessionStorage.setItem('parking_id', this.parkingId!);
                    localStorage.setItem('parking_id', this.parkingId!);
                    this.parkingIdForSaveExit.set(this.parkingId);

                    if (!this.stepFromUrl) {
                        const resumeStep = this.getResumeStep(parkingData, this.parkingId);
                        this.currentStep.set(resumeStep);
                        this.persistWizardStep(resumeStep, this.parkingId);
                        this.updateUrlWithCurrentStep(true);
                        this.loadStepData(resumeStep);
                    }
                }
            },
            error: (error) => {
                this.notificationService.showError('Error loading parking data. Please try again.', 3000);
            }
        });
    }

    private loadParkingDataForAutoFill(parkingId: string): void {
        if (!this.apiService || !parkingId || parkingId.trim() === '') {
            return;
        }

        this.apiService.getParkingDetail(parkingId).subscribe({
            next: (response) => {
                let parkingData = null;

                if (response && response.data) {
                    parkingData = response.data;
                } else if (response && (response as any).id) {
                    parkingData = response as any;
                }

                if (parkingData) {
                    this.autoFillAllFields(parkingData);
                    this.isLoadingFromApi = false;

                    if (!this.stepFromUrl) {
                        const resumeStep = this.getResumeStep(parkingData, parkingId);
                        this.currentStep.set(resumeStep);
                        this.persistWizardStep(resumeStep, parkingId);
                        this.updateUrlWithCurrentStep(true);
                        this.loadStepData(resumeStep);
                    }
                } else {
                    this.isLoadingFromApi = false;
                }
            },
            error: (error) => {
                this.isLoadingFromApi = false;
                this.loadSavedData();
            },
            complete: () => {
                if (this.currentStep() === 5) {
                    setTimeout(() => {
                        this.ensureTimezoneIsSetFromOrganization();
                    }, 300);
                }
            }
        });
    }

    private hasStoredManualMapSelection(): boolean {
        try {
            const raw = localStorage.getItem('parkings_manual_location_selection');
            if (!raw) {
                return false;
            }
            const parsed = JSON.parse(raw);
            return !!(parsed?.latitudeValue || parsed?.longitudeValue || parsed?.addressValue);
        } catch {
            return false;
        }
    }

    private autoFillAllFields(parkingData: any): void {
        const keepManualLocation = this.hasManualLocationSelection || this.hasStoredManualMapSelection();
        if (keepManualLocation) {
            this.hasManualLocationSelection = true;
            this.loadMapSelectionFromLocalStorage();
            const formLat = this.locationForm.get('latitudeValue')?.value;
            const formLng = this.locationForm.get('longitudeValue')?.value;

            if (!this.selectedLocation() && formLat && formLng) {
                this.selectedLocation.set({
                    lat: parseFloat(formLat),
                    lng: parseFloat(formLng)
                });
            }
        }

        if (parkingData.parking_type) {
            if (!this.parkingTypeSelected() || this.selectedCardIndex() < 0) {
                const parkingTypeIndex = this.parkingTypes.findIndex(
                    type => type.title === parkingData.parking_type
                );
                if (parkingTypeIndex !== -1) {
                    this.selectedCardIndex.set(parkingTypeIndex);
                    this.parkingTypeSelected.set(true);
                }
            }
        }

        if (parkingData.address && !this.hasManualLocationSelection) {
            const address = parkingData.address;
            const currentPostalCode = this.locationForm.get('postalCodeValue')?.value;
            const currentLatitude = this.locationForm.get('latitudeValue')?.value;
            const currentLongitude = this.locationForm.get('longitudeValue')?.value;

            if (address.latitude && address.longitude) {
                this.selectedLocation.set({
                    lat: parseFloat(address.latitude),
                    lng: parseFloat(address.longitude)
                });
            }

            const formData: any = {
                addressValue: address.address_line_1 || '',
                addressLine2Value: address.address_line_2 || '',
                cityValue: address.city || '',
                stateValue: address.state || '',
                countryValue: address.country || '',
                postalCodeValue: address.postal_code || currentPostalCode || '',
                latitudeValue: address.latitude || currentLatitude || '',
                longitudeValue: address.longitude || currentLongitude || ''
            };

            this.locationForm.patchValue(formData);

            if (address.address_line_1) {
                this.searchQuery.set(address.address_line_1);
            }
        }

        if (parkingData.name) {
            this.locationForm.patchValue({
                parkingName: parkingData.name
            });
        }

        if (parkingData.description) {
            this.locationForm.patchValue({
                descriptionValue: parkingData.description
            });
        }

        if (parkingData.amenities && Array.isArray(parkingData.amenities) && parkingData.amenities.length > 0) {
            const selectedIndices: number[] = [];
            parkingData.amenities.forEach((amenityName: string) => {
                const index = this.parkingFeatures.findIndex(
                    feature => feature.title === amenityName
                );
                if (index !== -1) {
                    selectedIndices.push(index);
                }
            });
            this.selectedFeatures.set(selectedIndices);
            this.updateSelectedAmenityIcons();
        } else if (this.selectedFeatures().length === 0) {
            this.loadAmenitiesData();
        }

        const opHours = parkingData.operating_hours || parkingData.operatingHours;
        if (opHours) {
            const is24Hours = opHours.open_time === '00:00' && opHours.close_time === '23:59';
            const allDays = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
            const isAllDays = opHours.open_days && Array.isArray(opHours.open_days) && opHours.open_days.length === 7 &&
                allDays.every((day: string) => opHours.open_days.includes(day));

            this.locationForm.patchValue({
                open24Hours: is24Hours,
                openTimeValue: opHours.open_time || '',
                closeTimeValue: opHours.close_time || ''
            });

            if (opHours.open_days && Array.isArray(opHours.open_days)) {
                this.locationForm.patchValue({
                    monday: opHours.open_days.includes('mon'),
                    tuesday: opHours.open_days.includes('tue'),
                    wednesday: opHours.open_days.includes('wed'),
                    thursday: opHours.open_days.includes('thu'),
                    friday: opHours.open_days.includes('fri'),
                    saturday: opHours.open_days.includes('sat'),
                    sunday: opHours.open_days.includes('sun')
                });
            }
        }

        if (parkingData.timeZone) {
            this.locationForm.patchValue({
                timeZoneValue: parkingData.timeZone
            });
        }

        if (parkingData.images && Array.isArray(parkingData.images) && parkingData.images.length > 0) {
            this.existingImages = [...parkingData.images];
            this.updateCarouselItems();
        }

        if (parkingData.region_id) {
            this.organizationRegionId.set(parkingData.region_id);
        }

        if (parkingData.managedBy || parkingData.manager) {
            const manager = parkingData.managedBy || parkingData.manager;
            if (manager) {
                this.selectedTeamMember = manager;
                this.selectedTeamValue = manager;
                this.selectedTeamDisplayValue = this.getUserDisplayName(manager);
                this.managerAlreadyAssigned = true;
                this.managerAssignmentChecked = true;
                this.managerAssignmentCompleted = true;
                const managerId = this.getUserId(manager);
                if (managerId) {
                    this.assignedManagerId = managerId;
                }
            }
        }

        this.locationForm.get('countryValue')?.disable();

        this.locationForm.updateValueAndValidity();

        if (this.currentStep() === 2 && this.selectedLocation()) {
            setTimeout(() => {
                this.loadMap();
                this.restoreMapCenterIfNeeded();
            }, 500);
        }

        if (this.currentStep() === 5) {
            setTimeout(() => {
                this.ensureTimezoneIsSetFromOrganization();
            }, 500);
        }
    }

    private populateFormWithAPIData(parkingData: any): void {
        if (parkingData.address) {
            this.locationForm.get('addressValue')?.setValue(parkingData.address);
        }

        if (parkingData.city) {
            this.locationForm.get('cityValue')?.setValue(parkingData.city);
        }

        if (parkingData.state) {
            this.locationForm.get('stateValue')?.setValue(parkingData.state);
        }

        if (parkingData.country) {
            this.locationForm.get('countryValue')?.setValue(parkingData.country);
            this.locationForm.get('countryValue')?.disable();
        }

        if (parkingData.pincode) {
            this.locationForm.get('postalCodeValue')?.setValue(parkingData.pincode);
        }

        if (parkingData.point && parkingData.point.coordinates) {
            const [lng, lat] = parkingData.point.coordinates;
            this.selectedLocation.set({ lat, lng });
            this.locationForm.get('latitudeValue')?.setValue(lat.toString());
            this.locationForm.get('longitudeValue')?.setValue(lng.toString());
        }
    }

    private hydrateReviewData(): void {
        this.loadParkingTypeFromLocalStorage();
        this.loadFormFromLocalStorage();
        this.loadMapSelectionFromLocalStorage();
        this.loadAmenitiesData();
        this.loadOperatingHoursData();
        this.loadTeamMemberData();
        this.loadParkingImagesFromLocalStorage();
        this.setDefaultReviewData();
        this.updateCarouselItems();
        this.cdr.markForCheck();
        this.loadReviewDataFromAPI();
    }

    private loadReviewDataFromAPI(): void {
        this.setDefaultReviewData();
        this.cdr.markForCheck();

        try {
            const parkingId = this.getExistingParkingId() ||
                this.parkingId ||
                sessionStorage.getItem('parking_id');

            if (!parkingId) {
                this.loadTeamMemberData();
                this.updateReviewManagerName();
                this.cdr.markForCheck();
                return;
            }

            this.apiService.getParkingDetail(parkingId).subscribe({
                next: (resp: any) => {
                    const data = resp?.data || resp;
                    if (!data) {
                        this.loadTeamMemberData();
                        this.updateReviewManagerName();
                        this.cdr.markForCheck();
                        return;
                    }

                    if (data.managedBy || data.manager) {
                        const manager = data.managedBy || data.manager;
                        const managerId = this.getUserId(manager);
                        if (managerId) {
                            this.assignedManagerId = managerId;
                            this.managerAlreadyAssigned = true;
                            this.managerAssignmentChecked = true;
                            this.managerAssignmentCompleted = true;
                        }
                    }

                    const operatingHoursStr = this.formatOperatingHours(data.operating_hours || data.operatingHours) ||
                        this.parkingData?.operatingHours;
                    const { facilitiesString, vehicleTypesString } = this.formatFacilitiesAndVehicles(data.facilities || []);
                    this.loadTeamMemberData();
                    const managerUser = this.selectedTeamMember || data.managedBy || data.manager;
                    const localManagerName = this.selectedTeamDisplayValue || this.getUserDisplayName(managerUser);

                    let managerString = '';
                    if (localManagerName) {
                        managerString = localManagerName;
                    } else if (data.managedBy || data.manager) {
                        managerString = this.getUserDisplayName(data.managedBy || data.manager);
                    } else {
                        managerString = this.getUserDisplayName(this.apiService.getCurrentUser()) || 'Admin';
                    }

                    const managerRole = this.getManagerRoleForReview(managerUser);

                    let locationStr = this.getAddressFromForm();
                    if (data.address) {
                        const addr = data.address;
                        const parts = [
                            addr.address_line_1,
                            addr.city,
                            addr.state,
                            addr.postal_code,
                            addr.country
                        ].filter(Boolean);
                        if (parts.length > 0) {
                            locationStr = parts.join(', ');
                        }
                    } else {
                        const parts = [
                            data.address_line_1,
                            data.city,
                            data.state,
                            data.pincode,
                            data.country
                        ].filter(Boolean);
                        if (parts.length > 0) {
                            locationStr = parts.join(', ');
                        }
                    }

                    const parkingType = data.parking_type || data.parkingType ||
                        this.parkingTypes[this.selectedCardIndex()]?.title ||
                        this.parkingData?.parkingType;
                    const amenitiesFromApi = Array.isArray(data.amenities) && data.amenities.length > 0
                        ? data.amenities.join(', ')
                        : (typeof data.amenities === 'string' ? data.amenities : '');

                    this.parkingData = {
                        operatingHours: operatingHoursStr || this.parkingData?.operatingHours || 'All day • 24 Hours',
                        parkingName: data.name || this.locationForm.get('parkingName')?.value || this.parkingData?.parkingName,
                        parkingAddress: locationStr || this.parkingData?.parkingAddress,
                        parkingType: parkingType,
                        description: data.description || this.locationForm.get('descriptionValue')?.value || this.parkingData?.description,
                        amenities: amenitiesFromApi || this.getSelectedAmenities() || this.parkingData?.amenities,
                        facilities: facilitiesString,
                        manager: managerString || this.getUserDisplayName(this.apiService.getCurrentUser()) || 'Admin',
                        managedBy: managerRole,
                    };

                    if (Array.isArray(data.images) && data.images.length > 0) {
                        this.existingImages = [...data.images];
                    }
                    this.updateCarouselItems();

                    this.operations = {
                        'Tell us about your parking': [
                            {
                                icon: 'assets/images/icons/Parking Lots.svg',
                                name: this.parkingData.parkingName,
                                parkingType: this.parkingData.parkingType,
                                location: this.parkingData.parkingAddress,
                            },
                        ],
                        'Add details people look for': [
                            {
                                icon: 'assets/images/icons/operating hours.svg',
                                amenities: this.parkingData.amenities,
                                operations: this.parkingData.operatingHours,
                            },
                        ],
                        'Set up rules and go live': [
                            {
                                icon: 'assets/images/icons/h.svg',
                                vehicleTypes: vehicleTypesString,
                                facilities: facilitiesString,
                                manager: this.parkingData.manager,
                            },
                        ],
                    } as any;

                    this.updateSelectedAmenityIcons();
                    this.cdr.markForCheck();
                },
                error: () => {
                    this.setDefaultReviewData();
                    this.loadTeamMemberData();
                    this.updateReviewManagerName();
                    this.cdr.markForCheck();
                }
            });
        } catch (error) {
            this.setDefaultReviewData();
            this.loadTeamMemberData();
            this.updateReviewManagerName();
            this.cdr.markForCheck();
        }
    }

    private updateReviewManagerName(): void {
        const managerUser = this.selectedTeamMember;
        const managerName = this.selectedTeamDisplayValue || this.getUserDisplayName(managerUser);
        const managerRole = this.getManagerRoleForReview(managerUser);

        if (managerName && this.parkingData) {
            this.parkingData.manager = managerName;
            this.parkingData.managedBy = managerRole;

            if (this.operations && this.operations['Set up rules and go live']) {
                const ops = this.operations['Set up rules and go live'];
                if (ops && ops.length > 0 && ops[0]) {
                    ops[0].manager = managerName;
                }
            }
            this.cdr.markForCheck();
        }
    }

    private setDefaultReviewData(): void {
        try {
            const opHours = this.buildOperatingHours();
            const operatingHoursStr = this.formatOperatingHours(opHours);

            const selectedManagerName = this.getUserDisplayName(this.selectedTeamMember);
            const managerString = this.selectedTeamDisplayValue || selectedManagerName || this.getUserDisplayName(this.apiService.getCurrentUser()) || 'Admin';
            const managerRole = this.getManagerRoleForReview(this.selectedTeamMember);

            this.parkingData = {
                operatingHours: operatingHoursStr,
                parkingName: this.locationForm.get('parkingName')?.value || 'New Parking',
                parkingAddress: this.getAddressFromForm() || 'Location not specified',
                parkingType: this.parkingTypes[this.selectedCardIndex()]?.title || 'Parking lot',
                description: this.locationForm.get('descriptionValue')?.value || 'Parking description',
                amenities: this.getSelectedAmenities() || 'No amenities specified',
                facilities: '-',
                manager: managerString,
                managedBy: managerRole,
            };

            this.updateSelectedAmenityIcons();

        } catch (error) {
            this.parkingData = {
                operatingHours: 'All day • 24 Hours',
                parkingName: 'New Parking',
                parkingAddress: 'India',
                parkingType: 'Standalone Parking Lots',
                description: 'Parking description',
                amenities: 'No amenities',
                facilities: '-',
                manager: 'Not assigned',
                managedBy: '-',
            };

            this.updateSelectedAmenityIcons();
        }
    }

    private getAddressFromForm(): string {
        const parts = [
            this.locationForm.get('addressValue')?.value,
            this.locationForm.get('cityValue')?.value,
            this.locationForm.get('stateValue')?.value,
            this.locationForm.get('postalCodeValue')?.value,
            this.locationForm.get('countryValue')?.value
        ].filter(Boolean);
        return parts.length > 0 ? parts.join(', ') : '';
    }

    private getSelectedAmenities(): string {
        const amenities = this.selectedFeatures()
            .map(i => this.parkingFeatures[i]?.title)
            .filter(Boolean);
        return amenities.length > 0 ? amenities.join(', ') : 'No amenities specified';
    }

    protected getCountryCodeFromName(countryName?: string | null): string {
        if (!countryName) {
            return '';
        }
        const trimmed = countryName.trim();
        if (trimmed.length === 2) {
            return trimmed.toUpperCase();
        }
        const countryNameToCode: { [key: string]: string } = {
            'India': 'IN',
            'United States': 'US',
            'United States of America': 'US',
            'USA': 'US',
            'United Kingdom': 'GB',
            'UK': 'GB',
            'Canada': 'CA',
            'Australia': 'AU',
            'Germany': 'DE',
            'France': 'FR',
            'Japan': 'JP',
            'China': 'CN',
            'Brazil': 'BR',
            'Mexico': 'MX',
            'Singapore': 'SG',
            'United Arab Emirates': 'AE',
            'UAE': 'AE',
            'Saudi Arabia': 'SA',
            'South Africa': 'ZA',
            'Netherlands': 'NL',
            'Italy': 'IT',
            'Spain': 'ES',
            'Sweden': 'SE',
            'Norway': 'NO',
            'Denmark': 'DK',
            'Finland': 'FI',
            'Switzerland': 'CH',
            'Austria': 'AT',
            'Belgium': 'BE',
            'Ireland': 'IE',
            'New Zealand': 'NZ',
            'South Korea': 'KR',
            'Thailand': 'TH',
            'Malaysia': 'MY',
            'Indonesia': 'ID',
            'Philippines': 'PH',
            'Vietnam': 'VN',
            'Pakistan': 'PK',
            'Bangladesh': 'BD',
            'Sri Lanka': 'LK',
            'Nepal': 'NP',
            'Bhutan': 'BT',
            'Myanmar': 'MM',
            'Cambodia': 'KH',
            'Laos': 'LA',
            'Mongolia': 'MN',
            'Kazakhstan': 'KZ',
            'Uzbekistan': 'UZ',
            'Kyrgyzstan': 'KG',
            'Tajikistan': 'TJ',
            'Turkmenistan': 'TM',
            'Afghanistan': 'AF',
            'Iran': 'IR',
            'Iraq': 'IQ',
            'Kuwait': 'KW',
            'Qatar': 'QA',
            'Bahrain': 'BH',
            'Oman': 'OM',
            'Yemen': 'YE',
            'Jordan': 'JO',
            'Lebanon': 'LB',
            'Syria': 'SY',
            'Israel': 'IL',
            'Palestine': 'PS',
            'Egypt': 'EG',
            'Libya': 'LY',
            'Tunisia': 'TN',
            'Algeria': 'DZ',
            'Morocco': 'MA',
            'Sudan': 'SD',
            'South Sudan': 'SS',
            'Ethiopia': 'ET',
            'Kenya': 'KE',
            'Uganda': 'UG',
            'Tanzania': 'TZ',
            'Rwanda': 'RW',
            'Burundi': 'BI',
            'Democratic Republic of the Congo': 'CD',
            'Congo': 'CG',
            'Central African Republic': 'CF',
            'Chad': 'TD',
            'Niger': 'NE',
            'Mali': 'ML',
            'Burkina Faso': 'BF',
            'Senegal': 'SN',
            'Gambia': 'GM',
            'Guinea-Bissau': 'GW',
            'Guinea': 'GN',
            'Sierra Leone': 'SL',
            'Liberia': 'LR',
            'Ivory Coast': 'CI',
            'Ghana': 'GH',
            'Togo': 'TG',
            'Benin': 'BJ',
            'Nigeria': 'NG',
            'Cameroon': 'CM',
            'Equatorial Guinea': 'GQ',
            'Gabon': 'GA',
            'Sao Tome and Principe': 'ST',
            'Angola': 'AO',
            'Zambia': 'ZM',
            'Zimbabwe': 'ZW',
            'Botswana': 'BW',
            'Namibia': 'NA',
            'Lesotho': 'LS',
            'Eswatini': 'SZ',
            'Madagascar': 'MG',
            'Mauritius': 'MU',
            'Seychelles': 'SC',
            'Comoros': 'KM',
            'Mayotte': 'YT',
            'Reunion': 'RE',
            'Djibouti': 'DJ',
            'Eritrea': 'ER',
            'Somalia': 'SO'
        };

        if (countryNameToCode[countryName]) {
            return countryNameToCode[countryName];
        }

        const lowerCountryName = countryName.toLowerCase();
        for (const [name, code] of Object.entries(countryNameToCode)) {
            if (name.toLowerCase() === lowerCountryName) {
                return code;
            }
        }

        for (const [name, code] of Object.entries(countryNameToCode)) {
            if (name.toLowerCase().includes(lowerCountryName) || lowerCountryName.includes(name.toLowerCase())) {
                return code;
            }
        }

        return 'IN';
    }

    protected updateMapCoordinatesForCountry(countryCode: string): void {
        const countryCoords = this.getCountryCoordinates(countryCode);
        if (countryCoords) {
            this.defaultLat = countryCoords.lat;
            this.defaultLng = countryCoords.lng;
        } else {
            const defaultCoords = this.getCountryCoordinates('IN');
            this.defaultLat = defaultCoords.lat;
            this.defaultLng = defaultCoords.lng;
        }
    }

    ngAfterViewInit(): void {
        if (this.currentStep() === 2) {
            setTimeout(() => {
                this.loadMap();
            }, 500);
        }
        setTimeout(() => this.updateReadMoreVisibility(), 0);
        window.addEventListener('resize', this.updateReadMoreVisibility.bind(this));
    }

    private updateReadMoreVisibility(): void {
        try {
            const el = this.descText?.nativeElement;
            if (!el) return;
            const isOverflowing = el.scrollHeight > el.clientHeight + 1;
            this.showReadMore = isOverflowing;
        } catch (err) {
        }
    }

    protected toggleDescription(): void {
        this.isDescriptionExpanded = !this.isDescriptionExpanded;
    }

    protected initializeMapAPI(): void {
        this.apiService.loadGoogleMapsApi().catch(err => {
        });
    }

    protected loadMap(): void {
        if (this.currentStep() !== 2) {
            return;
        }

        if (!this.mapContainer) {
            setTimeout(() => {
                this.loadMap();
            }, 1000);
            return;
        }

        if (!this.mapContainer.nativeElement) {
            setTimeout(() => {
                this.loadMap();
            }, 1000);
            return;
        }

        if (typeof google === 'undefined') {
            this.apiService.loadGoogleMapsApi().then(() => {
                this.loadMap();
            }).catch(() => {
            });
            return;
        }

        try {
            const countryCode = this.organizationCountry();

            if (this.isOrganizationLoading()) {
                setTimeout(() => {
                    this.loadMap();
                }, 1000);
                return;
            }

            const countryCoords = this.getCountryCoordinates(countryCode);
            this.defaultLat = countryCoords.lat;
            this.defaultLng = countryCoords.lng;

            const mapOptions = {
                center: { lat: this.defaultLat, lng: this.defaultLng },
                zoom: 6,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                zoomControl: true,
                mapTypeControl: false,
                streetViewControl: false,
                fullscreenControl: true,
                scrollwheel: true,
                draggable: true
            };

            this.map = new google.maps.Map(this.mapContainer.nativeElement, mapOptions);
            this.applyMapRestrictions(this.map);

            this.marker = new google.maps.Marker({
                position: { lat: this.defaultLat, lng: this.defaultLng },
                map: null,
                draggable: false,
                title: 'Parking Location',
                icon: this.getCustomMarkerIcon(),
                cursor: 'default'
            });

            this.map.addListener('dragstart', () => {
                this.onMapDragStart();
            });

            this.map.addListener('dragend', () => {
                this.onMapDragEnd();
            });

            this.map.addListener('center_changed', () => {
                if (!this.isInitialMapLoad) {
                    this.updateLocationFromMapCenter();
                }
            });

            this.map.addListener('idle', () => {
                if (!this.isInitialMapLoad) {
                    this.updateLocationFromMapCenter();
                }
            });

            const currentSearchQuery = this.searchQuery();
            if (!currentSearchQuery || currentSearchQuery === '') {
                this.searchQuery.set('');
            }

            if (!this.selectedLocation()) {
                const restored = this.loadMapSelectionFromLocalStorage();
                if (!restored) {
                    this.selectedLocation.set(null);
                }
            }

            if (!currentSearchQuery || currentSearchQuery === '') {
                setTimeout(() => {
                    const searchInput = document.querySelector('.search-input') as HTMLInputElement;
                    if (searchInput) {
                        searchInput.value = '';
                    }
                }, 100);

                setTimeout(() => {
                    const searchInput = document.querySelector('.search-input') as HTMLInputElement;
                    if (searchInput) {
                        searchInput.value = '';
                    }
                }, 2000);
            }

            setTimeout(() => {
                this.isInitialMapLoad = false;

                const currentSearchQuery = this.searchQuery();
                const hasAddress = !!this.locationForm.get('addressValue')?.value;
                const hasCity = !!this.locationForm.get('cityValue')?.value;
                const loc = this.selectedLocation();

                if (loc && (!hasAddress || !hasCity)) {
                    this.reverseGeocode(loc.lat, loc.lng, true);
                } else if (!hasAddress && currentSearchQuery && currentSearchQuery.trim() !== '') {
                    this.geocodeSearchQuery(currentSearchQuery);
                }
            }, 300);

            this.map.addListener('click', (event: any) => {
                this.placeMarker(event.latLng);
            });

            this.initializeAutocomplete();
            this.addCustomCursorStyles();

            this.isMapLoaded.set(true);

            this.restoreMapCenterIfNeeded();
        } catch (error) {
            setTimeout(() => {
                this.loadMap();
            }, 2000);
        }
    }

    protected updateLocationFromMapCenter(): void {
        if (this.map && this.marker) {
            const center = this.map.getCenter();
            if (center) {
                const lat = center.lat();
                const lng = center.lng();

                if (!this.isInitialMapLoad) {
                    this.selectedLocation.set({ lat, lng });
                }

                this.marker.setPosition(center);

                this.locationForm.patchValue({
                    latitudeValue: lat.toFixed(6),
                    longitudeValue: lng.toFixed(6)
                });

                if (!this.isInitialMapLoad && this.selectedLocation() &&
                    (lat !== this.defaultLat || lng !== this.defaultLng)) {
                    this.updateSearchInputWithAddress(lat, lng);
                    this.reverseGeocode(lat, lng);
                }
            }
        }
    }

    protected restoreMapCenterIfNeeded(): void {
        const loadedFromLocalStorage = this.loadMapSelectionFromLocalStorage();

        if (this.selectedLocation()) {
            const latLng = new google.maps.LatLng(
                this.selectedLocation()!.lat,
                this.selectedLocation()!.lng
            );

            this.map.setCenter(latLng);
            this.map.setZoom(15);

            this.marker.setPosition(latLng);
            this.marker.setMap(this.map);

            if (!this.isInitialMapLoad && loadedFromLocalStorage) {
                const address = this.locationForm.get('addressValue')?.value;
                if (address) {
                    this.searchQuery.set(address);
                }
            }
        }
    }

    protected getCustomMarkerIcon(isDragging: boolean = false): string {
        return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(`
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_1345_19385)">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.05005 11.7723C8.05005 9.60712 8.94935 7.51382 10.5799 5.95376C12.2601 4.36982 14.4843 3.49143 16.7935 3.50006V3.50008H16.8C19.1459 3.50008 21.3806 4.3899 23.0174 5.95116L23.0174 5.95118L23.0246 5.95791C23.8182 6.70639 24.4513 7.60841 24.8854 8.60916C25.3191 9.60887 25.5452 10.6863 25.55 11.776C25.5484 14.9385 23.3696 18.121 20.8079 20.702C19.5677 21.9517 18.3209 22.9772 17.3817 23.691C17.1702 23.8518 16.9751 23.9962 16.8 24.1231C16.625 23.9962 16.4299 23.8518 16.2184 23.691C15.2792 22.9772 14.0324 21.9517 12.7922 20.702C10.2295 18.12 8.05005 14.936 8.05005 11.7723ZM29.05 11.7723H27.3L29.05 11.7653C29.0438 10.2 28.7193 8.65224 28.0963 7.2162C27.4739 5.7817 26.5667 4.48856 25.4297 3.4152C23.1267 1.22028 20.0232 0.000901493 16.8033 7.57894e-05C13.5957 -0.0110832 10.5063 1.2104 8.17359 3.41219L8.17357 3.41216L8.1658 3.41959C5.86133 5.62164 4.55005 8.62274 4.55005 11.7723C4.55005 16.4049 7.62057 20.4598 10.3079 23.1675C11.6927 24.5628 13.0709 25.695 14.1005 26.4775C14.6167 26.8699 15.049 27.1772 15.3556 27.3886C15.509 27.4943 15.6312 27.5762 15.7171 27.633C15.76 27.6613 15.7938 27.6834 15.8179 27.6991L15.8468 27.7177L15.8556 27.7233L15.8585 27.7252L15.8597 27.7259C15.8601 27.7262 15.8605 27.7265 16.8 26.2501L15.8605 27.7265C16.4338 28.0913 17.1663 28.0913 17.7395 27.7265L16.8 26.2501C17.7395 27.7265 17.74 27.7262 17.7404 27.7259L17.7416 27.7252L17.7445 27.7233L17.7533 27.7177L17.7822 27.6991C17.8063 27.6834 17.8401 27.6613 17.883 27.633C17.9689 27.5762 18.0911 27.4943 18.2445 27.3886C18.5511 27.1772 18.9834 26.8699 19.4996 26.4775C20.5292 25.695 21.9074 24.5628 23.2922 23.1675C25.9795 20.4598 29.05 16.4049 29.05 11.7723ZM16.8 7C15.4077 7 14.0723 7.55312 13.0877 8.53769C12.1032 9.52226 11.55 10.8576 11.55 12.25C11.55 13.6424 12.1032 14.9777 13.0877 15.9623C14.0723 16.9469 15.4077 17.5 16.8 17.5C18.1924 17.5 19.5278 16.9469 20.5124 15.9623C21.4969 14.9777 22.05 13.6424 22.05 12.25C22.05 10.8576 21.4969 9.52225 20.5124 8.53769C19.5278 7.55312 18.1924 7 16.8 7ZM18.0375 13.4874C17.7093 13.8156 17.2642 14 16.8 14C16.3359 14 15.8908 13.8156 15.5626 13.4874C15.2344 13.1592 15.05 12.7141 15.05 12.25C15.05 11.7859 15.2344 11.3408 15.5626 11.0126C15.8908 10.6844 16.3359 10.5 16.8 10.5C17.2642 10.5 17.7093 10.6844 18.0375 11.0126C18.3657 11.3408 18.55 11.7859 18.55 12.25C18.55 12.7141 18.3657 13.1592 18.0375 13.4874Z" fill="#526ED3"/>
            </g>
            <ellipse cx="16.1" cy="32.2004" rx="16.1" ry="2.8" fill="#233A8A"/>
            <defs>
            <clipPath id="clip0_1345_19385">
            <rect width="28" height="28" fill="white" transform="translate(2.80005)"/>
            </clipPath>
            </defs>
            </svg>
        `)}`;
    }

    protected getMapStyles(): any[] {
        return [
            {
                "featureType": "all",
                "elementType": "geometry",
                "stylers": [{ "saturation": 32 }, { "lightness": -3 }, { "weight": 0.2 }]
            },
            {
                "featureType": "all",
                "elementType": "labels.text",
                "stylers": [{ "color": "#425469" }, { "lightness": 0 }]
            },
            {
                "featureType": "all",
                "elementType": "labels.text.stroke",
                "stylers": [{ "color": "#ffffff" }, { "lightness": 65 }]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.fill",
                "stylers": [{ "color": "#fefefe" }, { "lightness": 20 }]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.stroke",
                "stylers": [{ "color": "#fefefe" }, { "lightness": 17 }, { "weight": 1.2 }]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry",
                "stylers": [{ "color": "#f5f5f2" }, { "lightness": 20 }]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry.fill",
                "stylers": [{ "color": "#e8f4f8" }]
            },
            {
                "featureType": "landscape.man_made",
                "elementType": "geometry.stroke",
                "stylers": [{ "color": "#87ceeb" }, { "lightness": 14 }]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [{ "color": "#dfd2ae" }]
            },
            {
                "featureType": "poi",
                "elementType": "labels.text.fill",
                "stylers": [{ "color": "#93817c" }]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry.fill",
                "stylers": [{ "color": "#a5d8a5" }, { "lightness": 43 }]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry.stroke",
                "stylers": [{ "color": "#a5d8a5" }, { "lightness": 32 }]
            },
            {
                "featureType": "poi.park",
                "elementType": "labels.text.fill",
                "stylers": [{ "color": "#6b9a76" }]
            },
            {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": [{ "color": "#ffffff" }]
            },
            {
                "featureType": "road",
                "elementType": "geometry.fill",
                "stylers": [{ "color": "#ffeb3b" }, { "lightness": 20 }]
            },
            {
                "featureType": "road",
                "elementType": "labels.text.fill",
                "stylers": [{ "color": "#424242" }]
            },
            {
                "featureType": "road",
                "elementType": "labels.text.stroke",
                "stylers": [{ "color": "#ffffff" }, { "lightness": 100 }]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry",
                "stylers": [{ "color": "#ff9800" }]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [{ "color": "#ff9800" }, { "lightness": 77 }]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [{ "color": "#ff9800" }, { "lightness": 80 }, { "weight": 2 }]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels.text.fill",
                "stylers": [{ "color": "#616161" }]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels.text.stroke",
                "stylers": [{ "color": "#ffffff" }, { "lightness": 100 }]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry",
                "stylers": [{ "color": "#ffffff" }]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry.fill",
                "stylers": [{ "color": "#ffeb3b" }, { "lightness": 20 }]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry.stroke",
                "stylers": [{ "color": "#dcdcdc" }, { "lightness": 16 }]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels.text.fill",
                "stylers": [{ "color": "#757575" }]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels.text.stroke",
                "stylers": [{ "color": "#ffffff" }, { "lightness": 100 }]
            },
            {
                "featureType": "road.local",
                "elementType": "geometry",
                "stylers": [{ "color": "#ffffff" }]
            },
            {
                "featureType": "road.local",
                "elementType": "geometry.fill",
                "stylers": [{ "color": "#ffeb3b" }, { "lightness": 20 }]
            },
            {
                "featureType": "road.local",
                "elementType": "geometry.stroke",
                "stylers": [{ "color": "#eeeeee" }, { "lightness": 16 }]
            },
            {
                "featureType": "road.local",
                "elementType": "labels.text.fill",
                "stylers": [{ "color": "#616161" }]
            },
            {
                "featureType": "transit",
                "elementType": "geometry",
                "stylers": [{ "color": "#e5e5e5" }, { "lightness": 16 }]
            },
            {
                "featureType": "transit",
                "elementType": "geometry.fill",
                "stylers": [{ "color": "#e5e5e5" }, { "lightness": 16 }]
            },
            {
                "featureType": "transit",
                "elementType": "labels.text.fill",
                "stylers": [{ "color": "#9e9e9e" }]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [{ "color": "#c9c9c9" }, { "lightness": 17 }]
            },
            {
                "featureType": "water",
                "elementType": "geometry.fill",
                "stylers": [{ "color": "#4fc3f7" }, { "lightness": 50 }]
            },
            {
                "featureType": "water",
                "elementType": "labels.text.fill",
                "stylers": [{ "color": "#9e9e9e" }]
            },
            {
                "featureType": "water",
                "elementType": "labels.text.stroke",
                "stylers": [{ "color": "#ffffff" }, { "lightness": 100 }]
            }
        ];
    }

    protected initializeAutocomplete(): void {
        if (this.searchInput && typeof google !== 'undefined') {
            this.searchInput.nativeElement.addEventListener('input', (event: any) => {
                const query = event.target.value;
                this.searchQuery.set(query);
                if (query.trim()) {
                    this.searchLocation();
                } else {
                    this.showSearchResults.set(false);
                    this.searchResults.set([]);
                }
            });

            this.searchInput.nativeElement.addEventListener('focus', () => {
                if (this.searchQuery().trim()) {
                    this.showSearchResults.set(true);
                }
            });

            this.searchInput.nativeElement.addEventListener('keydown', (event: any) => {
                if (event.key === 'Enter') {
                    const firstResult = this.searchResults()[0];
                    if (firstResult) {
                        this.selectSearchResult(firstResult);
                    }
                }
            });
        }
    }

    protected placeMarker(latLng: any): void {
        let finalLatLng: any;

        if (latLng && typeof latLng.lat === 'function' && typeof latLng.lng === 'function') {
            finalLatLng = latLng;
            this.marker.setPosition(latLng);
            this.updateLocationFromMarker(latLng);
        } else if (latLng && typeof latLng.lat === 'number' && typeof latLng.lng === 'number') {
            finalLatLng = new google.maps.LatLng(latLng.lat, latLng.lng);
            this.marker.setPosition(finalLatLng);
            this.updateLocationFromMarker(finalLatLng);
        } else {
            return;
        }

        this.showMarker();

        const lat = finalLatLng.lat();
        const lng = finalLatLng.lng();
        this.updateSearchInputWithAddress(lat, lng);
    }

    protected onMarkerDragStart(): void {
        this.marker.setIcon(this.getCustomMarkerIcon(true));
    }

    protected onMarkerDrag(): void {
        this.marker.setIcon(this.getCustomMarkerIcon(true));
    }

    protected onMarkerDragEnd(): void {
        this.marker.setIcon(this.getCustomMarkerIcon(false));

        const position = this.marker.getPosition();
        if (position) {
            const lat = position.lat();
            const lng = position.lng();

            this.updateLocationFromMarker(position);
            this.updateSearchInputWithAddress(lat, lng);
        }
    }

    protected onMapDragStart(): void {
        this.keepSelectedSearchLabel = false;
        this.marker.setIcon(this.getCustomMarkerIcon(true));
    }

    protected onMapDragEnd(): void {
        this.marker.setIcon(this.getCustomMarkerIcon(false));
    }

    protected addCustomCursorStyles(): void {
        const style = document.createElement('style');
        style.textContent = `
            .gm-style-moc, .gm-style-mtc, [class*="gm-style-"] {
                cursor: grab !important;
            }
            .gm-style-moc:active, .gm-style-mtc:active, [class*="gm-style-"]:active {
                cursor: grabbing !important;
            }
            .gm-style-moc *, .gm-style-mtc *, [class*="gm-style-"] * {
                cursor: grab !important;
            }
            .gm-style-moc:active *, .gm-style-mtc:active *, [class*="gm-style-"]:active * {
                cursor: grabbing !important;
            }
            
            .map-container {
                cursor: grab !important;
            }
            .map-container:active {
                cursor: grabbing !important;
            }
            
            body, html {
                cursor: auto !important;
            }
            
            .gm-style-moc[style*="cursor"], 
            .gm-style-mtc[style*="cursor"], 
            [class*="gm-style-"][style*="cursor"] {
                cursor: grab !important;
            }
            
            *[style*="cursor: crosshair"],
            *[style*="cursor: not-allowed"],
            *[style*="cursor: no-drop"] {
                cursor: grab !important;
            }
        `;
        document.head.appendChild(style);
    }

    protected updateLocationFromMarker(latLng: any): void {
        let lat: number, lng: number;

        if (latLng && typeof latLng.lat === 'function' && typeof latLng.lng === 'function') {
            lat = latLng.lat();
            lng = latLng.lng();
        } else if (latLng && typeof latLng.lat === 'number' && typeof latLng.lng === 'number') {
            lat = latLng.lat;
            lng = latLng.lng;
        } else {
            return;
        }

        this.selectedLocation.set({ lat, lng });

        this.locationForm.patchValue({
            latitudeValue: lat.toFixed(6),
            longitudeValue: lng.toFixed(6)
        });

        this.reverseGeocode(lat, lng, true);

        this.searchNearbyParkings(lat, lng);
    }

    private applyAddressFromGoogle(result: any, lat: number, lng: number): void {
        const addressComponents = result?.address_components || [];
        let city = '';
        let country = '';
        let postalCode = '';
        let state = '';
        let countryCode = '';
        let route = '';
        let streetNumber = '';
        let sublocality = '';

        for (const component of addressComponents) {
            const types = component.types || [];
            if (types.includes('street_number')) {
                streetNumber = component.long_name;
            } else if (types.includes('route')) {
                route = component.long_name;
            } else if (types.includes('sublocality') || types.includes('sublocality_level_1')) {
                sublocality = sublocality || component.long_name;
            } else if (types.includes('locality')) {
                city = component.long_name;
            } else if (types.includes('country')) {
                country = component.long_name;
                countryCode = component.short_name;
            } else if (types.includes('postal_code')) {
                postalCode = component.long_name;
            } else if (types.includes('administrative_area_level_1')) {
                state = component.long_name;
            }
        }

        if (!city) {
            const lvl2 = addressComponents.find((c: any) => c.types?.includes('administrative_area_level_2'));
            city = (lvl2?.long_name) || sublocality || city;
        }

        let streetAddress = [streetNumber, route].filter(Boolean).join(' ').trim();
        if (!streetAddress) {
            streetAddress = result?.formatted_address || '';
            if (city) {
                streetAddress = streetAddress.replace(`, ${city}`, '');
            }
            if (state) {
                streetAddress = streetAddress.replace(`, ${state}`, '');
            }
            if (postalCode) {
                streetAddress = streetAddress.replace(`, ${postalCode}`, '');
                streetAddress = streetAddress.replace(` ${postalCode}`, '');
            }
            if (country) {
                streetAddress = streetAddress.replace(`, ${country}`, '');
            }
            streetAddress = streetAddress.replace(/,\s*\d{4,6}\s*/g, '');
            streetAddress = streetAddress.replace(/\s+\d{4,6}\s*/g, ' ');
            streetAddress = streetAddress.replace(/,\s*$/, '').trim();
        } else if (sublocality && !streetAddress.includes(sublocality)) {
            streetAddress = `${streetAddress}, ${sublocality}`;
        }

        if (!streetAddress) {
            streetAddress = result?.formatted_address || this.searchQuery() || '';
        }

        const existingAddress = (this.locationForm.get('addressValue')?.value || '').toString().trim();
        const existingCity = (this.locationForm.get('cityValue')?.value || '').toString().trim();
        const existingState = (this.locationForm.get('stateValue')?.value || '').toString().trim();
        const existingPostal = (this.locationForm.get('postalCodeValue')?.value || '').toString().trim();
        const resultIsPlusCode = (result?.types || []).includes('plus_code')
            || this.isPlusCodeLabel(result?.formatted_address || '')
            || this.isPlusCodeLabel(streetAddress);

        if (resultIsPlusCode) {
            const fromSelection = this.addressFromSelection(city, state, country);
            if (fromSelection) {
                streetAddress = fromSelection;
            } else if (existingAddress && !this.isPlusCodeLabel(existingAddress)) {
                streetAddress = existingAddress;
            } else {
                const named = (result?.name || this.searchQuery() || '').toString().trim();
                streetAddress = named && !this.isPlusCodeLabel(named) ? named : '';
            }
        }

        const formData = {
            addressValue: streetAddress,
            cityValue: city || existingCity,
            countryValue: country || this.locationForm.get('countryValue')?.value,
            postalCodeValue: postalCode || existingPostal,
            stateValue: state || existingState,
            latitudeValue: lat.toString(),
            longitudeValue: lng.toString()
        };

        this.locationForm.patchValue(formData);
        this.hasManualLocationSelection = true;
        this.saveMapSelectionToLocalStorage(formData);
        this.locationForm.get('countryValue')?.disable();

        const addressParts = [streetAddress, city, state, postalCode, country].filter(Boolean);
        this.parkingData = {
            ...this.parkingData,
            parkingAddress: addressParts.length > 0 ? addressParts.join(', ') : 'Location not specified'
        } as any;

        this.cdr.markForCheck();
    }

    private geocodeSearchQuery(query: string): Promise<void> {
        if (!query || typeof google === 'undefined') {
            return Promise.resolve();
        }

        this.isReverseGeocoding.set(true);
        return new Promise((resolve) => {
            const finish = () => {
                this.isReverseGeocoding.set(false);
                this.cdr.markForCheck();
                resolve();
            };

            try {
                const geocoder = new google.maps.Geocoder();
                const countryCode = this.organizationCountry();
                const request: any = { address: query };
                if (countryCode) {
                    request.componentRestrictions = { country: countryCode.toLowerCase() };
                }
                geocoder.geocode(request, (results: any, status: any) => {
                    if (status === 'OK' && results && results[0]?.geometry?.location) {
                        const location = results[0].geometry.location;
                        const lat = typeof location.lat === 'function' ? location.lat() : location.lat;
                        const lng = typeof location.lng === 'function' ? location.lng() : location.lng;
                        this.selectedLocation.set({ lat, lng });
                        this.applyAddressFromGoogle(results[0], lat, lng);
                    }
                    finish();
                });
            } catch {
                finish();
            }
        });
    }

    protected reverseGeocode(lat: number, lng: number, force: boolean = false): Promise<void> {
        if (this.isInitialMapLoad && !force) {
            return Promise.resolve();
        }

        this.isReverseGeocoding.set(true);

        return new Promise((resolve) => {
            const finish = () => {
                this.isReverseGeocoding.set(false);
                this.cdr.markForCheck();
                resolve();
            };

            try {
                const geocoder = new google.maps.Geocoder();
                geocoder.geocode({ location: { lat, lng } }, (results: any, status: any) => {
                    if (status === 'OK' && results && results[0]) {
                        this.applyAddressFromGoogle(results[0], lat, lng);
                        try { sessionStorage.removeItem('parkingsStep4Data'); } catch { }
                        this.autoSaveData().catch(() => { });
                    }
                    finish();
                });
            } catch {
                finish();
            }
        });
    }

    protected updateSearchInputWithAddress(lat: number, lng: number): void {
        if (this.isInitialMapLoad) {
            return;
        }

        const current = (this.searchQuery() || '').trim();
        if (this.keepSelectedSearchLabel && current && !this.isPlusCodeLabel(current)) {
            return;
        }

        const geocoder = new google.maps.Geocoder();
        const latlng = { lat, lng };

        geocoder.geocode({ location: latlng }, (results: any, status: any) => {
            if (status !== 'OK' || !results?.length) {
                return;
            }

            const label = this.readableGeocodeLabel(results);
            if (!label) {
                return;
            }

            this.searchQuery.set(label);
            this.addToRecentSearches({
                name: label,
                place_id: results.find((result: any) => result.formatted_address === label)?.place_id || '',
                type: 'reverse_geocode',
                lat: lat,
                lng: lng
            });
        });
    }

    private isPlusCodeLabel(value: string): boolean {
        return /^[23456789CFGHJMPQRVWX]{4,}\+[23456789CFGHJMPQRVWX]{2,}\b/i.test((value || '').trim());
    }

    private addressFromSelection(city: string, state: string, country: string): string {
        let address = (this.selectedPlaceDescription || '').trim();
        if (!address || this.isPlusCodeLabel(address)) {
            return '';
        }
        for (const part of [city, state, country, 'USA', 'United States']) {
            if (!part) continue;
            address = address.replace(new RegExp(`,?\\s*${part.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\s*,?`, 'ig'), ', ');
        }
        address = address.replace(/,\s*[A-Z]{2}\s*$/g, '');
        return address.replace(/\s+,/g, ',').replace(/,\s*,/g, ',').replace(/^[,\s]+|[,\s]+$/g, '').trim();
    }

    private readableGeocodeLabel(results: any[]): string {
        for (const result of results) {
            const formatted = (result?.formatted_address || '').trim();
            const types: string[] = result?.types || [];
            if (!formatted || types.includes('plus_code') || this.isPlusCodeLabel(formatted)) {
                continue;
            }
            return formatted;
        }
        return '';
    }

    protected showMarker(): void {
        if (this.marker && this.map) {
            this.marker.setMap(this.map);
            this.isMarkerVisible.set(true);
        }
    }

    protected hideMarker(): void {
        if (this.marker) {
            this.marker.setMap(null);
            this.isMarkerVisible.set(false);
        }
    }

    protected searchLocation(): void {
        if (!this.searchQuery().trim()) {
            this.showSearchResults.set(false);
            return;
        }

        this.isSearching.set(true);
        this.showSearchResults.set(true);

        const countryCode = this.organizationCountry();

        if (typeof google === 'undefined') {
            this.isSearching.set(false);
            setTimeout(() => {
                this.searchLocation();
            }, 2000);
            return;
        }

        const service = new google.maps.places.AutocompleteService();

        const searchParams: any = {
            input: this.searchQuery()
        };
        if (countryCode) {
            searchParams.componentRestrictions = { country: countryCode.toLowerCase() };
        }

        service.getPlacePredictions(searchParams,
            (predictions: any, status: any) => {
                this.isSearching.set(false);

                if (status === google.maps.places.PlacesServiceStatus.OK && predictions) {
                    const filteredPredictions = predictions;

                    this.searchResults.set(filteredPredictions);

                    const popularResults = filteredPredictions.slice(0, 5).map((prediction: any) => ({
                        name: prediction.description,
                        place_id: prediction.place_id,
                        type: 'search_result',
                        country: this.getCountryNameFromCode(countryCode)
                    }));
                    this.popularLocations.set(popularResults);
                } else {
                    const fallbackParams: any = { input: this.searchQuery() };
                    if (countryCode) {
                        fallbackParams.componentRestrictions = { country: countryCode.toLowerCase() };
                    }
                    service.getPlacePredictions(
                        fallbackParams,
                        (fallbackPredictions: any, fallbackStatus: any) => {
                            if (fallbackStatus === google.maps.places.PlacesServiceStatus.OK && fallbackPredictions) {
                                const countryName = this.getCountryNameFromCode(countryCode);
                                const filteredFallback = fallbackPredictions.filter((prediction: any) => {
                                    return prediction.description.toLowerCase().includes(countryName.toLowerCase());
                                });

                                this.searchResults.set(filteredFallback);

                                const popularResults = filteredFallback.slice(0, 5).map((prediction: any) => ({
                                    name: prediction.description,
                                    place_id: prediction.place_id,
                                    type: 'search_result',
                                    country: countryName
                                }));
                                this.popularLocations.set(popularResults);
                            } else {
                                this.searchResults.set([]);
                                this.popularLocations.set([]);
                            }
                        }
                    );
                }
            }
        );
    }

    protected selectSearchResult(result: any): void {
        this.showSearchResults.set(false);
        this.isSearching.set(false);
        this.isInitialMapLoad = false;

        const fallbackQuery = result?.description || result?.structured_formatting?.main_text || this.searchQuery();

        if (!this.map || typeof google === 'undefined' || !result?.place_id) {
            this.geocodeSearchQuery(fallbackQuery);
            return;
        }

        const service = new google.maps.places.PlacesService(this.map);

        service.getDetails(
            {
                placeId: result.place_id,
                fields: ['geometry', 'formatted_address', 'address_components', 'name']
            },
            (place: any, status: any) => {
                if (status === google.maps.places.PlacesServiceStatus.OK && place && place.geometry) {
                    const location = place.geometry.location;
                    let lat: number, lng: number;

                    if (location && typeof location.lat === 'function' && typeof location.lng === 'function') {
                        lat = location.lat();
                        lng = location.lng();
                    } else if (location && typeof location.lat === 'number' && typeof location.lng === 'number') {
                        lat = location.lat;
                        lng = location.lng;
                    } else {
                        this.geocodeSearchQuery(fallbackQuery);
                        return;
                    }

                    if (lat && lng) {
                        this.map.setCenter({ lat, lng });
                        this.map.setZoom(15);

                        this.selectedLocation.set({ lat, lng });

                        this.marker.setMap(this.map);
                        this.marker.setPosition({ lat, lng });

                        const selectedLocationName = place.name || result.description || result.structured_formatting?.main_text || place.formatted_address;
                        this.keepSelectedSearchLabel = true;
                        this.selectedPlaceDescription = result.description || place.formatted_address || selectedLocationName;
                        this.searchQuery.set(selectedLocationName);

                        try { localStorage.setItem('parkingsSuggestedName', selectedLocationName); } catch { }

                        this.applyAddressFromGoogle(place, lat, lng);
                        this.reverseGeocode(lat, lng, true);

                        try { sessionStorage.removeItem('parkingsStep4Data'); } catch { }

                        this.autoSaveData().catch(() => { });

                        this.addToRecentSearches({
                            name: place.name || place.formatted_address,
                            lat,
                            lng,
                            type: 'search'
                        });

                        this.autoSaveData();
                    }
                } else {
                    this.geocodeSearchQuery(fallbackQuery);
                }
            }
        );
    }

    protected selectPopularLocation(location: any): void {
        this.map.setCenter({ lat: location.lat, lng: location.lng });
        this.map.setZoom(15);

        this.selectedLocation.set({ lat: location.lat, lng: location.lng });

        this.marker.setMap(this.map);
        this.marker.setPosition({ lat: location.lat, lng: location.lng });

        this.searchQuery.set(location.name || 'Popular Location');

        this.addToRecentSearches(location);

        this.autoSaveData().catch(() => { });

        this.showSearchResults.set(false);
    }

    protected selectRecentSearch(search: any): void {
        this.map.setCenter({ lat: search.lat, lng: search.lng });
        this.map.setZoom(15);

        this.selectedLocation.set({ lat: search.lat, lng: search.lng });

        this.marker.setMap(this.map);
        this.marker.setPosition({ lat: search.lat, lng: search.lng });

        this.searchQuery.set(search.name || 'Recent Location');

        this.autoSaveData().catch(() => { });

        this.showSearchResults.set(false);
    }

    protected clearSearch(): void {
        this.searchQuery.set('');
        this.showSearchResults.set(false);
        this.searchResults.set([]);
        this.hideMarker();
    }

    @HostListener('document:click', ['$event'])
    protected onDocumentClick(event: Event): void {
        const searchContainer = document.querySelector('.search-container');
        if (searchContainer && !searchContainer.contains(event.target as Node)) {
            this.showSearchResults.set(false);
        }
    }

    @HostListener('document:keydown', ['$event'])
    protected onKeyDown(event: KeyboardEvent): void {
        if (event.key === 'Escape') {
            this.showSearchResults.set(false);
        }
    }

    protected onSearchInputFocus(): void {
        if (this.searchQuery().trim()) {
            this.showSearchResults.set(true);
            this.searchLocation();
        }
    }

    protected onSearchInputBlur(): void {
        setTimeout(() => {
            this.showSearchResults.set(false);
        }, 200);
    }

    private searchTimeout: any = null;

    protected onSearchInputChange(event: Event): void {
        const target = event.target as HTMLInputElement;
        const value = target.value;
        this.searchQuery.set(value);

        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }

        if (value.trim()) {
            if (value.trim().length >= 2) {
                this.searchTimeout = setTimeout(() => {
                    this.searchLocation();
                }, 300);
            } else {
                this.showSearchResults.set(false);
                this.searchResults.set([]);
            }
        } else {
            this.showSearchResults.set(false);
            this.searchResults.set([]);

            const countryName = this.getCountryNameFromCode(this.organizationCountry());
            if (countryName && countryName !== this.organizationCountry()) {
                this.loadPopularPlacesInCountry(countryName);
            }

            this.hideMarker();
            this.selectedLocation.set(null);
        }
    }

    protected getCurrentLocation(): void {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const lat = position.coords.latitude;
                    const lng = position.coords.longitude;

                    this.map.setCenter({ lat, lng });
                    this.map.setZoom(15);

                    this.selectedLocation.set({ lat, lng });

                    this.marker.setMap(this.map);
                    this.marker.setPosition({ lat, lng });

                    this.updateSearchInputWithAddress(lat, lng);

                    this.addToRecentSearches({
                        name: 'Current Location',
                        lat,
                        lng,
                        type: 'current'
                    });
                },
                () => {
                    this.map.setCenter({ lat: this.defaultLat, lng: this.defaultLng });
                }
            );
        }
    }

    protected searchNearbyParkings(lat: number, lng: number): void {
        const nearbyParkings = [
            { name: 'Central Parking Lot', distance: '0.2 km', rating: 4.5, price: '50/hr' },
            { name: 'Mall Parking', distance: '0.5 km', rating: 4.2, price: '30/hr' },
            { name: 'Street Parking', distance: '0.8 km', rating: 3.8, price: '20/hr' },
            { name: 'Office Complex Parking', distance: '1.2 km', rating: 4.0, price: '40/hr' }
        ];

        this.nearbyParkings.set(nearbyParkings);
        this.showNearbyParkings.set(true);
    }

    protected addToRecentSearches(search: any): void {
        const recentSearches = this.recentSearches();
        const existingIndex = recentSearches.findIndex(s =>
            s.lat === search.lat && s.lng === search.lng
        );

        if (existingIndex !== -1) {
            recentSearches.splice(existingIndex, 1);
        }

        recentSearches.unshift(search);

        if (recentSearches.length > 5) {
            recentSearches.splice(5);
        }

        this.recentSearches.set(recentSearches);
    }

    protected loadRecentSearches(): void {
        this.recentSearches.set([]);
    }

    protected parkingIdForSaveExit = signal(sessionStorage.getItem('parking_id') || localStorage.getItem('parkingId'));

    protected showSaveExitDialog(): void {
        if (this.canSaveAndExit()) {
            const data: TuiConfirmData = {
                content: 'Progress will be updated. You can finish later from the same step.',
                yes: 'Save & Exit',
                no: 'Cancel',
            };
            this.dialogs
                .open<boolean>(TUI_CONFIRM, {
                    label: 'Save & Exit Setup?',
                    size: 's',
                    data,
                })
                .pipe(switchMap((response) => {
                    if (response) {
                        this.confirmSaveAndExit();
                    }
                    return of(true);
                }))
                .subscribe();
        }
        else {
            const data: TuiConfirmData = {
                content: "Your changes won't be saved.",
                yes: 'Exit',
                no: 'Cancel',
            };
            this.dialogs
                .open<boolean>(TUI_CONFIRM, {
                    label: 'Exit Without Saving?',
                    size: 's',
                    data,
                })
                .pipe(switchMap((response) => {
                    if (response) {
                        this.exitAndClearLocalData();
                    }
                    return of(true);
                }))
                .subscribe();
        }
    }

    protected confirmSaveAndExit(): void {
        const stepToResume = this.currentStep();

        const persistLocalState = (parkingIdToSave: string | null) => {
            if (!parkingIdToSave) {
                return;
            }

            sessionStorage.setItem('parking_id', parkingIdToSave);
            localStorage.setItem('parking_id', parkingIdToSave);
            this.parkingId = parkingIdToSave;
            this.parkingIdForSaveExit.set(parkingIdToSave);
            this.persistWizardStep(stepToResume, parkingIdToSave);

            const parkingData = {
                step: stepToResume,
                selectedCardIndex: this.selectedCardIndex(),
                parkingTypeSelected: this.parkingTypeSelected(),
                selectedLocation: this.selectedLocation(),
                searchQuery: this.searchQuery(),
                locationFormData: this.locationForm.value,
                timestamp: new Date().toISOString()
            };

            sessionStorage.setItem('parkingFormData', JSON.stringify(parkingData));
            sessionStorage.setItem('lastActiveComponent', 'parkings');
            sessionStorage.setItem('lastActiveStep', stepToResume.toString());
        };

        const navigateAway = () => {
            this.apiService.invalidateParkingListCache();
            sessionStorage.setItem('parking_list_needs_refresh', 'true');
            this.notificationService.showSuccess('Progress saved. You can resume setup anytime.', 3000);
            const orgId = this.apiService.getCurrentOrganizationId();
            if (orgId) {
                this.router.navigate(['/organization', orgId, 'parking-lots']);
            } else {
                this.router.navigate(['/parking-lots']);
            }
        };

        const saveAndLeave = async () => {
            if (!this.getExistingParkingId()) {
                await this.patchParkingTypeData();
            }

            persistLocalState(this.getExistingParkingId());
            await this.saveCurrentStepData();
            persistLocalState(this.getExistingParkingId());

            const parkingId = this.getExistingParkingId();
            if (parkingId) {
                try {
                    await this.apiService.updateParkingWithJson(parkingId, { wizard_step: stepToResume }).toPromise();
                } catch { }
            }
        };

        saveAndLeave()
            .catch(() => { })
            .finally(() => navigateAway());
    }

    protected exitAndClearLocalData(): void {
        try {
            this.clearSavedData();
        } catch { }
        sessionStorage.removeItem('parkingFormData');
        sessionStorage.removeItem('lastActiveComponent');
        sessionStorage.removeItem('lastActiveStep');
        sessionStorage.removeItem('urlParkingId');
        this.router.navigate(['/parking-lots']);
    }

    protected loadSavedData(): void {
        const savedData = sessionStorage.getItem('combinedParkingData');
        if (savedData) {
            try {
                const data = JSON.parse(savedData);

                if (data.parkings) {
                    const parkingsData = data.parkings;

                    if (this.stepFromUrl == null) {
                        const persistedStep = this.getPersistedWizardStep();
                        this.currentStep.set(persistedStep || parkingsData.step || 1);
                    }

                    this.selectedCardIndex.set(parkingsData.selectedCardIndex ?? -1);
                    this.parkingTypeSelected.set(parkingsData.parkingTypeSelected ?? false);

                    if (parkingsData.selectedLocation) {
                        this.selectedLocation.set(parkingsData.selectedLocation);
                    }

                    if (parkingsData.searchQuery) {
                        this.searchQuery.set(parkingsData.searchQuery);
                    }

                    if (parkingsData.locationFormData) {
                        this.locationForm.patchValue(parkingsData.locationFormData);
                        this.locationForm.get('countryValue')?.disable();
                    }

                    if (parkingsData.region_id) {
                        this.organizationRegionId.set(parkingsData.region_id);
                    }

                    this.savedMapData = parkingsData;

                    this.loadParkingTypeFromLocalStorage();
                    this.loadLocationFromLocalStorage();
                    this.loadFormFromLocalStorage();
                    this.loadAmenitiesData();
                    this.loadOperatingHoursData();
                    this.loadParkingImagesFromLocalStorage();
                    this.loadTeamMemberData();
                }

            } catch (error) {
                sessionStorage.removeItem('combinedParkingData');
            }
        }

        this.loadStepSpecificData();
    }

    private loadStepSpecificData(): void {
        const currentStep = this.currentStep();

        switch (currentStep) {
            case 1:
                this.loadParkingTypeFromLocalStorage();
                break;
            case 2:
                this.loadLocationFromLocalStorage();
                break;
            case 3:
                this.loadFormFromLocalStorage();
                break;
            case 4:
                this.loadAmenitiesData();
                break;
            case 5:
                this.loadOperatingHoursData();
                break;
            case 6:
                this.loadParkingImagesFromLocalStorage();
                break;
            case 7:
                this.loadTeamMemberData();
                break;
        }
    }

    protected clearSavedData(keepParkingId: boolean = false): void {
        const wizardKeys = [
            'combinedParkingData',
            'parking_type_selection',
            'parkingsStep1Data',
            'parkingsStep2Data',
            'parkingsStep3Data',
            'parkingsStep4Data',
            'parkingsStep5Data',
            'parkingsStep6Data',
            'parkingsStep7Data',
            'parkingsStep8Data',
            'parkingsStep9Data',
            'parkingsStep10Data',
            'parking_amenities_data',
            'parking_operating_hours_data',
            'parking_team_member_data',
            'parking_pending_team_invite',
            'parking_invited_manager_id',
            'parkings_manual_location_selection',
            'parkingsSuggestedName',
            'parkingFormData'
        ];

        wizardKeys.forEach(key => {
            localStorage.removeItem(key);
            sessionStorage.removeItem(key);
        });

        this.selectedFeatures.set([]);
        this.selectedCardIndex.set(-1);
        this.parkingTypeSelected.set(false);
        this.amenitySvgs.set([]);

        // Reset manager assignment flags
        this.resetManagerAssignmentFlags();

        if (!keepParkingId) {
            sessionStorage.setItem('parking_id_cleared_at', Date.now().toString());

            sessionStorage.removeItem('parking_id');
            sessionStorage.removeItem('parkingId');
            sessionStorage.removeItem('selectedParkingId');
            sessionStorage.removeItem('urlParkingId');
            sessionStorage.removeItem('selectedParkingForVendor');
            sessionStorage.removeItem('vendorContext');

            localStorage.removeItem('parking_id');
            localStorage.removeItem('parkingId');
            localStorage.removeItem('selectedParkingId');
            localStorage.removeItem('lastActiveComponent');
            localStorage.removeItem('lastActiveStep');

            this.parkingIdForSaveExit.set(null);
            this.parkingId = '';
            this.isEditMode = false;
        }

        this.existingImages = [];
        this.currentUploadFiles = [];
        this.carouselItems = [];
        this.savedMapData = null;
        this.fileControl.reset();

        this.hasManualLocationSelection = false;

        try {
            this.locationForm.reset();
        } catch (e) { }
    }

    private saveMapSelectionToLocalStorage(locationData: any): void {
        try {
            const mapSelectionData = {
                ...locationData,
                timestamp: new Date().toISOString(),
                hasManualSelection: true
            };
            localStorage.setItem('parkings_manual_location_selection', JSON.stringify(mapSelectionData));
        } catch (error) {
        }
    }

    private loadMapSelectionFromLocalStorage(): boolean {
        try {
            const savedData = localStorage.getItem('parkings_manual_location_selection');
            if (savedData) {
                const mapSelectionData = JSON.parse(savedData);

                this.locationForm.patchValue({
                    addressValue: mapSelectionData.addressValue || '',
                    cityValue: mapSelectionData.cityValue || '',
                    stateValue: mapSelectionData.stateValue || '',
                    postalCodeValue: mapSelectionData.postalCodeValue || '',
                    countryValue: mapSelectionData.countryValue || '',
                    latitudeValue: mapSelectionData.latitudeValue || '',
                    longitudeValue: mapSelectionData.longitudeValue || ''
                });

                if (mapSelectionData.addressValue) {
                    this.searchQuery.set(mapSelectionData.addressValue);
                }

                if (mapSelectionData.latitudeValue && mapSelectionData.longitudeValue) {
                    this.selectedLocation.set({
                        lat: parseFloat(mapSelectionData.latitudeValue),
                        lng: parseFloat(mapSelectionData.longitudeValue)
                    });
                }

                this.hasManualLocationSelection = mapSelectionData.hasManualSelection || true;

                const hasAddress = !!(mapSelectionData.addressValue && mapSelectionData.cityValue);
                if (!hasAddress && mapSelectionData.latitudeValue && mapSelectionData.longitudeValue) {
                    this.isInitialMapLoad = false;
                    this.reverseGeocode(
                        parseFloat(mapSelectionData.latitudeValue),
                        parseFloat(mapSelectionData.longitudeValue)
                    );
                }

                this.cdr.markForCheck();
                return true;
            }
            return false;
        } catch (error) {
            return false;
        }
    }

    protected async autoSaveData(): Promise<void> {
        const capturedStep = this.currentStep();

        const existingData = sessionStorage.getItem('combinedParkingData');
        let combinedData = {
            parkings: {
                step: capturedStep,
                selectedCardIndex: this.selectedCardIndex(),
                parkingTypeSelected: this.parkingTypeSelected(),
                selectedLocation: this.selectedLocation(),
                searchQuery: this.searchQuery(),
                locationFormData: this.locationForm.value,
                parkingType: this.parkingTypes[this.selectedCardIndex()]?.title || 'Standalone Parking Lots',
                timeZone: this.locationForm.get('timeZoneValue')?.value || ((typeof Intl !== 'undefined' && Intl.DateTimeFormat) ? Intl.DateTimeFormat().resolvedOptions().timeZone : 'UTC'),
                region_id: this.organizationRegionId() || null,
                location: {
                    country: this.locationForm.get('countryValue')?.value || 'India',
                    state: this.locationForm.get('stateValue')?.value || '',
                    city: this.locationForm.get('cityValue')?.value || '',
                    address_line_1: this.locationForm.get('addressValue')?.value || '',
                    address_line_2: this.locationForm.get('addressLine2Value')?.value || '',
                    postalCode: this.locationForm.get('postalCodeValue')?.value || '',
                    lat: this.selectedLocation()?.lat.toString() || '',
                    lng: this.selectedLocation()?.lng.toString() || ''
                }
            },
            parkingAddPeople: {
                step: 1,
                formData: {},
                selectedParkingTypes: [],
                parkingFeatures: [],
                operatingHours: {},
                files: []
            },
            timestamp: new Date().toISOString()
        };

        if (existingData) {
            try {
                const parsedData = JSON.parse(existingData);
                if (parsedData.parkingAddPeople) {
                    combinedData.parkingAddPeople = parsedData.parkingAddPeople;
                }
            } catch (error) {
            }
        }

        sessionStorage.setItem('combinedParkingData', JSON.stringify(combinedData));

        await this.saveStepSpecificData(capturedStep);
    }

    private async saveStepSpecificData(stepOverride?: number): Promise<void> {
        const currentStep = stepOverride ?? this.currentStep();

        switch (currentStep) {
            case 1:
                this.saveParkingTypeToLocalStorage();
                break;
            case 2:
                this.saveLocationData();
                break;
            case 3:
                this.saveFormData();
                break;
            case 4:
                this.saveAmenitiesData();
                break;
            case 5:
                this.saveOperatingHoursData();
                break;
            case 6:
                await this.saveParkingImagesToLocalStorage();
                break;
            case 7:
                this.saveTeamMemberData();
                break;
        }
    }

    protected clearRecentSearches(): void {
        this.recentSearches.set([]);
    }

    private saveCombinedData(): void {
        this.autoSaveData().catch(() => { });
    }

    protected toggleNearbyParkings(): void {
        this.showNearbyParkings.update(show => !show);
    }

    protected updateCountry(countryCode: string): void {
        this.selectedCountry.set(countryCode);

        this.updatePopularLocations(countryCode);

        if (this.map) {
            const countryCoords = this.getCountryCoordinates(countryCode);
            this.defaultLat = countryCoords.lat;
            this.defaultLng = countryCoords.lng;

            this.map.setCenter({ lat: this.defaultLat, lng: this.defaultLng });
            this.map.setZoom(6);

            this.marker.setPosition({ lat: this.defaultLat, lng: this.defaultLng });

            this.selectedLocation.set(null);

            this.initializeAutocomplete();
        }
    }

    protected updatePopularLocations(countryCode: string): void {
        this.popularLocations.set([]);
    }

    protected getCurrentCountryName(): string {
        const countryCoords = this.getCountryCoordinates(this.selectedCountry());
        return countryCoords ? countryCoords.name : 'India';
    }

    protected getOrganizationCountryName(): string {
        const countryCoords = this.getCountryCoordinates(this.organizationCountry());
        return countryCoords ? countryCoords.name : 'India';
    }

    protected setOrganizationTimezone(): void {
        const countryName = this.getOrganizationCountryName();
        let timezone = (typeof Intl !== 'undefined' && Intl.DateTimeFormat) ? Intl.DateTimeFormat().resolvedOptions().timeZone : 'UTC';

        switch (countryName.toLowerCase()) {
            case 'india':
                timezone = 'Asia/Kolkata';
                break;
            case 'united states':
            case 'usa':
                timezone = 'America/New_York';
                break;
            case 'united kingdom':
            case 'uk':
                timezone = 'Europe/London';
                break;
            case 'australia':
                timezone = 'Australia/Sydney';
                break;
            case 'canada':
                timezone = 'America/Toronto';
                break;
            case 'germany':
                timezone = 'Europe/Berlin';
                break;
            case 'france':
                timezone = 'Europe/Paris';
                break;
            case 'japan':
                timezone = 'Asia/Tokyo';
                break;
            case 'china':
                timezone = 'Asia/Shanghai';
                break;
            case 'singapore':
                timezone = 'Asia/Singapore';
                break;
            case 'uae':
            case 'united arab emirates':
                timezone = 'Asia/Dubai';
                break;
            default:
                timezone = (typeof Intl !== 'undefined' && Intl.DateTimeFormat) ? Intl.DateTimeFormat().resolvedOptions().timeZone : 'UTC';
                break;
        }

        this.locationForm.get('timeZoneValue')?.setValue(timezone);
    }

    protected getOrganizationCountryCode(): string {
        return this.organizationCountry();
    }

    protected getAvailableCountries(): Array<{ code: string, name: string }> {
        return this.countryCoordinatesService.getAvailableCountries();
    }

    protected loadCountryRegion(): void {
        this.isRegionLoading.set(true);
        this.regionError.set(null);

        const countryCode = this.organizationCountry();

        this.countryRegionService.getCountryData(countryCode).subscribe({
            next: (data: CountryData | undefined) => {
                if (data) {
                    this.selectedCountryData.set(data);
                    this.isRegionLoading.set(false);

                    let timezoneToUse = this.organizationTimezone() || data.timezone;

                    if (this.organizationTimezone()) {
                        timezoneToUse = this.timezoneConverterService.extractTimezoneFromString(this.organizationTimezone()!);
                    }

                    this.locationForm.patchValue({
                        countryValue: this.getOrganizationCountryName(),
                        currencyValue: data.currency,
                        languageValue: data.language,
                        timeZoneValue: timezoneToUse,
                        taxNameValue: data.taxName
                    });
                    this.locationForm.get('countryValue')?.disable();

                    if (this.organizationTimezone()) {
                        this.updateTimezoneOptionsForCountry(countryCode, timezoneToUse);
                    }
                } else {
                    this.regionError.set('Country data not found');
                    this.isRegionLoading.set(false);
                }
            },
            error: (error: any) => {
                this.regionError.set(error.message || 'Failed to load region data');
                this.isRegionLoading.set(false);
            }
        });
    }

    protected saveParkingStep1Data(): void {
        if (!this.selectedLocation() || !this.parkingTypeSelected()) {
            return;
        }

        const selectedParkingType = this.parkingTypes[this.selectedCardIndex()]?.title || 'Standalone Parking Lots';

        const timezone = (typeof Intl !== 'undefined' && Intl.DateTimeFormat) ? Intl.DateTimeFormat().resolvedOptions().timeZone : 'UTC';

        const locationData = {
            country: this.locationForm.get('countryValue')?.value || 'India',
            state: this.locationForm.get('stateValue')?.value || '',
            city: this.locationForm.get('cityValue')?.value || '',
            address_line_1: this.locationForm.get('addressValue')?.value || '',
            address_line_2: this.locationForm.get('addressLine2Value')?.value || '',
            postalCode: this.locationForm.get('postalCodeValue')?.value || '',
            lat: this.selectedLocation()?.lat.toString() || '',
            lng: this.selectedLocation()?.lng.toString() || ''
        };

        const step1Payload = {
            parkingStep1: {
                parkingType: selectedParkingType,
                timeZone: timezone,
                region_id: this.organizationRegionId() || null,
                location: locationData
            }
        };

        this.apiService.createParking(step1Payload).subscribe({
            next: (response: any) => {
            },
            error: (error: any) => {
            }
        });
    }

    private ensureFormIsPopulated(): void {
        const pending = this.pendingLocationData();
        if (pending && (pending.latitudeValue || pending.longitudeValue || pending.addressValue)) {
            this.locationForm.patchValue({
                addressValue: pending.addressValue || '',
                cityValue: pending.cityValue || '',
                stateValue: pending.stateValue || '',
                postalCodeValue: pending.postalCodeValue || '',
                countryValue: pending.countryValue || '',
                latitudeValue: pending.latitudeValue || '',
                longitudeValue: pending.longitudeValue || ''
            });
            this.locationForm.get('countryValue')?.disable();

            if (pending.latitudeValue && pending.longitudeValue) {
                this.selectedLocation.set({
                    lat: parseFloat(pending.latitudeValue),
                    lng: parseFloat(pending.longitudeValue)
                });
            }

            this.pendingLocationData.set(null);

            if ((!pending.addressValue || !pending.cityValue) && pending.latitudeValue && pending.longitudeValue) {
                this.isInitialMapLoad = false;
                this.reverseGeocode(parseFloat(pending.latitudeValue), parseFloat(pending.longitudeValue));
            }

            this.cdr.markForCheck();
            return;
        }

        const loadedFromLocalStorage = this.loadMapSelectionFromLocalStorage();
        if (loadedFromLocalStorage) {
            const loadedAddress = this.locationForm.get('addressValue')?.value;
            const loadedCity = this.locationForm.get('cityValue')?.value;
            const loadedLat = this.locationForm.get('latitudeValue')?.value;
            const loadedLng = this.locationForm.get('longitudeValue')?.value;
            if ((!loadedAddress || !loadedCity) && loadedLat && loadedLng) {
                this.isInitialMapLoad = false;
                this.reverseGeocode(parseFloat(loadedLat), parseFloat(loadedLng));
            }
            this.cdr.markForCheck();
            return;
        }

        const currentAddress = this.locationForm.get('addressValue')?.value;
        const currentCity = this.locationForm.get('cityValue')?.value;
        const currentLat = this.locationForm.get('latitudeValue')?.value;
        const currentLng = this.locationForm.get('longitudeValue')?.value;

        const hasCompleteLocationData = currentAddress && currentCity && currentLat && currentLng;

        if (hasCompleteLocationData) {
            if (!this.selectedLocation()) {
                this.selectedLocation.set({
                    lat: parseFloat(currentLat),
                    lng: parseFloat(currentLng)
                });
            }
            return;
        }

        if (this.selectedLocation()) {
            const { lat, lng } = this.selectedLocation()!;

            this.locationForm.patchValue({
                latitudeValue: lat.toFixed(6),
                longitudeValue: lng.toFixed(6)
            });

            const currentState = this.locationForm.get('stateValue')?.value;

            if (!currentAddress || currentAddress.trim() === '' ||
                !currentCity || currentCity.trim() === '' ||
                !currentState || currentState.trim() === '') {
                this.isInitialMapLoad = false;
                this.reverseGeocode(lat, lng);
            }
        }

        this.locationForm.updateValueAndValidity();
        this.cdr.markForCheck();
    }

    protected showCurrentUserCountryInfo(): void {
        const organizationId = this.apiService.getCurrentOrganizationId();

        if (!organizationId) {
            return;
        }

        this.apiService.getOrganization(organizationId).subscribe({
            next: (response: any) => {
                let organization = response;
                if (response && response.data) {
                    organization = response.data;
                }

                if (organization && organization.name) {
                    let countryName = 'N/A';
                    let countryCode = 'N/A';

                    if (organization.address && organization.address.country) {
                        countryName = organization.address.country;
                        countryCode = this.getCountryCodeFromName(countryName);
                    } else if (organization.region_id) {
                        countryName = this.getCountryFromRegionId(organization.region_id);
                        if (countryName && countryName !== 'N/A') {
                            countryCode = this.getCountryCodeFromName(countryName);
                        }
                    }
                }
            },
            error: (error: any) => {
            }
        });
    }

    protected setSearchPlaceholderForCountry(countryName: string): void {
        if (!countryName || countryName === 'N/A') {
            return;
        }

        const placeholderText = `Search for places in ${countryName}...`;

        setTimeout(() => {
            const searchInput = document.querySelector('.search-input') as HTMLInputElement;
            if (searchInput) {
                searchInput.placeholder = placeholderText;
                searchInput.value = '';
                this.searchQuery.set('');
            }
        }, 1000);
    }

    protected reloadMapWithCountry(): void {
        const countryCode = this.organizationCountry();

        this.updateMapCoordinatesForCountry(countryCode);

        if (this.isMapLoaded() && this.map) {
            this.applyMapRestrictions(this.map);
            const countryCoords = this.getCountryCoordinates(countryCode);
            const newCenter = { lat: countryCoords.lat, lng: countryCoords.lng };

            this.map.panTo(newCenter);
            this.map.setZoom(6);

            if (this.marker) {
                this.marker.setPosition(newCenter);
            }

            this.initializeAutocomplete();
        } else if (this.currentStep() === 3) {
            setTimeout(() => {
                this.loadMap();
            }, 500);
        }
    }

    protected applyMapRestrictions(mapInstance: any): Promise<void> {
        return this.countryCoordinatesService.applyCountryMapRestriction(
            mapInstance,
            this.organizationCountry()
        );
    }

    protected preloadCommonCountryCoordinates(): void {
        const commonCountries = ['IN', 'US', 'GB', 'CA', 'AU', 'DE', 'FR', 'JP', 'CN', 'BR', 'MX', 'SG', 'AE', 'SA', 'ZA', 'DJ'];

        this.countryCoordinatesService.preloadCoordinates(commonCountries).then(() => {
        }).catch(() => {
        });
    }

    private async patchParkingTypeData(): Promise<void> {
        const parkingId = this.getExistingParkingId();

        if (!parkingId) {
            await this.createParkingAtStep1();
            return;
        }

        const selectedParkingType = this.parkingTypes[this.selectedCardIndex()]?.title || 'Standalone Parking Lots';

        const parkingName = this.locationForm.get('parkingName')?.value || '';
        const parkingDescription = this.locationForm.get('descriptionValue')?.value || '';
        const timeZone = this.locationForm.get('timeZoneValue')?.value || ((typeof Intl !== 'undefined' && Intl.DateTimeFormat) ? Intl.DateTimeFormat().resolvedOptions().timeZone : 'UTC');

        const step1Data = {
            parkingType: selectedParkingType,
            parking_type: selectedParkingType,
            name: parkingName,
            description: parkingDescription,
            timeZone: timeZone,
            region_id: this.organizationRegionId() || null,
            org_id: this.apiService.getCurrentOrganizationId() || '',
            wizard_step: this.currentStep()
        };

        return new Promise((resolve, reject) => {
            this.apiService.updateParkingWithJson(parkingId, step1Data).subscribe({
                next: () => {
                    this.isEditMode = true;
                    resolve();
                },
                error: (error) => {
                    reject(error);
                }
            });
        });
    }

    private async createParkingAtStep1(): Promise<void> {
        const existingParkingId = this.parkingId || sessionStorage.getItem('parking_id');
        if (existingParkingId) {
            return Promise.resolve();
        }

        const selectedParkingType = this.parkingTypes[this.selectedCardIndex()]?.title || 'Standalone Parking Lots';

        const parkingName = this.locationForm.get('parkingName')?.value || 'New Parking';
        const parkingDescription = this.locationForm.get('descriptionValue')?.value || 'Parking description';

        const slug = parkingName
            .toLowerCase()
            .trim()
            .replace(/[^\w\s-]/g, '')
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-')
            .concat('-', Date.now().toString().slice(-6));

        const payload = {
            org_id: this.apiService.getCurrentOrganizationId(),
            name: parkingName,
            slug: slug,
            description: parkingDescription,
            parkingType: selectedParkingType,
            status: 'inactive',
            wizard_step: this.currentStep()
        };

        return new Promise((resolve, reject) => {
            this.apiService.createParkingWithJson(payload).subscribe({
                next: (response) => {
                    const createdId = (response as any)?.data?.id || (response as any)?.id;
                    if (createdId) {
                        sessionStorage.setItem('parking_id', createdId);
                        localStorage.setItem('parking_id', createdId);
                        this.parkingId = createdId;
                        this.parkingIdForSaveExit.set(createdId);
                        this.isEditMode = true;
                        this.persistWizardStep(this.currentStep(), createdId);
                        resolve();
                    } else {
                        reject(new Error('No parking ID in response'));
                    }
                },
                error: (error) => {
                    reject(error);
                }
            });
        });
    }

    private async patchParkingWithLocationData(): Promise<void> {
        const parkingId = this.getExistingParkingId();
        if (!parkingId) {
            return Promise.reject('No parking ID');
        }

        if (this.hasManualLocationSelection) {
            const currentFormData = {
                addressValue: this.locationForm.get('addressValue')?.value || '',
                cityValue: this.locationForm.get('cityValue')?.value || '',
                stateValue: this.locationForm.get('stateValue')?.value || '',
                postalCodeValue: this.locationForm.get('postalCodeValue')?.value || '',
                countryValue: this.locationForm.get('countryValue')?.value || '',
                latitudeValue: this.locationForm.get('latitudeValue')?.value || '',
                longitudeValue: this.locationForm.get('longitudeValue')?.value || ''
            };
            this.saveMapSelectionToLocalStorage(currentFormData);
        }

        const locationData = {
            name: this.locationForm.get('parkingName')?.value || '',
            description: this.locationForm.get('descriptionValue')?.value || '',
            wizard_step: this.currentStep(),
            location: {
                address_line_1: this.locationForm.get('addressValue')?.value || '',
                address_line_2: this.locationForm.get('addressLine2Value')?.value || '',
                city: this.locationForm.get('cityValue')?.value || '',
                state: this.locationForm.get('stateValue')?.value || '',
                country: this.locationForm.get('countryValue')?.value || 'India',
                lat: this.selectedLocation()?.lat?.toString() || this.locationForm.get('latitudeValue')?.value || '',
                lng: this.selectedLocation()?.lng?.toString() || this.locationForm.get('longitudeValue')?.value || '',
                landmark: '',
                postalCode: this.locationForm.get('postalCodeValue')?.value || ''
            }
        };

        return new Promise((resolve, reject) => {
            this.apiService.updateParkingWithJson(parkingId as string, locationData).subscribe({
                next: () => {
                    resolve();
                },
                error: (error) => {
                    reject(error);
                }
            });
        });
    }

    private async patchParkingWithFormData(): Promise<void> {
        const parkingId = this.getExistingParkingId();
        if (!parkingId) {
            return Promise.reject('No parking ID');
        }

        const formData = {
            name: this.locationForm.get('parkingName')?.value || '',
            description: this.locationForm.get('descriptionValue')?.value || '',
            wizard_step: this.currentStep(),
            location: {
                address_line_1: this.locationForm.get('addressValue')?.value || '',
                address_line_2: this.locationForm.get('addressLine2Value')?.value || '',
                city: this.locationForm.get('cityValue')?.value || '',
                state: this.locationForm.get('stateValue')?.value || '',
                country: this.locationForm.get('countryValue')?.value || 'India',
                lat: this.selectedLocation()?.lat?.toString() || this.locationForm.get('latitudeValue')?.value || '',
                lng: this.selectedLocation()?.lng?.toString() || this.locationForm.get('longitudeValue')?.value || '',
                landmark: '',
                postalCode: this.locationForm.get('postalCodeValue')?.value || ''
            }
        };

        return new Promise((resolve, reject) => {
            this.apiService.updateParkingWithJson(parkingId as string, formData).subscribe({
                next: () => {
                    resolve();
                },
                error: (error) => {
                    reject(error);
                }
            });
        });
    }

    private patchParkingWithDetailsData(): void {
        const parkingId = this.getExistingParkingId();
        if (!parkingId) {
            return;
        }

        const detailsData = {
            name: this.locationForm.get('parkingName')?.value || '',
            description: this.locationForm.get('descriptionValue')?.value || 'Parking description'
        };

        this.apiService.updateParkingPatch(parkingId as string, detailsData).subscribe({
            next: async () => {
                const allFiles = await this.gatherAllFiles();
                if (allFiles.length > 0) {
                    try {
                        await this.apiService.uploadParkingImages(parkingId as string, allFiles).toPromise();
                    } catch (uploadError) {
                    }
                }
            },
            error: () => {
            }
        });
    }

    private async patchParkingWithImages(): Promise<void> {
        const parkingId = this.getExistingParkingId();
        if (!parkingId) {
            return Promise.reject('No parking ID');
        }

        const files = this.fileControl.value || this.currentUploadFiles || [];

        if (!files || files.length === 0) {
            return Promise.resolve();
        }

        this.uploadErrorMessage = '';

        this.isSubmitting.set(true);

        return new Promise((resolve, reject) => {
            this.apiService.uploadParkingImages(parkingId, files).subscribe({
                next: () => {
                    this.uploadErrorMessage = '';
                    this.isSubmitting.set(false);
                    resolve();
                },
                error: (error) => {
                    if (error.status === 413) {
                        const errorMsg = 'Files are too large to upload. Please reduce file size or upload fewer images.';
                        this.uploadErrorMessage = errorMsg;
                        this.notificationService.showError(errorMsg, 5000);
                    } else {
                        const errorMsg = 'Failed to upload images. Please try again.';
                        this.uploadErrorMessage = errorMsg;
                        this.notificationService.showError(errorMsg, 3000);
                    }
                    this.isSubmitting.set(false);
                    reject(error);
                }
            });
        });
    }

    private async patchParkingWithAmenitiesData(): Promise<void> {
        const parkingId = this.getExistingParkingId();
        if (!parkingId) {
            return Promise.reject('No parking ID');
        }

        const amenities = this.getAmenitiesList();
        const amenitiesData = {
            amenities: amenities,
            wizard_step: this.currentStep()
        };

        return new Promise((resolve, reject) => {
            this.apiService.updateParkingWithJson(parkingId as string, amenitiesData).subscribe({
                next: () => {
                    resolve();
                },
                error: (error) => {
                    reject(error);
                }
            });
        });
    }

    private async patchParkingWithOperatingHours(): Promise<void> {
        let parkingId = this.getExistingParkingId();

        if (!parkingId) {
            try {
                await this.createParkingAtStep1();
                parkingId = this.getExistingParkingId();
            } catch (error) {
                return Promise.reject('No parking ID and could not create parking');
            }
        }

        if (!parkingId) {
            return Promise.reject('No parking ID');
        }

        const operatingHours = this.buildOperatingHours();

        const timezoneValue = this.locationForm.get('timeZoneValue')?.value || '';
        const timezoneMatch = timezoneValue.match(/\(([^)]+)\)$/);
        const preferredTimezone = timezoneMatch ? timezoneMatch[1] : (this.organizationTimezone() || 'UTC');

        const preferredCurrency = this.organizationCurrency() || 'USD';

        const regionId = this.organizationRegionId();

        const operatingHoursData = {
            operating_hours: operatingHours,
            preferred_timezone: preferredTimezone,
            preferred_currency: preferredCurrency,
            region_id: regionId || null,
            wizard_step: this.currentStep()
        };

        return new Promise((resolve, reject) => {
            this.apiService.updateParkingWithJson(parkingId as string, operatingHoursData).subscribe({
                next: () => {
                    resolve();
                },
                error: (error) => {
                    reject(error);
                }
            });
        });
    }

    private dataUrlToFile(dataUrl: string, filename: string): File {
        const arr = dataUrl.split(',');
        const mimeMatch = arr[0].match(/:(.*?);/);
        const mime = mimeMatch ? mimeMatch[1] : 'image/jpeg';
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    }

    private getAmenitiesList(): string[] {
        let titles: string[] = (this.selectedFeatures() || [])
            .map(i => this.parkingFeatures[i]?.title)
            .filter(Boolean) as string[];

        if (!titles.length) {
            try {
                const saved = localStorage.getItem('parking_amenities_data');
                if (saved) {
                    const parsed = JSON.parse(saved);
                    const savedSelected: number[] = parsed?.selectedFeatures || [];
                    titles = savedSelected
                        .map((i: number) => this.parkingFeatures[i]?.title)
                        .filter(Boolean);
                }
            } catch { }
        }

        return Array.from(new Set(titles));
    }

    private async urlToFile(url: string, filename: string): Promise<File | null> {
        try {
            const res = await fetch(url);
            const blob = await res.blob();
            return new File([blob], filename, { type: blob.type || 'image/jpeg' });
        } catch {
            return null;
        }
    }

    private getUploadFiles(): File[] {
        const items = this.fileControl.value || this.currentUploadFiles || [];

        const out: File[] = [];
        for (const item of items as any[]) {
            if (!item) {
                continue;
            }
            if (item instanceof File) {
                out.push(item as File);
            } else if (item.file && item.file instanceof File) {
                out.push(item.file as File);
            }
        }
        if (out.length === 0 && this.currentUploadFiles && this.currentUploadFiles.length > 0) {
            return [...this.currentUploadFiles];
        }
        return out;
    }

    private async gatherAllFiles(): Promise<File[]> {
        const out: File[] = [...this.getUploadFiles()];

        if (this.existingImages && this.existingImages.length > 0) {
            for (let i = 0; i < this.existingImages.length; i++) {
                const img = this.existingImages[i];
                try {
                    if (typeof img === 'string') {
                        if (img.startsWith('data:image')) {
                            out.push(this.dataUrlToFile(img, `existing_${i}.jpg`));
                        } else if (img.startsWith('http')) {
                            const f = await this.urlToFile(img, `existing_${i}.jpg`);
                            if (f) out.push(f);
                        }
                    } else if (img && typeof img === 'object' && 'name' in img && 'size' in img && 'type' in img) {
                        out.push(img as File);
                    }
                } catch (error) {
                }
            }
        }

        return out;
    }

    private toTimeString(value: any): string {
        if (typeof value === 'string') return value;
        if (value && typeof value === 'object' && ('hours' in value || 'minutes' in value)) {
            const h = Number(value.hours || 0);
            const m = Number(value.minutes || 0);
            const hh = h.toString().padStart(2, '0');
            const mm = m.toString().padStart(2, '0');
            return `${hh}:${mm}`;
        }
        return '00:00';
    }

    private computeParkingName(): string {
        const raw = (this.locationForm.get('parkingName')?.value || '').toString().trim();
        const address = (this.locationForm.get('addressValue')?.value || '').toString().trim();
        const city = (this.locationForm.get('cityValue')?.value || '').toString().trim();
        const defaultHeadings = [
            "Now, let's give your parking a title",
            'Parking name',
        ];

        const isInvalid = !raw || defaultHeadings.some(h => raw.toLowerCase().includes(h.toLowerCase()));
        if (!isInvalid) {
            return raw;
        }

        if (address) return address;
        if (city && this.parkingTypes[this.selectedCardIndex()]?.title) {
            return `${this.parkingTypes[this.selectedCardIndex()].title} - ${city}`;
        }
        if (this.parkingTypes[this.selectedCardIndex()]?.title) {
            return this.parkingTypes[this.selectedCardIndex()].title;
        }
        return 'Parking';
    }

    protected forceUpdateCountry(): void {
        const organizationId = this.apiService.getCurrentOrganizationId();

        if (organizationId) {
            this.apiService.getOrganization(organizationId).subscribe({
                next: (response: any) => {
                    let organization = response;
                    if (response && response.data) {
                        organization = response.data;
                    }

                    if (organization) {
                        let countryName = 'India';
                        let countryCode = 'IN';

                        if (organization.address && organization.address.country) {
                            countryName = organization.address.country;
                            countryCode = this.getCountryCodeFromName(countryName);
                        } else if (organization.region_id) {
                            countryName = this.getCountryFromRegionId(organization.region_id);
                            if (countryName && countryName !== 'N/A') {
                                countryCode = this.getCountryCodeFromName(countryName);
                            }
                        }

                        this.organizationCountry.set(countryCode);
                        this.selectedCountry.set(countryCode);

                        if (countryCode !== 'IN') {
                            this.locationForm.get('countryValue')?.setValue(countryName);
                            this.setSearchPlaceholderForCountry(countryName);
                        }
                    }
                }
            });
        }
    }

    private formatLocationData(apiData: any): string {
        if (apiData && apiData.address) {
            const addr = apiData.address;
            const parts = [
                addr.address_line_1,
                addr.city,
                addr.state,
                addr.postal_code,
                addr.country
            ].filter(Boolean);
            if (parts.length > 0) {
                return parts.join(', ');
            }
        }

        const parts = [
            apiData?.address_line_1,
            apiData?.city,
            apiData?.state,
            apiData?.pincode,
            apiData?.country
        ].filter(Boolean);

        return parts.length > 0 ? parts.join(', ') : 'Location not specified';
    }

    private formatOperatingHours(operatingHours: any): string {
        if (!operatingHours) return 'All Day, 24 Hours';

        const { open_days, open_time, close_time } = operatingHours;
        const is24Hours = open_time === '00:00' && close_time === '23:59';
        const allDays = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
        const isAllDays = open_days && open_days.length === 7 && allDays.every(day => open_days.includes(day));
        if (isAllDays && is24Hours) {
            return 'All day • 24 Hours';
        }
        const daysString = this.formatDays(open_days);
        const timeString = `${open_time} - ${close_time}`;
        return `${daysString} • ${timeString}`;
    }

    private formatDays(openDays: string[]): string {
        if (!openDays || openDays.length === 0) return 'No days specified';
        const dayMap: { [key: string]: string } = {
            'mon': 'Mon',
            'tue': 'Tue',
            'wed': 'Wed',
            'thu': 'Thu',
            'fri': 'Fri',
            'sat': 'Sat',
            'sun': 'Sun'
        };
        const formattedDays = openDays.map(day => dayMap[day] || day);
        if (formattedDays.length === 7) return 'All days';
        if (formattedDays.length === 1) return formattedDays[0];
        return formattedDays.join(', ');
    }

    private formatFacilitiesAndVehicles(facilities: any[]): { facilitiesString: string; vehicleTypesString: string; totalCapacity: number } {
        if (!facilities || !Array.isArray(facilities)) {
            return {
                facilitiesString: 'No facilities specified',
                vehicleTypesString: 'No vehicle types specified',
                totalCapacity: 0
            };
        }

        const vehicleFacilities = facilities.filter(f => f.service_type === 'vehicle');
        const facilityTypes = facilities.filter(f => f.service_type === 'facility');

        const vehicleTypesString = vehicleFacilities.length > 0
            ? vehicleFacilities.map(f => `${f.name || 'Unknown'} (${f.capacity || 0})`).join(', ')
            : 'No vehicle types specified';

        const facilitiesString = facilityTypes.length > 0
            ? facilityTypes.map(f => f.name || 'Unknown').join(', ')
            : 'No facilities specified';

        const totalCapacity = facilities.reduce((total: number, facility: any) => total + (facility.capacity || 0), 0);

        return { facilitiesString, vehicleTypesString, totalCapacity };
    }

    private getAdminNameAsFallback(): string {
        const currentUser = this.apiService.getCurrentUser();
        if (currentUser) {
            if (currentUser.firstName && currentUser.lastName) {
                return `${currentUser.firstName} ${currentUser.lastName} (Admin)`;
            } else if (currentUser.firstName) {
                return `${currentUser.firstName} (Admin)`;
            } else if (currentUser.email) {
                return `${currentUser.email} (Admin)`;
            }
        }
        return 'Admin (Current User)';
    }

    private formatManagerFromApi(managedBy: any): string {
        const currentUser = this.apiService.getCurrentUser();
        if (!managedBy) {
            if (currentUser) {
                const adminName = this.getUserDisplayName(currentUser);
                return adminName ? `${adminName} (Admin)` : 'Admin (Current User)';
            }
            return 'No manager assigned';
        }

        if (currentUser && this.getUserId(managedBy) === this.getUserId(currentUser)) {
            const adminName = this.getUserDisplayName(currentUser);
            return adminName ? `${adminName} (Admin)` : 'Admin (Current User)';
        }

        const managerName = this.getUserDisplayName(managedBy);
        return managerName || 'Manager assigned';
    }

    private processPendingTeamInviteAndAssignManager(parkingId: string) {
        const pendingRaw = localStorage.getItem('parking_pending_team_invite');
        const selectedManagerId = this.getUserId(this.selectedTeamMember);
        const invitedManagerId = localStorage.getItem('parking_invited_manager_id');

        const assignManager = (managerId: string) => {
            if (!managerId) {
                return of(undefined);
            }
            return this.apiService.updateParkingManager({ parkingId, managerId }).pipe(
                map(() => undefined),
                catchError(() => of(undefined))
            );
        };

        if (!pendingRaw) {
            return assignManager(selectedManagerId || invitedManagerId || '');
        }

        let pending: any;
        try {
            pending = JSON.parse(pendingRaw);
        } catch {
            localStorage.removeItem('parking_pending_team_invite');
            return assignManager(selectedManagerId || invitedManagerId || '');
        }

        if (pending.parkingId && pending.parkingId !== parkingId) {
            return assignManager(selectedManagerId || invitedManagerId || '');
        }

        const payload = pending.payload;
        if (!payload) {
            localStorage.removeItem('parking_pending_team_invite');
            return assignManager(selectedManagerId || invitedManagerId || '');
        }

        return this.apiService.inviteTeamMember(payload).pipe(
            switchMap((response: any) => {
                const managerId =
                    (typeof response?.data === 'string' ? response.data : '') ||
                    response?.data?.id ||
                    response?.data?.user_id ||
                    pending.display?.userId ||
                    selectedManagerId ||
                    invitedManagerId ||
                    '';
                localStorage.removeItem('parking_pending_team_invite');
                return assignManager(managerId);
            }),
            catchError(() => {
                const fallbackId = pending.display?.userId || selectedManagerId || invitedManagerId || '';
                localStorage.removeItem('parking_pending_team_invite');
                return assignManager(fallbackId);
            })
        );
    }

    protected async goLiveWithParking(): Promise<void> {
        let parkingId = this.parkingId ||
            this.getExistingParkingId() ||
            this.apiService.getCurrentParkingId() ||
            sessionStorage.getItem('parking_id') ||
            localStorage.getItem('parking_id') ||
            sessionStorage.getItem('parkingId') ||
            localStorage.getItem('parkingId') ||
            this.parkingIdForSaveExit();

        if (!parkingId) {
            try {
                await this.createParkingAtStep1();
                parkingId = this.parkingId ||
                    this.getExistingParkingId() ||
                    this.apiService.getCurrentParkingId() ||
                    sessionStorage.getItem('parking_id') ||
                    localStorage.getItem('parking_id');
            } catch (e) {
                console.error('Failed to create parking before Go Live:', e);
            }
        }

        if (!parkingId) {
            this.notificationService.showError('Error: No parking ID found. Please try again.', 3000);
            return;
        }

        const orgId = this.apiService.getCurrentOrganizationId();
        if (!orgId) {
            this.notificationService.showError('Error: No organization ID found. Please try again.', 3000);
            return;
        }

        this.isActivating.set(true);

        this.apiService.activateParkingActive({ parkingId, org_id: orgId }).pipe(
            catchError((error) => {
                const message = String(
                    error?.error?.message || error?.message || ''
                ).toLowerCase();

                if (message.includes('already active')) {
                    return of(null);
                }

                return throwError(() => error);
            }),
            switchMap(() => this.apiService.ensureDefaultHelmetLockerFacility(parkingId, orgId).pipe(catchError(() => of(null)))),
            switchMap(() => this.processPendingTeamInviteAndAssignManager(parkingId))
        ).subscribe({
            next: () => {
                this.isActivating.set(false);
                this.parkingDataService.clearAllFormData();
                this.clearPersistedWizardStep(parkingId);
                localStorage.removeItem('parking_invited_manager_id');
                localStorage.removeItem('parking_pending_team_invite');
                localStorage.removeItem('parking_team_member_data');
                this.notificationService.showSuccess('Your parking is now live! All setup data has been cleared.', 5000);

                setTimeout(() => {
                    this.router.navigate(['/organization', orgId, 'parking-lots'], { replaceUrl: true });
                }, 1500);
            },
            error: (error) => {
                this.isActivating.set(false);
                const message = error?.error?.message || error?.message || 'Failed to activate parking. Please try again.';
                this.notificationService.showError(message, 4000);
            }
        });
    }

    private readonly previewService = inject(TuiPreviewDialogService);

    @ViewChild('preview')
    protected readonly preview?: TemplateRef<TuiDialogContext>;

    @ViewChild('contentSample')
    protected readonly contentSample?: TemplateRef<Record<string, unknown>>;

    @ViewChild('uploadDialog')
    protected readonly uploadDialog?: TemplateRef<TuiDialogContext>;

    protected previewIndex = 0;
    protected length = 2;
    protected titles = ['Transaction cert.jpg', 'My face.jpg'];

    protected get previewContent(): PolymorpheusContent {
        return this.previewIndex === 0 && this.contentSample
            ? this.contentSample
            : 'https://avatars.githubusercontent.com/u/10106368';
    }

    protected show(): void {
        this.previewService.open(this.preview || '').subscribe({
            complete: () => { },
        });
    }

    protected download(): void {
        this.notificationService.showInfo('Downloading...', 2000);
    }

    protected delete(): void {
        this.notificationService.showInfo('Deleting...', 2000);
    }

    protected openUploadDialog(): void {
        this.dialogs.open(this.uploadDialog || '', {
            size: 's',
            closeable: true,
        }).subscribe({
            complete: () => {
            },
        });
    }

    protected openFilePreview(fileIndex: number): void {
        const files = this.fileControl.value || [];
        if (files.length === 0 || fileIndex >= files.length) {
            return;
        }

        this.previewIndex = fileIndex;
        this.previewService.open(this.preview || '').subscribe({
            complete: () => {
            },
        });
    }

    protected openExistingImagePreview(imageIndex: number): void {
        if (this.existingImages.length === 0 || imageIndex >= this.existingImages.length) {
            return;
        }

        const imageUrl = this.existingImages[imageIndex];

        this.previewService.open(imageUrl).subscribe({
            complete: () => {
            },
        });
    }

    protected getCurrentFileName(): string {
        const files = this.fileControl.value || [];
        if (files[this.previewIndex]) {
            return files[this.previewIndex].name;
        }
        return 'Unknown file';
    }

    protected getCurrentFileUrl(): string {
        const files = this.fileControl.value || [];
        if (files[this.previewIndex]) {
            return this.getFileUrl(files[this.previewIndex]);
        }
        return '';
    }

    protected getUploadedFilesLength(): number {
        return (this.fileControl.value || []).length;
    }

    protected deleteCurrentFile(): void {
        const files = this.fileControl.value || [];
        if (files[this.previewIndex]) {
            this.onRemove(files[this.previewIndex]);
            this.notificationService.showSuccess('File deleted', 2000);
        }
    }

    protected downloadCurrentFile(): void {
        const files = this.fileControl.value || [];
        if (files[this.previewIndex]) {
            const file = files[this.previewIndex];
            const url = this.getFileUrl(file);
            const link = document.createElement('a');
            link.href = url;
            link.download = file.name;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.notificationService.showInfo('Downloading...', 2000);
        }
    }

    protected isImageFile(file: File): boolean {
        return file.type.startsWith('image/');
    }

    protected getFileUrl(file: File): string {
        if (this.fileUrlCache.has(file)) {
            return this.fileUrlCache.get(file)!;
        }

        const url = URL.createObjectURL(file);
        this.fileUrlCache.set(file, url);
        return url;
    }

    private cleanupFileUrl(file: File): void {
        const url = this.fileUrlCache.get(file);
        if (url) {
            URL.revokeObjectURL(url);
            this.fileUrlCache.delete(file);
        }
    }

    private cleanupAllFileUrls(): void {
        this.fileUrlCache.forEach((url) => {
            URL.revokeObjectURL(url);
        });
        this.fileUrlCache.clear();
    }

    protected formatFileSize(bytes: number): string {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    }

    protected onSwipe(swipe: TuiSwipeEvent): void {
        const files = this.fileControl.value || [];
        const maxIndex = files.length - 1;

        if (swipe.direction === 'left') {
            this.previewIndex = tuiClamp(this.previewIndex + 1, 0, maxIndex);
        }

        if (swipe.direction === 'right') {
            this.previewIndex = tuiClamp(this.previewIndex - 1, 0, maxIndex);
        }
    }

    private updateCarouselItems(): void {
        const items: any[] = [];

        if (this.existingImages && this.existingImages.length > 0) {
            this.existingImages.forEach((src, index) => {
                items.push({
                    src: src,
                    title: `Existing Image ${index + 1}`,
                    description: ''
                });
            });
        }

        if (this.currentUploadFiles && this.currentUploadFiles.length > 0) {
            this.currentUploadFiles.forEach((file, index) => {
                const url = this.getFileUrl(file);
                items.push({
                    src: url,
                    title: `New Image ${index + 1}`,
                    description: ''
                });
            });
        }

        if (items.length === 0) {
            items.push({
                src: this.blankMockImage,
                title: 'No Image Available',
                description: ''
            });
        }

        this.carouselItems = items;
        this.cdr.markForCheck();
    }

    ngOnDestroy(): void {
        this.cleanupAllFileUrls();
    }

    protected onlyNumbers(event: KeyboardEvent): void {
        const charCode = event.which ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            event.preventDefault();
        }
    }

    protected onOnlyNumbersInput(event: any, controlName: string = 'postalCodeValue'): void {
        const input = event.target as HTMLInputElement;
        const cleanValue = input.value.replace(/[^0-9]/g, '');
        input.value = cleanValue;
        if (controlName && this.locationForm.get(controlName)) {
            this.locationForm.get(controlName)?.setValue(cleanValue, { emitEvent: false });
        }
    }
}